import type { Dict } from '../types';

export const ja: Dict = {
  'chat.amrCard.switchTitle': 'モデル呼び出しに失敗しました — このタスクは一時停止中です',
  'chat.amrCard.switchBody': 'Open Design 公式の AMR モデルサービスに切り替えてください — API キーの設定は不要です。サインイン・認可・チャージが完了すると、このタスクは自動で再試行されます。',
  'chat.amrCard.chipOfficial': '公式ホスティング',
  'chat.amrCard.chipNoKey': 'API キー不要',
  'chat.amrCard.chipAutoRetry': 'サインイン後に自動再試行',
  'chat.amrCard.switchCta': 'AMR に切り替えて再試行',
  'chat.amrError.authMessage': 'AMR アカウントがまだ認可されていません。認可するとこのタスクは自動で再試行されます。',
  'chat.amrError.balanceMessage': 'AMR の残高が不足しています。チャージしてこのタスクを続行してください。',
  'chat.amrError.authorizeCta': '認可して再試行',
  'chat.amrError.rechargeCta': 'AMR にチャージ',
  'chat.antigravityError.launchTerminalCta': 'ターミナルでサインイン',
  'chat.antigravityError.launchSwitchModelCta': 'ターミナルでモデルを切り替え',
  'chat.connectionDropped': '応答が完了する前にモデルサービスへの接続が切断されました。多くはネットワークやプロキシの不安定が原因です。再試行してください。',
  'common.cancel': 'キャンセル',
  'common.save': '保存',
  'common.close': '閉じる',
  'common.clear': 'クリア',
  'common.delete': '削除',
  'common.rename': '名前を変更',
  'common.edit': '編集',
  'common.preview': 'プレビュー',
  'common.share': '共有',
  'common.search': '検索',
  'common.searchEllipsis': '検索…',
  'common.loading': '読み込み中…',
  'common.all': 'すべて',
  'common.none': 'なし',
  'common.default': 'デフォルト',
  'common.installed': 'インストール済み',
  'common.notInstalled': '未インストール',
  'common.active': 'アクティブ',
  'common.offline': 'オフライン',
  'common.selected': '選択中',
  'common.create': '作成',
  'common.openPreview': 'プレビューを開く',
  'common.exitFullscreen': 'フルスクリーンを終了',
  'common.fullscreen': 'フルスクリーン',
  'common.openInNewTab': '新しいタブで開く',
  'common.exportPdf': 'PDFとしてエクスポート',
  'common.exportZip': '.zipとしてダウンロード',
  'common.exportHtml': 'スタンドアロンHTMLとしてエクスポート',
  'common.exportImage': '画像としてエクスポート',
  'common.exportImageFailed': '画像のキャプチャに失敗しました。再試行するか、ブラウザのスクリーンショットツールを使用してください。',
  'common.justNow': 'たった今',
  'common.minutesAgo': '{n}分前',
  'common.hoursAgo': '{n}時間前',
  'common.daysAgo': '{n}日前',
  'common.weeksAgo': '{n}週間前',
  'common.now': '今',
  'common.minutesShort': '{n}分',
  'common.hoursShort': '{n}時間',
  'common.daysShort': '{n}日',
  'common.untitled': '無題',
  'plugins.availableDetails.provenance': '来歴',
  'plugins.availableDetails.provenanceLine': '{source} より · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': '{source} より · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'インストール',
  'plugins.availableDetails.version': 'バージョン',
  'plugins.availableDetails.pluginVersion': 'プラグインのバージョン',
  'plugins.availableDetails.copyInstallCommand': 'インストールコマンドをコピー',
  'plugins.availableDetails.copied': 'コピーしました',
  'plugins.availableDetails.deprecatedPrefix': '非推奨: {message}',
  'plugins.availableDetails.deprecatedFallback': 'このバージョンは非推奨に指定されています。',
  'plugins.availableDetails.yanked': '取り下げ済み。',
  'plugins.availableDetails.yankedWithReason': '取り下げ済み: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': '（非推奨）',
  'plugins.availableDetails.versionYankedSuffix': '（取り下げ済み）',
  'plugins.availableDetails.ref': '参照',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': '権限',
  'plugins.availableDetails.capabilitySummary': '機能の概要',
  'plugins.actions.copyInstallCommand': 'インストールコマンドをコピー',
  'plugins.actions.copyPluginId': 'プラグイン ID をコピー',
  'plugins.actions.copyReadmeBadge': 'README バッジをコピー',
  'plugins.actions.openSourceGithub': 'GitHub でソースを開く',
  'plugins.actions.openSource': 'ソースを開く',
  'plugins.actions.openHomepage': 'ホームページを開く',
  'plugins.actions.openMarketplace': 'マーケットプレイスで開く',
  'app.brand': 'Open Design',
  'app.brandPill': 'リサーチプレビュー',
  'app.brandSubtitle': 'by Nexu Labs',
  'app.welcomeLoading': 'ワークスペースを読み込み中…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'ようこそ',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': '概要から始める',
  'settings.onboardingCreateBody': '作成したいサイト、アプリ、スライド、画像、動画を記述してください。Open Design がプロジェクトを作成し、編集可能な状態で作業を保持します。',
  'settings.onboardingMemoryTitle': '作業コンテキストを保存',
  'settings.onboardingMemoryBody': '設定、プロジェクトの情報、繰り返し使うルールを追加すると、今後のチャットで適切なコンテキストが引き継がれます。',
  'settings.onboardingSystemsTitle': 'デザインシステムを取り込む',
  'settings.onboardingSystemsBody': 'ブランドシステムを選択または作成すると、生成される成果物が実際の色、タイポグラフィ、プロダクトの言語表現に従います。',
  'settings.onboardingExecutionTitle': '生成の実行方法を選択',
  'settings.onboardingExecutionBody': 'ワンクリックでセットアップでき、すぐに使えるデフォルト設定を備えた公式 CLI。1 つのキーで、より優れた価格設定の多数のモデルから選択できます。',
  'settings.onboardingAmrCloudBenefitOfficial': '公式おすすめ',
  'settings.onboardingAmrCloudBenefitReady': 'デプロイ不要',
  'settings.onboardingAmrCloudBenefitModels': 'Claude Opus 4.8 に対応',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA ハーネス',
  'settings.onboardingAmrCloudUpcomingLabel': '近日対応',
  'settings.onboardingAmrCloudUpcomingImageVideo': '画像/動画生成',
  'settings.onboardingAmrCloudUpcomingSkills': '豊富な Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'スマートルーティング',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'AMR を認証',
  'settings.onboardingAmrCloudAuthorizedAction': '認証済み',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': '最新情報を受け取る',
  'settings.onboardingNewsletterTitle': '最新情報をお届け',
  'settings.onboardingNewsletterBody': '製品アップデート、新しいテンプレート、デザインシステム、アンバサダーの活動をメールでお届けします。任意 — スキップできます。',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Open Design にサインイン',
  'settings.onboardingCloudBody': 'サインインすれば、クラウド AI ですぐにデザインを始められます。複雑な設定は一切不要です。',
  'settings.onboardingCloudSignIn': 'Open Design Cloud にサインイン',
  'settings.onboardingCloudContinue': '続行（ログイン済み）',
  'settings.onboardingCloudAlternative': 'ローカル CLI または自分の API キーを使う',
  'settings.onboardingCloudRights': 'All rights reserved.',
  'settings.onboardingCloudOr': 'または',
  'settings.onboardingGateTooltipNoRuntime': 'この先のステップは AI で実行されます。続けるには実行方法を選んでください。',
  'settings.onboardingGateTooltipAmr': 'この先のステップは AI で実行されます。続けるには Open Design AMR にサインインしてください。',
  'settings.onboardingGateTooltipLocal': 'この先のステップは AI で実行されます。続けるには利用可能なローカル CLI を選んでください。',
  'settings.onboardingGateTooltipByok': 'この先のステップは AI で実行されます。続けるにはモデルキーを追加してテストしてください。',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': '公式',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleAgency': '📣 マーケティング代理店',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': '設定',
  'settings.title': '実行モード',
  'settings.subtitle': 'ローカル CLI と BYOK のどちらを使うか選択します。',
  'settings.modeAria': '実行モード',
  'settings.protocolAria': 'API プロトコル',
  'settings.modeDaemon': 'ローカル CLI',
  'settings.modeDaemonHelp': 'マシン上のコードエージェント CLI 経由で実行',
  'settings.modeDaemonOffline': 'デーモンが起動していません',
  'settings.modeDaemonOfflineMeta': 'デーモンオフライン',
  'settings.modeDaemonInstalledMeta': '{count} インストール済み',
  'settings.modeApi': 'API プロバイダー',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK ではプロジェクトファイルの読み取り、書き込み、編集はできません。コードを変更する場合は Local CLI を使用してください。',
  'settings.codeAgent': 'コードエージェント',
  'settings.codeAgentHint': 'PATH をスキャンして検出されます。生成に使用する CLI を選択してください。',
  'settings.rescan': '↻ 再スキャン',
  'settings.rescanTitle': 'PATH を再スキャン',
  'settings.rescanRunning': 'スキャン中...',
  'settings.rescanSuccess': 'スキャン完了。{count} 件が利用可能です。',
  'settings.designSystemRenameFailed': '名前の変更に失敗しました。デーモンを確認して再試行してください。',
  'settings.rescanFailed': 'スキャンに失敗しました。デーモンを確認して再試行してください。',
  'settings.test': 'テスト',
  'settings.testTitle': '接続を確認するため、ごく短いテストプロンプトを送信します',
  'settings.testRunning': '接続をテスト中…',
  'settings.byokReadyToTest': 'テスト準備完了',
  'settings.testCancel': 'キャンセル',
  'settings.testRetry': 'テストを再試行',
  'settings.required': '必須',
  'settings.testMissingFields': '接続をテストするには {fields} を入力してください。',
  'settings.testSuccessApi': '接続成功。{ms} ms で応答 — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} が {ms} ms で応答 — \'{sample}\'',
  'settings.testAuthFailed': '認証に失敗しました。API キーを確認してください。',
  'settings.testForbidden': 'アクセスが拒否されました。アカウント、リージョン、組織を確認してください。',
  'settings.testNotFoundModel': 'このエンドポイントにモデル \'{model}\' は見つかりません。',
  'settings.testInvalidModelId': 'モデル ID \'{model}\' は無効です。カスタム ID は英数字で始まり、空白を含めないでください。',
  'settings.testInvalidBaseUrl': 'Base URL が無効か到達できません。',
  'settings.testRateLimited': 'プロバイダがテストをレート制限しました。設定は有効に見えます。',
  'settings.testUpstream': 'プロバイダが {status} を返しました。少し時間をおいて再試行してください。',
  'settings.testTimeout': '{ms} ms 後にテストがタイムアウトしました。',
  'settings.testAgentMissing': '{agentName} がインストールされていないか、PATH にありません。',
  'settings.testAgentSpawn': '{agentName} を起動できませんでした: {detail}。',
  'settings.testUnknown': 'テストに失敗しました: {detail}',
  'settings.agentInstall.install': 'インストール',
  'settings.agentInstall.docs': 'ドキュメント',
  'settings.agentInstall.pathHint': 'npm または Homebrew で CLI をインストールしたのに未インストールのまま表示される場合は、Open Design daemon が引き継ぐ PATH にツールの bin ディレクトリが含まれていることを確認してください（macOS では Terminal と GUI アプリで PATH が異なる場合があります）。QUICKSTART.md（"Local agent CLI and PATH" セクション）を参照してください。',
  'settings.agentInstall.stepOpenLinks': '利用したいエージェントの「インストール」または「ドキュメント」を開きます。',
  'settings.agentInstall.stepAuth': 'Open Design に戻る前に、ベンダー CLI で認証（サインインまたは API 資格情報の追加）を行います。',
  'settings.agentInstall.stepRescan': 'このセクションで「再スキャン」をクリックします。',
  'settings.agentInstall.stepSelect': 'インストール済みとして表示されたらエージェントカードを選択します。',
  'settings.noAgentsDetected': 'エージェントが検出されませんでした。Claude Code、Codex、Gemini CLI、OpenCode、Cursor Agent、Qwen、または GitHub Copilot CLI のいずれかをインストールして、再スキャンをクリックしてください。',
  'settings.agentInstalledGroup': 'あなたの CLI（{count}）',
  'settings.agentInstallGroup': 'インストール可能（{count}）',
  'settings.agentAuthRequired': '認証が必要です',
  'settings.agentAuthUnknown': '認証状態は不明です',
  'settings.amrCloud': 'Open Design AMR',
  'settings.amrAuthorize': '認証',
  'settings.amrBenefitOfficial': '公式',
  'settings.amrBenefitLowerPrice': '低コスト',
  'settings.amrBenefitManyModels': '多数のモデル',
  'settings.amrPromoBonus': '期間限定ボーナス: +100%',
  'settings.amrSignInToContinue': '続行するにはサインインしてください',
  'settings.amrSignIn': 'サインイン',
  'settings.amrSignedIn': 'サインイン済み',
  'settings.amrNotSignedIn': 'サインインしていません',
  'settings.amrSigningIn': 'サインイン中…',
  'settings.amrActivationHint': 'ブラウザを開いています…開かない場合は、下のリンクからサインインを完了してください。',
  'settings.amrActivationBrowserFailed': 'ブラウザを自動で開けませんでした。下のサインインページを開いて続行してください。',
  'settings.amrActivationOpen': 'サインインページを開く',
  'settings.amrActivationCopyCode': '認証コードをコピー',
  'settings.amrActivationCopy': 'コピー',
  'settings.amrActivationCopied': 'コピーしました',
  'settings.amrCancelSignIn': 'サインインをキャンセル',
  'settings.amrAccountStatus': 'AMR アカウントの状態',
  'settings.amrConsole': 'AMR コンソール',
  'settings.amrLoginErrorCompact': 'AMR へのサインインに失敗しました。',
  'settings.advanced': '詳細設定',
  'settings.amrLogin': 'サインイン',
  'settings.amrLogout': 'サインアウト',
  'settings.amrLoggingIn': 'サインイン中…',
  'settings.amrLoggingOut': 'サインアウト中…',
  'settings.amrLoggedInAs': '{email} でサインイン中',
  'settings.amrLoggedInWithPlan': '{email} としてサインイン中 · {plan}',
  'settings.amrLoggedInPill': 'サインイン済み',
  'settings.amrNotLoggedIn': 'サインインしていません',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'プロバイダーをクイック入力',
  'settings.providerPreset': 'ゲートウェイプリセット',
  'settings.protocolGroupProtocols': 'プロトコル',
  'settings.protocolGroupGateways': 'ゲートウェイ',
  'settings.customProvider': 'カスタムプロバイダー',
  'settings.apiKey': 'APIキー',
  'settings.apiKeyGetLink': 'キーを取得 ↗',
  'settings.showKey': 'キーを表示',
  'settings.hideKey': 'キーを隠す',
  'settings.show': '表示',
  'settings.hide': '隠す',
  'settings.model': 'モデル',
  'settings.apiKeyInvalid': 'API key が無効です。',
  'settings.apiKeyCleaned': 'API key から余分な空白を削除しました。',
  'settings.modelsLoadedFromAccount': '✓ アカウントから {count} 個のモデルを読み込みました。',
  'settings.modelsLoadedCount': '✓ {count} 個のモデルを読み込みました。',
  'settings.modelSourceAccount': 'アカウントから',
  'settings.modelSourceSuggested': 'おすすめ',
  'settings.fetchModels': 'モデルを取得',
  'settings.fetchModelsTitle': 'このプロバイダーから利用可能なモデルを取得',
  'settings.fetchModelsRunning': 'モデルを取得中…',
  'settings.fetchModelsMissingFields': 'モデルを取得するには {fields} を入力してください。',
  'settings.fetchModelsInvalidBaseUrl': 'モデルを取得するには有効な Base URL を入力してください。',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI はデプロイ名を使用するため、ここではモデルの検出を利用できません。',
  'settings.fetchModelsUnsupportedOllama': 'Ollama Cloud のモデル検出はまだ利用できません。モデルを選択するか入力してください。',
  'settings.fetchModelsSuccess': '{count} 件のモデルを取得しました。',
  'settings.fetchModelsEmpty': '互換性のあるテキストモデルが返されませんでした。',
  'settings.fetchModelsUnsupported': 'このプロトコルではモデルの検出を利用できません。',
  'settings.fetchModelsFailed': 'モデルを取得できませんでした: {detail}',
  'settings.suggestedModelsHint': 'これはこのプロトコル向けの推奨モデルです。プロバイダーによっては別のモデルをサポートしている場合があります。',
  'settings.baseUrl': 'ベース URL',
  'settings.baseUrlInvalid': '公開 http:// または https:// URL を使用してください。',
  'settings.baseUrlCustomize': 'カスタマイズ',
  'settings.baseUrlDefaultHint': 'デフォルトのエンドポイントです。通常は変更不要です。',
  'settings.azureBaseUrlPlaceholder': 'Azure エンドポイント URL を貼り付け',
  'settings.azureBaseUrlHint': 'Azure ポータル → 対象リソース → エンドポイント で確認できます。',
  'settings.azureDeploymentModel': 'デプロイ名',
  'settings.azureCustomDeploymentName': 'カスタムデプロイ名',
  'settings.azureDeploymentModelHint': 'Azure OpenAI では、このフィールドが /openai/deployments/<model> のデプロイ名として使われます。Azure で作成したデプロイ名を入力してください。',
  'settings.azureModelFetchHint': 'Azure リソースのデプロイ名を入力してください。Azure のデプロイは自動取得できません。',
  'settings.apiVersion': 'API バージョン',
  'settings.byokImageModel': '画像生成モデル',
  'settings.byokVideoModel': '動画生成モデル',
  'settings.byokVideoI2vHint': '画像から動画モデル:参照画像が必要です(指定しない場合はプロジェクト内の最新画像を自動使用)',
  'settings.byokSpeechModel': '音声生成モデル',
  'settings.byokSpeechVoice': '音声(ボイス)',
  'settings.byokModelDefaultOption': 'デフォルト',
  'settings.maxTokens': '最大トークン（任意）',
  'settings.maxTokensHint': '応答長の上限。各モデルにチューニング済みのデフォルト値があります（プレースホルダーに表示）。空のままにすればそれを使用し、数値を入力すれば上書きされます。',
  'settings.apiHint': 'リクエストはローカル daemon プロキシ経由で設定した Base URL に送信されます。キーはこのブラウザ内にのみ保存され、プロバイダーへのリクエスト時に送信されます。',
  'settings.skipForNow': '今はスキップ',
  'settings.getStarted': '始める',
  'settings.envConfigure': '実行モード',
  'settings.localCli': 'ローカル CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'エージェント未選択',
  'settings.language': '言語',
  'settings.languageHint': 'インターフェースの言語を切り替えます。このブラウザに保存されます。',
  'settings.appearance': '外観',
  'settings.appearanceHint': 'ライト、ダーク、またはシステム設定に従う。',
  'settings.themeSystem': 'システム',
  'settings.themeLight': 'ライト',
  'settings.themeDark': 'ダーク',
  'settings.agentModelHead': 'モデル：',
  'settings.modelPicker': 'モデル',
  'settings.modelSourceLive': 'CLI から取得',
  'settings.modelSourceFallback': '組み込みリスト',
  'settings.reasoningPicker': '推論の強さ',
  'settings.modelPickerHint': 'CLI が `models` コマンドを公開している場合に取得されます。「デフォルト」は CLI 自身の設定に委ね、「カスタム…」は CLI が受け付ける任意のモデル ID を入力できます。',
  'settings.modelPickerLiveHint': 'インストール済みの CLI からモデルを更新しました。デフォルトは引き続き CLI 設定を使用します。',
  'settings.modelPickerLiveCatalogOnlyHint': 'インストール済みの CLI からモデルを更新しました。',
  'settings.modelPickerFallbackHint': '組み込みのデフォルトを表示しています。再スキャンをクリックすると CLI から最新モデルを取得します。',
  'settings.cliEnvTitle': '詳細設定: プロキシとカスタムパス',
  'settings.cliEnvHint': '選択した CLI の環境を上書きするために使用します: API key、プロキシ base URL、カスタム home、標準以外の実行ファイルパス。base URL を設定しない場合、CLI は既定の endpoint を使用します。シークレットはローカルのアプリ設定内に保持され、選択した CLI のみが参照します。',
  'settings.cliEnvClaudeConfigDir': 'Claude Code 設定ディレクトリ',
  'settings.cliEnvClaudeBaseUrl': 'Claude プロキシの Base URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API key',
  'settings.cliEnvCodexHome': 'Codex ホーム',
  'settings.cliEnvCodexBin': 'Codex 実行ファイルのパス',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI プロキシの Base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API key',
  'settings.modelCustom': 'カスタム（下に入力）…',
  'settings.modelCustomLabel': 'カスタムモデル ID',
  'settings.modelCustomPlaceholder': '例: anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'メディアプロバイダー',
  'settings.mediaProvidersHint': '画像・動画・音声生成のための API キー。ローカルに保存され、ローカルデーモンに同期されます。',
  'settings.mcpServerTitle': 'MCP サーバー',
  'settings.mcpServerHint': 'Open Design を MCP サーバーとしてコーディングエージェントに公開します。',
  'settings.externalMcpTitle': '外部 MCP',
  'settings.externalMcpHint': '外部サービス（Higgsfield、GitHub など）の MCP ツールを追加します。',
  'settings.mediaProviderApiKey': 'APIキー',
  'settings.mediaProviderBaseUrl': 'ベース URL',
  'settings.mediaProviderConfigured': '設定済み',
  'settings.mediaProviderUnset': '未設定',
  'settings.mediaProviderClear': 'クリア',
  'settings.mediaProviderClearConfirm': '保存された {name} の設定を削除しますか？{name} を使うには再度入力する必要があります。',
  'settings.mediaProviderPlaceholder': 'APIキーを貼り付け',
  'settings.mediaProviderBaseUrlPlaceholder': 'デフォルトのベース URL を上書き',
  'settings.mediaProviderReload': 'デーモンから再読み込み',
  'settings.mediaProviderReloadError': 'ローカルデーモンからメディアプロバイダー設定を再読み込みできませんでした。',
  'settings.mediaProviderReloadSuccess': 'ローカルデーモンからメディアプロバイダー設定を再読み込みしました。',
  'settings.mediaProviderLoadError': 'ローカルデーモンからメディアプロバイダー設定を読み込めませんでした。今のところブラウザーに保存された設定を使用します。',
  'settings.mediaProviderComingSoonHint': 'これらはロードマップで追跡しています。デーモンはまだクライアントを提供していないため、設定するものはありません。',
  'settings.privacy': 'プライバシー',
  'settings.privacyHint': 'Open Design チームと共有されるデータ',
  'settings.privacyConsentKicker': 'Open Design の改善にご協力ください',
  'settings.privacyConsentLead': 'Open Design は、改善のために使用状況データをチームと共有できます。これには次の内容が含まれます:',
  'settings.privacyConsentFooter': 'これらはいつでも 設定 → プライバシー で変更できます。',
  'settings.privacyConsentShare': '使用状況データを共有',
  'settings.privacyConsentDecline': '共有しない',
  'settings.privacyConsentAccept': '了解しました',
  'settings.privacyConsentBannerFooter': 'データ共有はデフォルトで有効です。いつでも 設定 → プライバシー で無効にできます。',
  'settings.privacyConsentPolicyLink': 'プライバシーポリシーを読む',
  'settings.privacyMetrics': '匿名メトリクス',
  'settings.privacyMetricsHint': '実行回数、Token使用量、エラー率、所要時間。プロンプトやプロジェクトデータは含みません。',
  'settings.privacyContent': '会話とツールのコンテンツ',
  'settings.privacyContentHint': 'プロンプト、アシスタントの応答、ツールの入力/出力、品質レビューに必要な完全なコンテキストファイル。機密情報は送信前に削除されます。',
  'settings.privacyInstallationId': '匿名ID',
  'settings.privacyOptedOut': 'オプトアウト済み',
  'settings.privacyDataDeletion': 'データを削除',
  'settings.privacyDataDeletionHint': '匿名IDをローテーションし、送信を停止します。既存のトレースは当社の保持ポリシーに従って期限切れになります。',
  'settings.about': '概要',
  'settings.aboutHint': 'バージョンと実行環境の詳細',
  'settings.appVersion': 'バージョン',
  'settings.appChannel': 'チャンネル',
  'settings.appRuntime': '実行環境',
  'settings.appPlatform': 'プラットフォーム',
  'settings.appArchitecture': 'アーキテクチャ',
  'settings.runtimePackaged': 'パッケージ版アプリ',
  'settings.runtimeDevelopment': '開発環境',
  'settings.versionUnavailable': 'daemon がオフラインの間はバージョン詳細を取得できません。',
  'settings.installLatest': '最新版をインストール',
  'settings.alreadyLatest': '最新バージョンです',
  'settings.mcpTitle': 'MCPサーバー',
  'settings.mcpHint': 'コーディング Agent（Cursor、Claude Code、VS Code など）が Open Design プロジェクトを直接読み取れるようにします。',
  'settings.mcpDaemonError': 'インストールパスを解決するためのローカルデーモンに接続できませんでした（{error}）。Open Designが実行中であることを確認してから、このパネルを再度開いてください。',
  'settings.mcpBuildDaemon': '先にデーモンをビルドしてください。',
  'settings.mcpNodeMissing': 'Nodeバイナリが見つかりません。',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js が見つかりません。`pnpm --filter @open-design/daemon build` を実行して更新してください。',
  'settings.mcpMethodCli': 'CLIコマンド',
  'settings.mcpInstructionCli': 'ターミナルでこれを実行してください。',
  'settings.mcpMethodToml': 'TOML設定',
  'settings.mcpInstructionCodex': 'このテーブルを {path} に追記してください。同じ設定がCodex CLIとCodex IDE拡張機能で共有されます。',
  'settings.mcpMethodOneClick': 'ワンクリックインストール',
  'settings.mcpInstructionCursor': '「Install in Cursor」をクリックして承認ダイアログ付きでインストールするか、このJSONを {path} にマージしてください。',
  'settings.mcpDeeplinkInstallCursor': 'Cursor にインストール',
  'settings.mcpMethodJson': 'JSON設定',
  'settings.mcpInstructionCopilot': 'コマンドパレット（{shortcut}）を開き、「MCP: Open User Configuration」を実行して、このJSONをマージしてください。ツールを表示するには、Copilot ChatがAgentモードである必要があります。',
  'settings.mcpInstructionAntigravity': 'Antigravity の場合：Agent パネルの「...」メニュー → MCP Servers → Manage MCP Servers → View raw config。この JSON をマージしてください。',
  'settings.mcpInstructionZed': 'Zedの設定（{shortcut}）を開き、これをトップレベルのオブジェクトにマージしてください。Zedは「mcpServers」ではなく「context_servers」を使用します。',
  'settings.mcpInstructionWindsurf': '{path} を開く（または Cascade の MCPs アイコン → Configure を使用）してマージしてください：',
  'settings.mcpCopyAria': 'MCP設定スニペットをコピー',
  'settings.mcpResolvingFailed': '# パスの解決に失敗しました。上記のエラーを参照してください',
  'settings.mcpLoadingPaths': '# ローカルデーモンからインストールパスを読み込み中…',
  'settings.mcpCopied': 'コピーしました',
  'settings.mcpCopy': 'コピー',
  'settings.mcpCursorApproval': 'Cursorは設定を書き込む前に承認ダイアログを表示します。',
  'settings.mcpCodexOneClickInstall': 'Codex にインストール',
  'settings.mcpCodexOneClickUninstall': 'Codexから削除',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI が PATH 上に見つかりません — Codex をインストールするか、スニペットを手動で貼り付けてください。',
  'settings.mcpCodexInstallSuccess': 'インストールしました。新しいサーバーを読み込むにはCodexを再起動してください。',
  'settings.mcpCodexUninstallSuccess': 'Codexから削除しました。',
  'settings.mcpCodexBusy': '処理中…',
  'settings.mcpCodexInstallError': '操作に失敗しました: {error}',
  'settings.mcpRestartNote': '新しいサーバーを認識させるには、クライアントを再起動してください。',
  'settings.mcpRestartDetail': 'ほとんどのエディタは起動時にのみMCPサーバーを読み込みます。Cursor / VS Code / Antigravity / Windsurf では、完全な再起動の代わりにコマンドパレットから `Developer: Reload Window` を実行できます。ZedとClaude Codeは終了して再度開く必要があります。',
  'settings.mcpCapabilitiesTitle': 'Agentでできること',
  'settings.mcpCapabilityRead': 'プロジェクト内の任意のファイル（HTML、JSX、CSS、JSON、SVG、Markdown）を読み取り・検索する。',
  'settings.mcpCapabilityPull': 'デザインバンドルを1回の呼び出しで取得する: エントリファイルに加えて、参照されているすべてのCSS変数、コンポーネント、フォント。',
  'settings.mcpCapabilityDefault': 'Open Designで開いているプロジェクトとファイルをデフォルトにするため、どのデザインかを言い直すことなく「これを私のアプリで作って」と言えます。',
  'settings.mcpRunningNote': 'MCPツールの呼び出しを成功させるには、Open Designが実行中である必要があります。Open Designを開く前にコーディングAgentを起動した場合は、ライブデーモンに接続できるようAgentを再起動してください。',
  'entry.tabDesigns': 'デザイン',
  'entry.tabTemplates': 'テンプレート',
  'entry.tabDesignSystems': 'デザインシステム',
  'entry.tabConnectors': 'コネクタ',
  'entry.openSettingsTitle': '設定',
  'entry.openSettingsAria': '設定を開く',
  'entry.discordLabel': 'Discord に参加',
  'entry.discordAria': 'Open Design の Discord に参加',
  'entry.discordAriaWithOnline': 'Open Design の Discord に参加 - {online}',
  'entry.discordOnlineLabel': '{count} 人がオンライン',
  'entry.followXLabel': 'X で @nexudotio をフォロー',
  'entry.resizeAria': 'サイドバーをリサイズ',
  'entry.loadingWorkspace': 'ワークスペースを読み込み中…',
  'entry.useEverywhereTitle': 'どこでも使う',
  'entry.useEverywhereAria': '「どこでも使う」ガイドを開く（CLI、MCP、HTTP、Skills）',
  'entry.navExpand': 'サイドバーを展開',
  'entry.navCollapse': 'サイドバーを折りたたむ',
  'entry.navNewProject': '新規プロジェクト',
  'entry.navHome': 'ホーム',
  'entry.navProjects': 'プロジェクト',
  'entry.navTasks': 'オートメーション',
  'entry.navPlugins': 'プラグイン',
  'entry.navDesignSystems': 'デザインシステム',
  'entry.navIntegrations': 'インテグレーション',
  'workspaceTabs.project': 'プロジェクト',
  'workspaceTabs.pluginDetails': 'プラグインの詳細',
  'workspaceTabs.marketplace': 'マーケットプレイス',
  'homeHero.title': '何をデザインしますか？',
  'homeHero.templatesScrollHint': '上にスクロールしてさらにテンプレートを表示',
  'homeHero.templatesCollapse': 'テンプレートを折りたたむ',
  'homeHero.subtitlePrefix': 'オープンソースの Claude Design 代替。',
  'homeHero.placeholder': '生成したい内容を記述してください…',
  'homeHero.placeholderActive': 'サンプルクエリを編集するか、独自に記述してください…',
  'homeHero.skills': 'スキル',
  'homeHero.addMenu': 'コンテキストを追加',
  'homeHero.addPlugin': 'プラグインを追加',
  'homeHero.addConnectors': 'コネクタを追加',
  'homeHero.addMcp': 'MCP サーバーを追加',
  'homeHero.noPlugins': 'インストール済みのプラグインがありません',
  'homeHero.noMcp': 'MCP サーバーがありません',
  'homeHero.noConnectors': '接続済みのコネクタがありません',
  'homeHero.applying': '適用中…',
  'homeHero.pluginTitle': 'プラグイン：{title}',
  'homeHero.pluginPrefix': 'プラグイン：{title}',
  'homeHero.skillPrefix': 'スキル：{title}',
  'homeHero.removePlugin': 'プラグインを削除',
  'homeHero.removePluginAria': 'プラグイン {title} を削除',
  'homeHero.clearActivePlugin': '有効なプラグインをクリア',
  'homeHero.clearActiveSkill': '有効なスキルをクリア',
  'homeHero.contextItemsResolved': '{n} 件のコンテキスト項目を解決しました',
  'homeHero.removeFile': 'ファイルを削除',
  'homeHero.contextSearchResults': 'コンテキスト検索結果',
  'homeHero.contextSurfaces': 'コンテキストサーフェス',
  'homeHero.loadingContext': 'コンテキストを読み込み中…',
  'homeHero.noResults': '「{query}」に該当する結果はありません。',
  'homeHero.searchPrompt': 'ファイル、プラグイン、スキル、MCP サーバー、コネクターを検索。',
  'homeHero.parameters': '{n} 個のパラメーター',
  'homeHero.details': '詳細',
  'homeHero.toRun': 'で実行',
  'homeHero.forNewLine': 'で改行',
  'homeHero.run': '実行',
  'homeHero.typeSomethingToRun': '実行する内容を入力してください',
  'homeHero.promptExamples': '例',
  'homeHero.footer.designSystem': 'スタイル',
  'homeHero.footer.autoDesignSystem': '自動',
  'homeHero.footer.autoDesignSystemSummary': '現在のプロンプトに最適なデザインシステムと視覚スタイルを自動で選びます。',
  'homeHero.footer.ratio': '比率',
  'homeHero.footer.duration': '長さ',
  'homeHero.footer.resolution': '解像度',
  'homeHero.footer.speakerNotes': 'ノート',
  'homeHero.footer.noSpeakerNotes': 'ノートなし',
  'homeHero.footer.availableCount': '{n} 件利用可能',
  'homeHero.footer.noMatches': '一致なし',
  'homeHero.moreShortcuts': 'その他',
  'homeHero.railAria': 'プロジェクトカテゴリーまたはスターターショートカットを選択',
  'homeHero.subTypeAria': 'サブタイプを選択',
  'homeHero.confirmReplaceTitle': '現在のプロンプトを置き換えますか？',
  'homeHero.confirmReplaceBody': '{title} を使用すると、入力欄の現在のテキストが置き換えられます。',
  'homeHero.confirmReplace': '置き換える',
  'homeHero.chip.prototype': 'プロトタイプ',
  'homeHero.chip.liveArtifact': 'ライブアーティファクト',
  'homeHero.chip.deck': 'スライドデッキ',
  'homeHero.chip.image': '画像',
  'homeHero.chip.video': '動画',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': '音声',
  'homeHero.chip.createPlugin': 'プラグインを作成',
  'homeHero.chip.figma': 'Figma から',
  'homeHero.chip.folder': 'フォルダーから',
  'homeHero.chip.template': 'テンプレートから',
  'homeHero.chip.liveArtifactHint': 'ライブでプレビューできるインタラクティブな HTML/CSS/JS アーティファクトを構築します。',
  'homeHero.chip.hyperframesHint': 'HTML ベースのモーションを作成：キャプション、オーディオリアクティブなビジュアル、シーン遷移。',
  'homeHero.chip.createPluginHint': '再利用可能な Open Design プラグインを作成し、マイプラグインに追加します。',
  'homeHero.chip.figmaHint': 'Figma フレームを有効なデザインシステムに移行します。',
  'homeHero.chip.folderHint': '既存のローカルフォルダーをインポートして編集を続けます。',
  'homeHero.chip.templateHint': '付属のテンプレートから開始します。',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'フォルダ',
  'workingDirPicker.homeTitle': 'ローカルストレージに保存 — クリックしてフォルダを選択',
  'workingDirPicker.processing': '処理中…',
  'workingDirPicker.select': 'ローカルストレージ',
  'workingDirPicker.clearAria': '作業ディレクトリをクリア',
  'workingDirPicker.replaceFailed': '作業ディレクトリを置き換えられませんでした',
  'workingDirPicker.unavailable': 'このビルドではフォルダ選択を利用できません。フォルダを選択するにはデスクトップアプリを実行してください。',
  'workingDirPicker.openUnavailable': 'フォルダを表示するには、このプロジェクトをデスクトップアプリで開いてください。',
  'workingDirPicker.openFailed': 'このフォルダを表示できませんでした',
  'workingDirPicker.showInFileManager': 'ファイルマネージャーで表示',
  'workingDirPicker.replace': 'フォルダを選択…',
  'workingDirPicker.recent': '最近使用したディレクトリ',
  'workingDirPicker.defaultLabel': 'ローカルストレージ',
  'handoff.toTarget': '{target}に引き継ぐ',
  'handoff.openInTarget': '{target}で開く',
  'handoff.openAction': '開く',
  'handoff.menuTitle': 'どのエディタで開きますか？',
  'handoff.action': '引き継ぐ',
  'handoff.fallbackTitle': '$PATH上にエディタが見つかりません - {target}で開きます',
  'handoff.chooseTargetAria': '引き継ぎ先を選択',
  'handoff.optionsAria': '引き継ぎオプション',
  'handoff.editorSection': 'エディタで開く',
  'handoff.cliSection': 'CLI用にコピー',
  'handoff.clickOpen': 'クリックして開く',
  'handoff.framework': 'コードフレームワーク',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'バニラJavaScript、HTML、CSS',
  'handoff.amrWebsite': 'AMRのWebサイトを開く',
  'handoff.copyPrompt': 'プロンプトをコピー',
  'handoff.copyPromptForTarget': '{target}用のプロンプトをコピー',
  'handoff.copied': 'コピーしました',
  'handoff.projectPathUnavailable': 'プロジェクトパスを読み込み中です。しばらくしてからもう一度お試しください。',
  'handoff.copyFailed': 'クリップボードへの書き込みがブロックされました。しばらくしてからもう一度お試しください。',
  'handoff.promptIntro': 'このローカルのOpen Designプロジェクトフォルダから続行してください:',
  'handoff.promptTarget': '引き継ぎ先',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': '{cli}で作業を引き継ぎます。以下を実行してください:',
  'handoff.promptReadFiles': 'まずこのディレクトリに入るか読み込んでください。DESIGN.md、README、既存のHTML/CSS/JS、アセット、存在する場合はpackage.jsonを優先してください。',
  'handoff.promptKeepDesign': '現在のビジュアルデザイン、レイアウト、インタラクション、アセットを維持してください。計画の段階で止めないでください。',
  'handoff.promptProduceCode': '実際に実行可能な{framework}コードを生成または変更してください。プロジェクトに既により明確なスタックがある場合は、その矛盾を指摘し、結果が実行可能な状態を保ってください。',
  'handoff.promptVerify': '最後に、実行、プレビュー、検証のコマンドを教えてください。',
  'handoff.promptCommandHint': 'プロジェクトディレクトリから開始するには、以下を使用してください:',
  'handoff.promptProject': 'プロジェクト',
  'handoff.promptProjectId': 'プロジェクトID',
  'handoff.notInstalled': '未インストール',
  'handoff.notDetectedTitle': '{target} - $PATH上で検出されませんでした',
  'designSystemPicker.select': 'デザインシステムを選択',
  'designSystemPicker.loading': 'デザインシステムを読み込み中…',
  'designSystemPicker.searchPlaceholder': 'デザインシステムを検索（タイトル / カテゴリ / 概要）',
  'designSystemPicker.searchCompactPlaceholder': 'デザインシステムを検索',
  'designSystemPicker.noneTitle': 'デザインシステムなし',
  'designSystemPicker.noneSummary': 'モデルに自由に選ばせる',
  'designSystemPicker.empty': '一致するデザインシステムがありません',
  'designSystemPicker.openPreview': 'プレビューを開く',
  'designSystemPicker.loadingPreview': 'プレビューを読み込み中…',
  'designSystemPicker.noPreview': 'プレビューページがありません。完全なプレビューを表示するには Design Systems を開いてください。',
  'designSystemPicker.previewHint': 'デザインシステムにカーソルを合わせるとプレビューが表示されます',
  'designSystemPicker.fullscreenAria': '{title} の全画面プレビュー',
  'designSystemPicker.closeFullscreen': '全画面プレビューを閉じる',
  'designSystemPicker.closeEsc': '閉じる（Esc）',
  'designSystemPicker.previewFrameTitle': '{title} のプレビュー',
  'designSystemPicker.fullscreenFrameTitle': '{title} の全画面プレビュー',
  'recentProjects.title': '最近のプロジェクト',
  'recentProjects.viewAll': 'すべて表示',
  'recentProjects.empty': 'プロジェクトはまだありません — プロンプトを入力して開始してください。',
  'pluginsHome.title': 'コミュニティ',
  'pluginsHome.subtitle': 'このランタイムに同梱された、すぐに使える Open Design ワークフロー。1つ選んでスタータープロンプトを読み込むか、レジストリでさらに探せます。',
  'pluginsHome.browseRegistry': 'レジストリを見る',
  'pluginsHome.count': '{total}件中{filtered}件',
  'pluginsHome.loadingCatalog': 'カタログを読み込み中…',
  'pluginsHome.emptyCatalog': 'カタログは空です。バンドルされたプラグインは Open Design に同梱されており、ここに自動的に表示されるはずです — 解消しない場合はデーモンを再起動してみてください。',
  'pluginsHome.emptyFiltered': '現在のフィルターに一致するプラグインはありません。',
  'pluginsHome.clearFilters': 'フィルターをクリア',
  'pluginsHome.modeAria': 'プラグインモード',
  'pluginsHome.featured': '保存済み',
  'pluginsHome.totalInCatalog': 'カタログに{n}件',
  'pluginsHome.categoryFilterAria': 'カテゴリフィルター',
  'pluginsHome.subcategoryFilterAria': '{label}のサブカテゴリフィルター',
  'pluginsHome.allCategory': 'すべての{label}',
  'pluginsHome.searchPlaceholder': 'プラグインを検索…',
  'pluginsHome.searchAria': 'プラグインを検索',
  'pluginsHome.clearSearch': '検索をクリア',
  'pluginsHome.facet.import': 'インポート',
  'pluginsHome.facet.create': '作成',
  'pluginsHome.facet.export': 'エクスポート',
  'pluginsHome.facet.share': '共有',
  'pluginsHome.facet.deploy': 'デプロイ',
  'pluginsHome.facet.refine': '調整',
  'pluginsHome.facet.extend': '拡張',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'コード / フォルダ',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'スクリーンショット',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'スライド',
  'pluginsHome.facet.publicLink': '公開リンク',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'ダッシュボード',
  'pluginsHome.subfacet.app-prototypes': 'アプリ',
  'pluginsHome.subfacet.landing-marketing': 'LP / マーケ',
  'pluginsHome.subfacet.developer-tools': '開発者ツール',
  'pluginsHome.subfacet.docs-reports': 'ドキュメント / レポート',
  'pluginsHome.subfacet.brand-design': 'ブランド / デザイン',
  'pluginsHome.subfacet.pitch-business': 'ピッチ / ビジネス',
  'pluginsHome.subfacet.course-training': '講座 / 研修',
  'pluginsHome.subfacet.reports-briefings': 'レポート / ブリーフ',
  'pluginsHome.subfacet.product-sales': 'プロダクト / 営業',
  'pluginsHome.subfacet.engineering-talks': '技術トーク',
  'pluginsHome.subfacet.creative-decks': 'クリエイティブ資料',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / モックアップ',
  'pluginsHome.subfacet.brand-visuals': 'ブランド / ロゴ',
  'pluginsHome.subfacet.storyboards-motion-refs': '絵コンテ',
  'pluginsHome.subfacet.social-content': 'SNS / コンテンツ',
  'pluginsHome.subfacet.avatar-portrait': 'アバター / ポートレート',
  'pluginsHome.subfacet.illustration-style': 'イラスト / スタイル',
  'pluginsHome.subfacet.motion-effects': 'モーション / エフェクト',
  'pluginsHome.subfacet.social-short-form': 'SNS / ショート動画',
  'pluginsHome.subfacet.marketing-product': 'マーケ / プロダクト',
  'pluginsHome.subfacet.data-explainers': 'データ / 解説',
  'pluginsHome.subfacet.cinematic-story': 'シネマティック / ストーリー',
  'pluginsView.lede': 'インストール済みのワークフローを閲覧し、レジストリのエントリを探索し、ソースを管理して、チーム配布用のプラグインを準備します。',
  'pluginsView.importPlugin': 'プラグインをインポート',
  'pluginsView.agentContext': 'Agent コンテキスト',
  'pluginsView.summaryAria': 'プラグインの概要',
  'pluginsView.areasAria': 'プラグインエリア',
  'pluginsView.loading': 'プラグインを読み込み中…',
  'pluginsView.tab.installed': 'インストール済み',
  'pluginsView.tab.available': '利用可能',
  'pluginsView.tab.sources': 'ソース',
  'pluginsView.tab.team': 'チーム',
  'pluginsView.tabHint.installed': '自分のプラグイン',
  'pluginsView.tabHint.available': 'ソースから',
  'pluginsView.tabHint.sources': 'カタログ',
  'pluginsView.tabHint.team': 'エンタープライズ',
  'pluginsView.installedTitle': 'インストール済みプラグイン',
  'pluginsView.installedSubtitle': 'インポートした、またはマーケットプレイスのソースからインストールしたプラグイン。',
  'pluginsView.installedEmpty': 'インストール済みのユーザープラグインはまだありません。作成 / インポートを使用するか、利用可能なエントリをインストールしてください。',
  'pluginsView.availableTitle': 'ソースから利用可能',
  'pluginsView.availableSubtitle': '設定済みのマーケットプレイスから検出されたカタログエントリ。',
  'pluginsView.availableFiltersAria': '利用可能なプラグインのフィルター',
  'pluginsView.searchAvailableAria': '利用可能なプラグインを検索',
  'pluginsView.searchAvailablePlaceholder': '利用可能なプラグインを検索',
  'pluginsView.clearAvailableSearch': '利用可能なプラグインの検索をクリア',
  'pluginsView.source': 'ソース',
  'pluginsView.availableEmptyInstalled': '利用可能なエントリはまだありません。インストール済みのカタログエントリは「利用可能」から削除されます。再び利用可能にするには、アンインストールしてください。',
  'pluginsView.availableEmptyFiltered': 'フィルターに一致する利用可能なエントリはありません。',
  'pluginsView.availableEmptyNoSources': '利用可能なエントリはまだありません。「ソース」タブでソースを追加してください。',
  'pluginsView.installing': 'インストール中…',
  'pluginsView.install': 'インストール',
  'pluginsView.sourcesTitle': 'レジストリソース',
  'pluginsView.sourcesSubtitle': '利用可能なプラグインエントリを供給するマーケットプレイスカタログ。',
  'pluginsView.sourceUrl': 'ソース URL',
  'pluginsView.defaultTrust': 'デフォルトの信頼レベル',
  'pluginsView.trust.restricted': '制限付き',
  'pluginsView.trust.trusted': '信頼済み',
  'pluginsView.trust.official': '公式',
  'pluginsView.adding': '追加中…',
  'pluginsView.addSource': 'ソースを追加',
  'pluginsView.sourcesEmpty': 'レジストリソースはまだ設定されていません。',
  'pluginsView.pluginsCount': '{n} 個のプラグイン',
  'pluginsView.catalogVersion': 'カタログ v{version}',
  'pluginsView.trustFor': '{name} の信頼レベル',
  'pluginsView.refreshing': '更新中…',
  'pluginsView.removing': '削除中…',
  'pluginsView.teamTitle': 'プライベートチームマーケットプレイス',
  'pluginsView.teamBody': 'このエリアは、エンタープライズおよびチームのカタログ、プライベートな信頼ポリシー、共有プラグインのライフサイクル管理のために予約されています。',
  'pluginCard.details': '詳細',
  'pluginCard.use': '使用',
  'pluginCard.useWithQuery': 'クエリ付きで使用',
  'pluginCard.applying': '適用中…',
  'pluginCard.publish': '公開',
  'pluginCard.contribute': '貢献',
  'pluginCard.starting': '開始中…',
  'pluginCard.detailsAria': '{title} の詳細を表示',
  'pluginCard.chooseUseAria': '{title} の使用方法を選択',
  'pluginCard.useOptionsAria': '{title} の使用オプション',
  'pluginCard.shareAria': '{title} を共有',
  'pluginCard.publishAria': '{title} を GitHub リポジトリとして公開',
  'pluginCard.publishTitle': 'プラグインを GitHub リポジトリとして公開',
  'pluginCard.contributeAria': '{title} を Open Design に貢献',
  'pluginCard.contributeTitle': 'プラグインを pull request で Open Design に貢献',
  'skillPluginCandidate.createForMe': 'プラグイン/テンプレートを作成',
  'skillPluginCandidate.contributeToMain': 'open-design にコントリビュート',
  'skillPluginCandidate.repoDescription': 'このリポジトリはプラグインとして利用できそうです。',
  'integrations.kicker': '連携',
  'integrations.lede': '外部システムを接続し、MCP ツールをエージェントループに取り込み、他の IDE やスクリプト、自動化から Open Design を利用できます。',
  'integrations.agentReady': 'Agent 対応',
  'integrations.areasAria': '連携エリア',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'スキル',
  'integrations.tabHint.mcp': '外部ツール',
  'integrations.tabHint.connectors': 'アカウントと API',
  'integrations.tabHint.useEverywhere': 'CLI、HTTP、MCP',
  'integrations.skillsTitle': 'Skills 連携',
  'integrations.skillsBody': 'Skill レベルの連携管理は別ブランチから移行中です。このタブは予約済みで、MCP、Connectors、今後の Skills 設定を同じ Integration ルートにまとめるためのものです。',
  'mcpClient.title': '外部 MCP サーバー',
  'mcpClient.subtitle': 'コーディング Agent 向けのサードパーティツール。',
  'mcpClient.addServer': 'サーバーを追加',
  'mcpClient.emptyTitle': 'MCP サーバーが設定されていません。',
  'mcpClient.emptyBody': '「サーバーを追加」をクリックして始めましょう — テンプレート（Higgsfield OpenClaw、Pollinations、Allyson、Imagician、EdgeOne Pages、GitHub、Filesystem…）を選ぶか、カスタムの stdio / HTTP サーバーを設定します。',
  'mcpClient.saveChanges': '変更を保存',
  'mcpClient.storedAt': '保存先',
  'mcpClient.daemonError': 'ローカルデーモンに接続できませんでした。Open Design が実行中であることを確認してから、このパネルを再度開いてください。',
  'mcpClient.saveFailed': '保存に失敗しました。デーモンが実行中であることを確認して、もう一度お試しください。',
  'useEverywhere.modalAria': 'Open Design をあらゆる場所で使う',
  'useEverywhere.modalTitle': 'Open Design をあらゆる場所で使う',
  'useEverywhere.modalSubtitle': 'Open Design をあらゆる IDE、Agent、スクリプトに組み込めます — CLI、HTTP、MCP、Skills 対応。「Agent 用のガイドをコピー」を使って Claude Code、Codex、Cursor、openclaw、hermes に貼り付ければ、すべてをセットアップできます。',
  'useEverywhere.closeAria': '「あらゆる場所で使う」を閉じる',
  'useEverywhere.closeTitle': '閉じる（Esc）',
  'useEverywhere.tabsAria': '連携サーフェス',
  'useEverywhere.footStrong': 'ワンクリックで引き渡し。',
  'useEverywhere.footBody': 'Agent がすぐに実行できる構造化された Markdown ガイドをコピーします — インストール、検証、利用まで。',
  'useEverywhere.configureMcp': 'MCP サーバーを設定',
  'useEverywhere.copyGuide': 'Agent 用ガイドをコピー',
  'useEverywhere.copy': 'コピー',
  'useEverywhere.copied': 'コピーしました',
  'useEverywhere.copyFailed': 'コピーに失敗しました',
  'useEverywhere.copySnippetAria': 'スニペットをコピー: {label}',
  'useEverywhere.section.overview.tab': '概要',
  'useEverywhere.section.overview.heading': 'Open Design は、お使いの Agent が動く場所ならどこでも動作します',
  'useEverywhere.section.overview.intro': 'Open Design は単なるウィンドウ以上のものです — ローカルの特権デーモン（`od`）に加え、Skills + Design-Systems + Atoms のレジストリを備えています。マシン上で起動すれば、あらゆるコード Agent（Claude Code、Codex、Cursor、OpenCode/openclaw、Hermes、独自のスクリプト）が、4 つの相互に交換可能なインターフェースを通じて、生成の実行、プロジェクトの検査、デザイン成果物の作成を行えます。',
  'useEverywhere.section.overview.bullet1': 'CLI — ヘッドレスなスクリプト、CI、シェル自動化向けの `od <command>`。',
  'useEverywhere.section.overview.bullet2': 'MCP サーバー — Open Design を Model Context Protocol サーバーとして接続し、MCP 対応のあらゆる Agent がスキルの一覧表示、シナリオの実行、成果物の読み取りを行えるようにします。',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` の REST + SSE エンドポイント。Web UI が使うのと同じインターフェースです。',
  'useEverywhere.section.overview.bullet4': 'Skills — ドロップインで使える `SKILL.md` パック（Claude 互換）。PATH 上にあるあらゆる Agent が、Open Design なしでも呼び出せます。',
  'useEverywhere.section.overview.bullet5': '標準成果物 — デーモンが起動する前に、Skills、同梱のデフォルトプラグイン、コミュニティのプラグイン例から実際の HTML プロジェクトをシードします。',
  'useEverywhere.section.overview.snippet1': 'ローカルでデーモン（と web UI）を起動する',
  'useEverywhere.section.overview.snippet2': '到達可能かどうかを確認する',
  'useEverywhere.section.overview.snippet3': '起動前に標準アーティファクトを取り込む',
  'useEverywhere.section.overview.footer': 'デーモンはデフォルトで `./.od/`（プロジェクトローカル）に書き込みます。プロジェクト間でデータを共有するには `OD_DATA_DIR=~/.open-design` を設定してください。',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': '任意のシェルから Open Design を操作する',
  'useEverywhere.section.cli.intro': '`od` バイナリはデーモンに同梱されており、Claude Code / Codex が生成を実行する際に使用するものと同じバイナリです。ほとんどのサブコマンドはローカルデーモンに POST するシンクライアントなので、`pnpm tools-dev` で起動した場合でもパッケージ化されたアプリとして起動した場合でも同じように動作します。',
  'useEverywhere.section.cli.bullet1': '`od`（引数なし）— デーモンを起動し、Web UI を開きます。',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — 統合メディアプロトコルを通じて画像 / 動画 / 音声のバイトデータを生成します。',
  'useEverywhere.section.cli.bullet3': '`od run ...` — プロンプト + スキルからプロジェクトの実行を開始します。',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — コミュニティプラグインのインストールと適用を行います。',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — ローカルで利用可能なものを確認します。',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — デーモンの状態を確認し、PATH 上の Agent CLI を検出します。',
  'useEverywhere.section.cli.snippet1': '画像を生成する（設定済みのメディアプロバイダーに委譲）',
  'useEverywhere.section.cli.snippet2': 'シナリオプラグインをヘッドレスで実行し、イベントを JSON 行としてストリーミングする',
  'useEverywhere.section.cli.snippet3': 'ローカルで利用可能なスキルとデザインシステムを一覧表示する',
  'useEverywhere.section.cli.snippet4': 'CLI からシードされたアーティファクトを確認する',
  'useEverywhere.section.cli.snippet5': '環境と検出された Agent（Claude、Codex、Cursor、…）を検証',
  'useEverywhere.section.cli.footer': 'すべてのサブコマンドは `--daemon-url http://127.0.0.1:<port>` を受け付け、特定の実行中デーモンを対象にできます — テスト用にサンドボックス化した 2 つ目のインスタンスを実行する際に便利です。',
  'useEverywhere.section.mcp.tab': 'MCP サーバー',
  'useEverywhere.section.mcp.heading': 'Open Design を MCP サーバーとして任意のコーディング Agent に公開する',
  'useEverywhere.section.mcp.intro': 'Open Design には Model Context Protocol サーバー（`od mcp`）が同梱されており、MCP 対応のあらゆるクライアント — Cursor、Claude Code、Antigravity、VS Code Copilot Chat、openclaw、hermes — が、手動でシェルを呼び出すことなく Open Design のツール（スキルの一覧表示、プレビューのレンダリング、メディアの生成、プラグインの実行）を検出できます。デーモンは主要な各クライアント向けに、貼り付けるだけで使えるインストール用スニペットを `GET /api/mcp/install-info` で公開します。',
  'useEverywhere.section.mcp.bullet1': 'stdio トランスポート — 追加のポート不要で、クライアントが `od mcp` を直接起動します。',
  'useEverywhere.section.mcp.bullet2': 'サイドカーとして起動された場合、ローカル IPC ステータスソケット経由で稼働中のデーモン URL を自動検出します。',
  'useEverywhere.section.mcp.bullet3': '通常のインストールでは `--daemon-url http://127.0.0.1:<port>` にフォールバックするため、MCP プロセスは常に稼働中のデーモンを見つけられます。',
  'useEverywhere.section.mcp.bullet4': '`OD_DATA_DIR` を固定することで、起動された MCP プロセスがデーモンが既に使用しているのと同じ場所に書き込むようにします（パッケージ化された macOS アプリバンドルでの EPERM を回避）。',
  'useEverywhere.section.mcp.snippet1': '汎用 MCP クライアント設定（Cursor、Claude Code、Codex、… で動作）',
  'useEverywhere.section.mcp.snippet2': 'または: お使いのインストール環境に合わせたスニペットをデーモンに問い合わせる',
  'useEverywhere.section.mcp.snippet3': 'ライブアーティファクト MCP バリアント（ダッシュボードの読み取りと更新）',
  'useEverywhere.section.mcp.footer': 'Open Design アプリで「設定 → 連携」を開くと、JSON を手作業で編集する代わりに、クライアント別のインストールコマンド（Cursor、Claude Code、Antigravity、VS Code）をコピーできます。',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'web UI が使用するものと同じ REST + SSE サーフェス',
  'useEverywhere.section.http.intro': 'ローカルデーモンは `http://127.0.0.1:7456`（ポートは設定可能）で HTTP API を提供します。web UI が呼び出すすべてのエンドポイントは、あなたのスクリプトからも自由に利用できます。ストリーミングエンドポイント（チャットターン、プロジェクト実行）は、`@open-design/contracts` のコントラクト型を伴う Server-Sent Events を発行します。',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — デーモンの稼働状態。',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` と `GET /api/design-systems` — 利用可能なレジストリ。',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` と `POST /api/projects` — プロジェクトの一覧表示と作成（POST はプロジェクトと最初の会話を返します）。',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — 会話の Agent イベントの SSE ストリーム。',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — インストール済みプラグインをバインドし、レンダリングされたクエリ例と入力を取得します。',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — PATH 上で検出されたコード Agent の CLI。',
  'useEverywhere.section.http.snippet1': 'インストール済みのスキルを一覧表示する（Agent はこれらをテンプレートとして使用します）',
  'useEverywhere.section.http.snippet2': 'プロンプトからプロジェクトを作成する（サーバーサイドのフロー全体）',
  'useEverywhere.section.http.snippet3': 'チャットのターンをストリーミング（SSE — 各行は JSON-Lines 互換）',
  'useEverywhere.section.http.footer': 'すべてのリクエスト/レスポンスの純粋な TypeScript 型は `@open-design/contracts` にあります — ジェネレーターを組み込まなくても、スクリプトにインポートするだけで完全な補完が得られます。',
  'useEverywhere.section.skills.tab': 'スキルとヘッドレス',
  'useEverywhere.section.skills.heading': 'あらゆる Agent 向けのドロップイン Skills — Open Design が起動していなくても利用可能',
  'useEverywhere.section.skills.intro': 'Skill は、Claude 互換の `SKILL.md`（YAML フロントマター + 本文）を含むディレクトリです。Open Design はこのフォーマットを `od:` 名前空間（`mode`、`preview`、`design_system`、`inputs`、…）で拡張し、同じ成果物を Open Design 内でも、Claude Code、Codex、openclaw、hermes のような素の Agent でも利用できるようにしています。検出は優先順位のチェーンに従うため、プロジェクトは自身のスキルを上書きできます。',
  'useEverywhere.section.skills.bullet1': '検出: `./.claude/skills/` → `./skills/` → `~/.claude/skills/`（プロジェクトが優先）。',
  'useEverywhere.section.skills.bullet2': '1 つのスキルを複数のプロジェクトにシンボリックリンクすることで、コピーせずに共有できます。',
  'useEverywhere.section.skills.bullet3': '各スキルは、コネクター、アトム、デザインシステム要件、およびギャラリー用の `preview` サンプル出力を宣言できます。',
  'useEverywhere.section.skills.bullet4': 'ヘッドレス: PATH に `od` を持つ Agent は `od skills list` を呼び出してから任意のスキルを実行できます。読み取り専用のフローではデーモンは任意です。',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` は、デフォルトのプラグイン例とコミュニティプラグイン例で同じアーティファクト形状を実行し、その結果の `index.html` プロジェクトを再利用可能なテストデータとして保存します。',
  'useEverywhere.section.skills.snippet1': '最小限の SKILL.md（Claude 互換のフロントマター + Open Design の追加項目）',
  'useEverywhere.section.skills.snippet2': '共有スキルをプロジェクトにシンボリックリンクする（cc-switch 方式）',
  'useEverywhere.section.skills.snippet3': 'ヘッドレス: デーモンが現在認識しているスキルを一覧表示する',
  'useEverywhere.section.skills.snippet4': 'ヘッドレスアーティファクトフィクスチャバンドル',
  'useEverywhere.section.skills.footer': '仕様: `docs/skills-protocol.md` と `docs/agent-adapters.md` は、アダプターサーフェス全体（Claude Code、Codex、Cursor、MCP 対応 Agent、BYOK API フォールバック）とアダプターごとのスキル注入戦略を網羅しています。',
  'tasks.kicker': '自動化ワークスペース',
  'tasks.comingSoon': '近日公開',
  'tasks.lede': '自動化はプロンプトを永続的な作業へと変えます。Orbit が実行し、ルーティンが定義を保持し、スケジュールが実行タイミングを決定し、ライブアーティファクトが変更内容を表示します。',
  'tasks.newAutomation': '新規自動化',
  'tasks.previewNote': 'プレビュー画面のみです。Orbit 設定は現在ご利用いただけます。ルーティン、スケジュール、ライブアーティファクトの連携は、バックエンドのブランチがマージされ次第提供されます。',
  'tasks.primitivesAria': '自動化プリミティブ',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': '長時間または定期的に実行される Agent 作業のための永続ランタイム。',
  'tasks.primitive.orbit.enabled': '日次サマリー有効',
  'tasks.primitive.orbit.manualOnly': '手動のみ',
  'tasks.primitive.routines.title': 'ルーティン',
  'tasks.primitive.routines.body': '単一のチャット終了後も保持される永続的なタスク定義。',
  'tasks.primitive.routines.meta': 'プロダクトシェル準備完了',
  'tasks.primitive.schedules.title': 'スケジュール',
  'tasks.primitive.schedules.body': 'ルーティンの実行タイミングを決定する時間またはイベントトリガー。',
  'tasks.primitive.schedules.meta': 'ブランチ保留中',
  'tasks.primitive.liveArtifacts.title': 'ライブアーティファクト',
  'tasks.primitive.liveArtifacts.body': 'Agent の作業中に更新され続けるレポートやメモ。',
  'tasks.primitive.liveArtifacts.meta': 'プレビューモデル',
  'tasks.listAria': '自動化一覧',
  'tasks.routinesAndRuns': '{n} 件のルーティンと実行',
  'tasks.filtersAria': '自動化フィルター',
  'tasks.filter.scheduled': 'スケジュール済み',
  'tasks.filter.running': '実行中',
  'tasks.filter.done': '完了',
  'tasks.configurationAria': '自動化の設定',
  'tasks.slot.trigger': 'トリガー',
  'tasks.slot.pattern': 'パターン',
  'tasks.slot.runtime': 'ランタイム',
  'tasks.slot.output': '出力',
  'tasks.liveArtifact': 'ライブアーティファクト',
  'tasks.viewProgress': '進捗を表示',
  'tasks.pause': '一時停止',
  'tasks.runNow': '今すぐ実行',
  'tasks.openArtifact': 'アーティファクトを開く',
  'tasks.status.dailyAt': '毎日 · {time}',
  'tasks.status.pausedManual': '一時停止中 · 手動のみ',
  'tasks.sample.orbit.title': 'Orbit Daily コネクターサマリー',
  'tasks.sample.orbit.metaEnabled': 'コネクターダイジェストはスケジュール済み',
  'tasks.sample.orbit.metaDisabled': '有効にするには Orbit 設定を開く',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · ライブ成果物',
  'tasks.sample.orbit.previewDisabled': 'スケジュールされた実行はありません',
  'tasks.sample.orbit.triggerEnabled': 'スケジュール · 毎日 {time}',
  'tasks.sample.orbit.triggerDisabled': '手動 · オンデマンド実行',
  'tasks.sample.orbit.pattern': 'ルーティン · コネクターダイジェスト',
  'tasks.sample.orbit.runtime': 'Orbit · デーモンによるスケジュール実行',
  'tasks.sample.orbit.output': 'ライブ成果物 · 更新可能なレポート',
  'tasks.sample.orbit.artifactMetaEnabled': '実行ごとに更新されます',
  'tasks.sample.orbit.artifactMetaDisabled': 'スケジュール待ち',
  'tasks.sample.orbit.body1': '# Orbit Daily アクティビティサマリー',
  'tasks.sample.orbit.body2': 'コネクターを確認済み · 成功、スキップ、失敗',
  'tasks.sample.orbit.body3': 'ハイライトは更新可能なライブアーティファクトになります。',
  'tasks.sample.mcp.title': 'MCP 代替手段の調査',
  'tasks.sample.mcp.status': 'orbit で実行中 · 2時間14分',
  'tasks.sample.mcp.meta': '14 / 30 ソース処理済み',
  'tasks.sample.mcp.preview': 'research_notes.md · ライブ',
  'tasks.sample.mcp.trigger': '手動 · ワンショット',
  'tasks.sample.mcp.pattern': 'ディープリサーチプロンプト',
  'tasks.sample.mcp.runtime': 'リモート · 永続',
  'tasks.sample.mcp.output': 'ライブレポート · 自動更新',
  'tasks.sample.mcp.artifactMeta': '12秒前に更新',
  'tasks.sample.mcp.body1': '# MCP 代替手段 - 暫定的な調査結果',
  'tasks.sample.mcp.body2': '14 件のソースを精査 · 3 件の候補を選定',
  'tasks.sample.mcp.body3': '## 候補リスト',
  'tasks.sample.mcp.body4': '- JSON-RPC 経由のツール呼び出しスキーマ...',
  'tasks.sample.mcp.body5': '- gRPC ベースの Agent プロトコル...',
  'tasks.sample.weekly.title': '週次チームダイジェスト',
  'tasks.sample.weekly.status': '次回: 月 9:00 AM',
  'tasks.sample.weekly.meta': 'チーム週次ドキュメントを更新',
  'tasks.sample.weekly.preview': 'team_weekly.md · 次の成果物',
  'tasks.sample.weekly.trigger': 'スケジュール · 毎週',
  'tasks.sample.weekly.pattern': 'ルーティン · チームダイジェスト',
  'tasks.sample.weekly.runtime': 'リモート · 定期実行',
  'tasks.sample.weekly.output': 'ライブ成果物 · Markdown',
  'tasks.sample.weekly.artifactMeta': '最終更新 4日前',
  'tasks.sample.weekly.body1': '# チーム週次レポート',
  'tasks.sample.weekly.body2': '## 進行中',
  'tasks.sample.weekly.body3': '- デザインシステム統合パス',
  'tasks.sample.weekly.body4': '- コネクタ品質チェック',
  'tasks.sample.weekly.body5': '## リスク',
  'tasks.sample.pr.title': 'PR レビューのリマインダー',
  'tasks.sample.pr.status': '新しい PR 時 · 23分前に実行',
  'tasks.sample.pr.meta': 'Slack DM を送信',
  'tasks.sample.pr.preview': '前回の配信に成功しました',
  'tasks.sample.pr.trigger': 'イベント · 新規 PR',
  'tasks.sample.pr.pattern': 'ルーティン · 通知',
  'tasks.sample.pr.runtime': 'ローカル · クイック実行',
  'tasks.sample.pr.output': 'メッセージ · Slack DM',
  'tasks.sample.pr.artifactMeta': '最終実行: 23 分前',
  'tasks.sample.pr.body1': 'レビュー用に PR #184 をオープンしました',
  'tasks.sample.pr.body2': '一致したレビュアー: design-platform, web-runtime',
  'tasks.sample.pr.body3': '配信: Slack DM を送信しました',
  'tasks.sample.meeting.title': '会議前の準備',
  'tasks.sample.meeting.status': '明日 · 午前 10:00',
  'tasks.sample.meeting.meta': '単発 · サマリーを送信',
  'tasks.sample.meeting.preview': 'meeting_brief.md · キュー待ち',
  'tasks.sample.meeting.trigger': 'スケジュール · 単発',
  'tasks.sample.meeting.pattern': 'ブリーフィングプロンプト',
  'tasks.sample.meeting.runtime': 'リモート · 制限あり',
  'tasks.sample.meeting.output': '成果物 + メッセージ',
  'tasks.sample.meeting.artifactMeta': '生成待ち',
  'tasks.sample.meeting.body1': '# 会議ブリーフ',
  'tasks.sample.meeting.body2': 'アジェンダのソース: カレンダーイベント + リンクされたドキュメント',
  'tasks.sample.meeting.body3': '出力には決定事項、ブロッカー、質問が含まれます。',
  'tasks.sample.candidate.title': '候補者トラッキング',
  'tasks.sample.candidate.status': '失敗 · 要対応',
  'tasks.sample.candidate.meta': '認証の有効期限切れ',
  'tasks.sample.candidate.preview': '再開するには Greenhouse を再接続してください',
  'tasks.sample.candidate.trigger': 'スケジュール · 毎日',
  'tasks.sample.candidate.pattern': 'ルーティン · 応募者の同期',
  'tasks.sample.candidate.runtime': 'リモート · 繰り返し',
  'tasks.sample.candidate.output': 'ライブアーティファクト · テーブル',
  'tasks.sample.candidate.artifactMeta': '認証が復元されるまで一時停止中',
  'tasks.sample.candidate.body1': '# 候補者パイプライン',
  'tasks.sample.candidate.body2': '最後に成功した同期: 2 日前',
  'tasks.sample.candidate.body3': '対応が必要: ソースアカウントを再接続してください。',
  'routines.title': '自動化',
  'routines.subtitle': '無人で実行されるスケジュール自動化。',
  'routines.newAutomation': '新規自動化',
  'routines.loading': '読み込み中…',
  'routines.empty': '自動化はまだありません。',
  'routines.emptyHint': '「新規自動化」をクリックして、無人で実行する Agent をスケジュールします。',
  'routines.runHistoryLoading': '実行を読み込み中…',
  'routines.runHistoryEmpty': '実行履歴はまだありません。',
  'routines.fieldName': '名前',
  'routines.fieldNamePlaceholder': '朝のブリーフィング',
  'routines.fieldPrompt': 'プロンプト',
  'routines.fieldPromptPlaceholder': '昨日の GitHub と Linear のアクティビティを取得し、変更点を要約します。',
  'routines.fieldSchedule': 'スケジュール',
  'routines.fieldMinute': '毎時の分',
  'routines.fieldTime': '時刻',
  'routines.fieldTimezone': 'タイムゾーン',
  'routines.fieldsetProject': 'プロジェクト',
  'routines.kind.hourly': '毎時',
  'routines.kind.daily': '毎日',
  'routines.kind.weekdays': '平日',
  'routines.kind.weekly': '毎週',
  'routines.weekday.short.0': '日',
  'routines.weekday.short.1': '月',
  'routines.weekday.short.2': '火',
  'routines.weekday.short.3': '水',
  'routines.weekday.short.4': '木',
  'routines.weekday.short.5': '金',
  'routines.weekday.short.6': '土',
  'routines.weekday.long.0': '日曜日',
  'routines.weekday.long.1': '月曜日',
  'routines.weekday.long.2': '火曜日',
  'routines.weekday.long.3': '水曜日',
  'routines.weekday.long.4': '木曜日',
  'routines.weekday.long.5': '金曜日',
  'routines.weekday.long.6': '土曜日',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': '毎時 :{minute} に実行',
  'routines.describe.daily': '毎日 {time} {tz} に実行',
  'routines.describe.weekdays': '月〜金 {time} {tz} に実行',
  'routines.describe.weekly': '毎週 {day} の {time} {tz} に実行',
  'routines.modeCreate': '実行ごとに新規プロジェクトを作成',
  'routines.modeCreateHint': '起動ごとに新しい独立したワークスペース。',
  'routines.modeReuse': '既存のプロジェクトを再利用',
  'routines.modeReuseHint': '各実行はプロジェクト内の新しい会話として扱われます。',
  'routines.pickProject': '— プロジェクトを選択 —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ 実行ごとに新規プロジェクト',
  'routines.tagPaused': '一時停止中',
  'routines.metaNext': '次回: {when}',
  'routines.metaLast': '前回:',
  'routines.triggerManual': '手動',
  'routines.triggerScheduled': 'スケジュール',
  'routines.openProject': 'プロジェクトを開く',
  'routines.openProjectTitle': 'この実行が書き込んだプロジェクトを開く',
  'routines.runNow': '今すぐ実行',
  'routines.edit': '編集',
  'routines.pause': '一時停止',
  'routines.resume': '再開',
  'routines.history': '履歴',
  'routines.hideHistory': '履歴を非表示',
  'routines.delete': '削除',
  'routines.deleteTitle': 'この自動化を削除',
  'routines.cancel': 'キャンセル',
  'routines.save': '保存',
  'routines.saving': '保存中…',
  'routines.create': '作成',
  'routines.creating': '作成中…',
  'routines.status.queued': '待機中',
  'routines.status.running': '実行中',
  'routines.status.succeeded': '成功',
  'routines.status.failed': '失敗',
  'routines.status.canceled': 'キャンセル済み',
  'routines.confirmDelete': 'この自動化を削除しますか？過去の実行とそのプロジェクトは保持されます。',
  'routines.errorPickProject': '再利用するプロジェクトを選択するか、「実行ごとに新規作成」に切り替えてください',
  'routines.errorAgentEmptyOutput': 'Agent は出力を生成せずに完了しました。モデルまたはプロバイダーが空のレスポンスを返した可能性があります。上流のエラーがないか Agent のログを確認してください。',
  'entry.helpAria': 'ヘルプ',
  'entry.helpMenuAria': 'ヘルプメニュー',
  'entry.helpGetHelp': 'GitHub でサポートを受ける',
  'entry.helpSubmitFeature': '機能をリクエスト',
  'entry.helpWhatsNew': '最新情報',
  'entry.helpDownloadDesktop': 'デスクトップアプリをダウンロード',
  'entry.githubStarLabel': 'スター',
  'entry.githubStarTitle': 'GitHub でスターを付ける',
  'entry.githubStarAria': 'GitHub で Open Design にスターを付ける',
  'entry.tabImageTemplates': '画像テンプレート',
  'entry.tabVideoTemplates': '動画テンプレート',
  'promptTemplates.searchPlaceholder': 'テンプレートを検索…',
  'promptTemplates.countLabel': '{n} 件',
  'promptTemplates.emptyImage': '画像プロンプトテンプレートがまだインストールされていません。',
  'promptTemplates.emptyVideo': '動画プロンプトテンプレートがまだインストールされていません。',
  'promptTemplates.emptyNoMatch': '検索に一致するテンプレートがありません。',
  'promptTemplates.attributionFooter': '公開プロンプトライブラリから引用。各カードは元の作者にリンクしています。',
  'promptTemplates.openPreviewTitle': 'プロンプトとプレビューを開く',
  'promptTemplates.sourcePrefix': 'ソース:',
  'promptTemplates.fetchError': 'テンプレートの本文を読み込めませんでした。',
  'promptTemplates.promptLabel': 'プロンプト本文',
  'promptTemplates.copyPrompt': 'プロンプトをコピー',
  'promptTemplates.copyDone': 'コピーしました！',
  'promptTemplates.modelHint': '推奨モデル: {model}',
  'promptTemplates.openSource': 'オリジナルを表示',
  'promptTemplates.openFullscreen': 'フルスクリーンプレビューを開く',
  'promptTemplates.closeFullscreen': 'フルスクリーンプレビューを閉じる',
  'promptTemplates.allSources': 'すべてのソース',
  'promptTemplates.sourceFilterAria': 'ソースで絞り込む',
  'promptTemplates.retry': '再試行',
  'connectors.title': 'コネクター',
  'connectors.subtitle': 'ライブアーティファクトを支えるローカルおよび将来のデータソース。',
  'connectors.account': 'アカウント',
  'connectors.noAccount': '未接続',
  'connectors.tools': 'ツール',
  'connectors.connect': '接続',
  'connectors.disconnect': '接続解除',
  'connectors.authorizationPending': '認証を待機しています…',
  'connectors.authorizationPendingHint': '開いたウィンドウで認証を完了してください。',
  'connectors.cancelAuthorization': 'キャンセル',
  'connectors.configure': '設定',
  'connectors.unavailable': '利用不可',
  'connectors.phaseStubTitle': 'コネクター API はフェーズ 3 で提供されます。これはプレビュー画面です。',
  'connectors.statusAvailable': '利用可能',
  'connectors.statusConnected': '接続済み',
  'connectors.statusError': 'エラー',
  'connectors.statusDisabled': '無効',
  'connectors.gateTitle': '続行するには Composio API key を追加してください',
  'connectors.gateBody': '上にキーを貼り付けて「キーを保存」をクリックすると、利用可能な連携が読み込まれます。',
  'connectors.aboutLabel': '概要',
  'connectors.detailsLabel': '詳細',
  'connectors.statusLabel': 'ステータス',
  'connectors.category.aiAgents': 'AI Agent',
  'connectors.category.aiInfrastructure': 'AI インフラ',
  'connectors.category.accounting': '会計',
  'connectors.category.admin': '管理',
  'connectors.category.advertising': '広告',
  'connectors.category.analytics': 'アナリティクス',
  'connectors.category.automation': '自動化',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'カレンダー',
  'connectors.category.commerce': 'コマース',
  'connectors.category.communication': 'コミュニケーション',
  'connectors.category.contacts': '連絡先',
  'connectors.category.dataPlatform': 'データプラットフォーム',
  'connectors.category.database': 'データベース',
  'connectors.category.design': 'デザイン',
  'connectors.category.developer': '開発者',
  'connectors.category.documentation': 'ドキュメント',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': '教育',
  'connectors.category.email': 'メール',
  'connectors.category.events': 'イベント',
  'connectors.category.fieldService': 'フィールドサービス',
  'connectors.category.finance': 'ファイナンス',
  'connectors.category.fitness': 'フィットネス',
  'connectors.category.forms': 'フォーム',
  'connectors.category.gaming': 'ゲーム',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'ホスピタリティ',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': '連携',
  'connectors.category.localization': 'ローカライゼーション',
  'connectors.category.logistics': 'ロジスティクス',
  'connectors.category.maps': 'マップ',
  'connectors.category.marketing': 'マーケティング',
  'connectors.category.media': 'メディア',
  'connectors.category.meetings': '会議',
  'connectors.category.nonprofit': '非営利',
  'connectors.category.observability': 'オブザーバビリティ',
  'connectors.category.payments': '決済',
  'connectors.category.personal': '個人',
  'connectors.category.presentations': 'プレゼンテーション',
  'connectors.category.procurement': '調達',
  'connectors.category.product': 'プロダクト',
  'connectors.category.productivity': '生産性',
  'connectors.category.projectManagement': 'プロジェクト管理',
  'connectors.category.recruiting': '採用',
  'connectors.category.research': 'リサーチ',
  'connectors.category.salesIntelligence': 'セールスインテリジェンス',
  'connectors.category.scheduling': 'スケジューリング',
  'connectors.category.search': '検索',
  'connectors.category.security': 'セキュリティ',
  'connectors.category.signing': '署名',
  'connectors.category.social': 'ソーシャル',
  'connectors.category.spreadsheets': 'スプレッドシート',
  'connectors.category.storage': 'ストレージ',
  'connectors.category.support': 'サポート',
  'connectors.category.surveys': 'アンケート',
  'connectors.category.tasks': 'タスク',
  'connectors.category.timeTracking': '時間追跡',
  'connectors.category.video': '動画',
  'connectors.category.whiteboard': 'ホワイトボード',
  'connectors.categoryLabel': 'カテゴリ',
  'connectors.providerLabel': 'プロバイダー',
  'connectors.toolsSection': 'ツール',
  'connectors.toolsLoading': 'ツールを読み込み中…',
  'connectors.noToolsAvailable': '利用可能なツールはまだありません。接続して、この連携が公開する内容を確認してください。',
  'connectors.toolDetailsUnavailable': 'ツールの詳細は利用できませんが、このコネクターは {n} 個のツールを報告しています。',
  'connectors.loadMoreTools': 'さらにツールを読み込む',
  'connectors.openDetailsAria': '{name} の詳細を開く',
  'connectors.toolsBadgeNone': 'ツールなし',
  'connectors.toolsBadgeOne': '{n} 個のツール',
  'connectors.toolsBadgeMany': '{n} 個のツール',
  'connectors.searchPlaceholder': 'コネクターを検索…',
  'connectors.searchAriaLabel': '名前、プロバイダー、ツールでコネクターを検索',
  'connectors.searchClear': '検索をクリア',
  'connectors.emptyNoMatchTitle': '「{query}」に一致するコネクターはありません',
  'connectors.emptyNoMatchBody': '別のキーワードをお試しいただくか、検索をクリアしてカタログ全体を参照してください。',
  'connectors.emptyNoMatchAction': '検索をクリア',
  'newproj.tabPrototype': 'プロトタイプ',
  'newproj.tabLiveArtifact': 'ライブアーティファクト',
  'newproj.tabDeck': 'スライド',
  'newproj.tabTemplate': 'テンプレートから',
  'newproj.tabMedia': 'メディア',
  'newproj.tabOther': 'その他',
  'newproj.titlePrototype': '新しいプロトタイプ',
  'newproj.titleLiveArtifact': '新しいライブアーティファクト',
  'newproj.titleDeck': '新しいスライドデッキ',
  'newproj.titleTemplate': 'テンプレートから開始',
  'newproj.titleImage': '新しい画像',
  'newproj.titleVideo': '新しい動画',
  'newproj.titleAudio': '新しい音声',
  'newproj.titleMedia': '新しいメディア',
  'newproj.titleOther': '新しいプロジェクト',
  'newproj.namePlaceholder': 'プロジェクト名',
  'newproj.fidelityLabel': '品質',
  'newproj.fidelityWireframe': 'ワイヤーフレーム',
  'newproj.fidelityHigh': '高品質',
  'newproj.toggleSpeakerNotes': 'スピーカーノートを使用',
  'newproj.toggleSpeakerNotesHint': 'スライドのテキストを減らし、話す内容をノートに残します。',
  'newproj.toggleAnimations': 'アニメーションを含める',
  'newproj.toggleAnimationsHint': 'テンプレートにモーション（入場・ホバー・トランジション）を追加します。',
  'newproj.targetPlatformsLabel': 'ターゲットプラットフォーム',
  'newproj.targetPlatformsHint': '1つ以上選択してください。Responsive web はブラウザのブレークポイントのみに対応します。ネイティブのクロスプラットフォーム版が必要な場合は、iOS、Android、タブレットアプリ、デスクトップアプリを追加してください。',
  'newproj.platform.responsive.label': 'レスポンシブ Web',
  'newproj.platform.responsive.hint': 'デスクトップ、タブレット、モバイルのブラウザに対応した1つのウェブ体験',
  'newproj.platform.webDesktop.label': 'デスクトップ Web',
  'newproj.platform.webDesktop.hint': 'ブラウザを主体とするプロダクトまたはランディングページ',
  'newproj.platform.mobileIos.label': 'iOS アプリ',
  'newproj.platform.mobileIos.hint': 'iPhone のフレームと iOS のインタラクションルール',
  'newproj.platform.mobileAndroid.label': 'Android アプリ',
  'newproj.platform.mobileAndroid.hint': 'Pixel のフレームと Material のインタラクションルール',
  'newproj.platform.tablet.label': 'タブレットアプリ',
  'newproj.platform.tablet.hint': '分割ビューを備えたネイティブ風のタブレット体験',
  'newproj.platform.desktopApp.label': 'デスクトップアプリ',
  'newproj.platform.desktopApp.hint': 'macOS/Windows のアプリクローム',
  'newproj.surfaceOptionsLabel': 'コンパニオンサーフェス',
  'newproj.includeLandingPage': 'ランディングページを含める',
  'newproj.includeLandingPageHint': '広告、ウェイトリスト、ローンチキャンペーン、アプリのダウンロード、プロダクト説明のためのレスポンシブなマーケティングページを追加します。',
  'newproj.includeOsWidgets': 'OS ウィジェットを含める',
  'newproj.includeOsWidgetsHint': 'モバイル/タブレットアプリ向けに、プラットフォームネイティブのホーム画面、ロック画面、クイックアクセスウィジェットを追加します。',
  'newproj.includeOsWidgetsDisabledHint': 'ターゲットプラットフォームとして iOS、Android、またはタブレットアプリを選択すると利用できます。',
  'newproj.templateLabel': 'テンプレート',
  'newproj.noTemplatesTitle': 'テンプレートがまだありません',
  'newproj.noTemplatesBody': 'プロジェクトを開き、ファイルビューア内の共有メニューからテンプレートに変換してください。テンプレートはここに表示されます。',
  'newproj.savedTemplate': '保存済みテンプレート',
  'newproj.fileSingular': 'ファイル',
  'newproj.filePlural': 'ファイル',
  'newproj.create': '作成',
  'newproj.locationLabel': '保存先',
  'newproj.locationDefault': 'Open Design プロジェクト',
  'newproj.locationExternalBase': '外部ベース',
  'newproj.createLiveArtifact': 'ライブアーティファクトを作成',
  'newproj.createFromTemplate': 'テンプレートから作成',
  'newproj.createDisabledTitle': '最初にプロジェクトをテンプレートとして保存してください（プロジェクト内の共有メニュー）。',
  'newproj.importClaudeZip': 'Claude Design ZIP をインポート',
  'newproj.importClaudeZipTitle': 'Claude Design の .zip エクスポートをインポート',
  'newproj.importingClaudeZip': 'インポート中…',
  'newproj.privacyFooter': 'デフォルトではあなただけがプロジェクトを見ることができます。',
  'newproj.designSystem': 'デザインシステム',
  'newproj.dsNoneFreeform': 'なし — フリーフォーム',
  'newproj.dsNoneSubtitleEmpty': 'システムトークンなし、独自のパレットを選択',
  'newproj.dsNoneSubtitleSelected': 'システムトークンをスキップ。エージェントが独自のパレットを選択します。',
  'newproj.dsCategoryFallback': 'デザインシステム',
  'newproj.dsSearch': 'デザインシステムを検索…',
  'newproj.dsModeAria': '選択モード',
  'newproj.dsModeSingle': 'シングル',
  'newproj.dsModeMulti': 'マルチ',
  'newproj.dsNoneTitle': 'なし — フリーフォーム',
  'newproj.dsNoneSub': 'システムトークンをスキップ。エージェントが独自のパレットを選択します。',
  'newproj.dsEmpty': '"{query}" に一致するデザインシステムがありません。',
  'newproj.dsFootSingular': 'はインスピレーションのみです。',
  'newproj.dsFootPlural': 'はインスピレーションのみです。',
  'newproj.dsFootClear': 'クリア',
  'newproj.dsBadgeDefault': 'デフォルト',
  'newproj.dsPrimaryFallback': 'プライマリ',
  'newproj.surfaceImage': '画像',
  'newproj.surfaceVideo': '動画',
  'newproj.surfaceAudio': '音声',
  'newproj.modelLabel': 'モデル',
  'newproj.modelSearch': 'モデルを検索…',
  'newproj.modelEmpty': '一致するモデルがありません。',
  'newproj.modelRecommended': '推奨',
  'newproj.modelMissingTitle': 'モデルを選択',
  'newproj.modelMissingSub': 'このサーフェスに使うモデルを選択します。',
  'newproj.aspectLabel': 'アスペクト',
  'newproj.videoLengthLabel': '長さ',
  'newproj.videoLengthSeconds': '{n}秒',
  'newproj.audioKindLabel': '音声タイプ',
  'newproj.audioKindMusic': '音楽',
  'newproj.audioKindSpeech': 'スピーチ / TTS',
  'newproj.audioKindSfx': '効果音',
  'newproj.audioDurationLabel': '長さ',
  'newproj.audioDurationSeconds': '{n}秒',
  'newproj.voiceLabel': '音声',
  'newproj.voicePlaceholder': 'プロバイダーの音声 ID（省略可）',
  'newproj.connectorsLabel': 'コネクタ',
  'newproj.connectorsHint': 'このアーティファクトがデータを取得できるデータソース。',
  'newproj.connectorsEmptyTitle': 'コネクタが設定されていません',
  'newproj.connectorsEmptyBody': 'データソースを接続すると、ライブアーティファクトがプレースホルダーではなく実際の数値を取得できるようになります。',
  'newproj.connectorsEmptyCta': 'コネクターを設定 →',
  'newproj.connectorsLoading': 'コネクターを読み込み中…',
  'newproj.connectorsCountOne': '{n} 件接続済み',
  'newproj.connectorsCountMany': '{n} 件接続済み',
  'newproj.connectorsManage': '管理',
  'newproj.promptTemplateLabel': '参照テンプレート',
  'newproj.promptTemplateNoneTitle': 'なし — 自分で書く',
  'newproj.promptTemplateNoneSub': 'ギャラリーをスキップして、自分でブリーフを書きます',
  'newproj.promptTemplateRefSub': '参照テンプレート',
  'newproj.promptTemplateSearch': 'テンプレートを検索…',
  'newproj.promptTemplateEmpty': 'この種類のテンプレートはまだインストールされていません。',
  'newproj.promptTemplateBodyLabel': 'プロンプト（編集可能）',
  'newproj.promptTemplateOptimizeHint': '自由に編集できます — 変更内容はエージェントのブリーフに反映されます。',
  'newproj.promptTemplateBodyEmpty': '本文が空です — エージェントはテンプレート参照を受け取りません。',
  'newproj.deleteTemplateTitle': 'テンプレートを削除',
  'newproj.deleteTemplateConfirm': '"{name}" を削除しますか？この操作は取り消せません。',
  'newproj.deleteTemplateConfirmCta': 'テンプレートを削除',
  'newproj.deleteTemplateError': 'テンプレートを削除できませんでした。もう一度お試しください。',
  'designs.subRecent': '最近',
  'designs.subYours': 'あなたのデザイン',
  'designs.filterAria': 'プロジェクトをフィルター',
  'designs.searchPlaceholder': '検索…',
  'designs.emptyNoProjects': 'プロジェクトがまだありません。',
  'designs.emptyNoMatch': '検索に一致するプロジェクトがありません。',
  'designs.deleteTitle': 'プロジェクトを削除',
  'designs.deleteConfirm': '"{name}" を削除しますか？',
  'designs.cardFreeform': 'フリーフォーム',
  'designs.badgeLive': 'ライブ',
  'designs.liveArtifactBadgesAria': 'ライブアーティファクトのバッジ',
  'designs.liveCount': '{n} 件ライブ',
  'designs.statusLive': 'ライブアーティファクト',
  'designs.statusArchived': 'アーカイブ済み',
  'designs.statusError': 'エラー',
  'designs.statusRefreshing': '更新中…',
  'designs.statusRefreshFailed': '更新に失敗しました',
  'designs.statusRefreshed': '更新しました',
  'designs.status.notStarted': '未開始',
  'designs.status.queued': 'キュー中',
  'designs.status.running': '実行中',
  'designs.status.awaitingInput': '入力待ち',
  'designs.status.succeeded': '完了',
  'designs.status.published': '公開済み',
  'designs.status.failed': '失敗',
  'designs.status.canceled': 'キャンセル済み',
  'designs.viewToggleAria': '表示モード',
  'designs.viewGrid': 'グリッド表示',
  'designs.viewKanban': 'ボード表示',
  'designs.kanbanEmptyColumn': 'デザインなし',
  'designs.deleteAria': 'プロジェクト {name} を削除',
  'designs.menuMore': 'その他の操作',
  'designs.menuRename': '名前を変更',
  'designs.menuDelete': '削除',
  'designs.renamePrompt': '「{name}」の新しい名前',
  'designs.selectMode': '選択',
  'designs.cancelSelect': 'キャンセル',
  'designs.deleteSelected': '選択した項目を削除',
  'designs.selectedCount': '{n} 件選択中',
  'designs.deleteSelectedConfirm': '{n} 件のプロジェクトを削除しますか？',
  'designs.deleteSelectedSuccess': '{n} 件のプロジェクトを削除しました。',
  'designs.deleteSelectedPartial': '{deleted} 件のプロジェクトを削除しました（{failed} 件は失敗）。',
  'designs.tagPrototype': 'プロトタイプ',
  'designs.tagLiveArtifact': 'ライブアーティファクト',
  'designs.tagSlide': 'スライド',
  'designs.tagMedia': 'メディア',
  'designs.renameTitle': 'プロジェクト名を変更',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'キャンセル',
  'examples.typeLabel': 'タイプ',
  'examples.surfaceLabel': 'サーフェス',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': '画像',
  'examples.surfaceVideo': '動画',
  'examples.surfaceAudio': '音声',
  'examples.scenarioLabel': 'シナリオ',
  'examples.modeAll': 'すべて',
  'examples.modePrototypeDesktop': 'プロトタイプ · デスクトップ',
  'examples.modePrototypeMobile': 'プロトタイプ · モバイル',
  'examples.modeDeck': 'スライド',
  'examples.modeDocument': 'ドキュメント & テンプレート',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'ライブ',
  'examples.scenarioGeneral': '一般',
  'examples.scenarioEngineering': 'エンジニアリング',
  'examples.scenarioProduct': 'プロダクト',
  'examples.scenarioDesign': 'デザイン',
  'examples.scenarioMarketing': 'マーケティング',
  'examples.scenarioSales': 'セールス',
  'examples.scenarioFinance': 'ファイナンス',
  'examples.scenarioHr': '人事',
  'examples.scenarioOperations': 'オペレーション',
  'examples.scenarioSupport': 'サポート',
  'examples.scenarioLegal': '法務',
  'examples.scenarioEducation': '教育',
  'examples.scenarioPersonal': '個人',
  'examples.searchPlaceholder': 'サンプルを検索…',
  'examples.searchAria': '名前でサンプルを検索',
  'examples.emptyNoSkills': 'スキルがありません。デーモンは起動していますか？',
  'examples.emptyNoMatch': 'このフィルターに一致するサンプルがありません。',
  'examples.openPreview': '⤢ プレビューを開く',
  'examples.loadingPreview': 'プレビューを読み込み中…',
  'examples.hoverPreview': 'ホバーでプレビュー',
  'examples.usePrompt': 'このプロンプトを使用',
  'examples.previewModalTitle': 'フルプレビューを開く（モーダル）',
  'examples.shareTitle': 'このサンプルを共有',
  'examples.shareLoadFirst': 'プレビューを読み込むためにホバーしてください',
  'examples.unavailablePlaceholder': '{kind} プレビューは同梱されていません — 詳細は開いて確認',
  'examples.shareUnavailable': '共有できる {kind} プレビューは同梱されていません',
  'examples.shareMenu': '共有 ▾',
  'examples.exportPdfAllSlides': 'PDFとしてエクスポート（全スライド）',
  'examples.exportPptxLocked': 'PPTXとしてエクスポート…（先にテンプレートを開いてください）',
  'examples.tagSlideDeck': 'スライドデッキ',
  'examples.tagTemplate': 'テンプレート',
  'examples.tagDesignSystem': 'デザインシステム',
  'examples.tagMobilePrototype': 'モバイルプロトタイプ',
  'examples.tagDesktopPrototype': 'デスクトッププロトタイプ',
  'examples.tagImage': '画像',
  'examples.tagVideo': '動画',
  'examples.tagAudio': '音声',
  'examples.previewLabel': 'プレビュー',
  'ds.surfaceLabel': 'サーフェス',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': '画像',
  'ds.surfaceVideo': '動画',
  'ds.surfaceAudio': '音声',
  'ds.searchPlaceholder': 'デザインシステムを検索…',
  'ds.emptyNoMatch': '検索に一致するデザインシステムがありません。',
  'ds.badgeDefault': 'デフォルト',
  'ds.preview': 'プレビュー',
  'ds.previewTitle': 'デザインシステムをプレビュー',
  'ds.categoryAll': 'すべて',
  'ds.categoryUncategorized': '未分類',
  'ds.showcase': 'ショーケース',
  'ds.tokens': 'トークン',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md を読み込み中…',
  'avatar.title': 'アカウントと設定',
  'avatar.localCli': 'ローカル CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'ローカル CLI を使用',
  'avatar.useApi': 'API · BYOK を使用',
  'avatar.codeAgent': 'コードエージェント',
  'avatar.rescan': 'PATH を再スキャン',
  'avatar.amrConsole': 'AMR アカウント',
  'avatar.amrConsoleMeta': '残高とチャージ',
  'avatar.settings': '設定',
  'avatar.backToProjects': 'プロジェクトに戻る',
  'avatar.metaActive': 'アクティブ',
  'avatar.metaOffline': 'オフライン',
  'avatar.metaSelected': '選択中',
  'avatar.noAgentSelected': 'エージェント未選択',
  'avatar.modelSection': 'モデル',
  'avatar.modelLabel': 'モデル',
  'avatar.reasoningLabel': '推論',
  'avatar.customSuffix': '（カスタム）',
  'socialShare.openDesignSection': 'Open Design を共有',
  'socialShare.openDesignTitle': 'GitHub の Open Design',
  'socialShare.openDesignText': 'Open Design は、デザイン成果物の作成・編集・デプロイ・引き継ぎを行うためのオープンソースのワークスペースです。',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'ソーシャル共有',
  'socialShare.publishPageTitle': '共有ページを公開',
  'socialShare.publishPageSubtitle': 'このプレビューを公開して、ソーシャルプラットフォームで共有できるようにします。',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Open Design で作成: {title}。デプロイされた成果物を見て、リポジトリにスターを付けてください: {repo}',
  'socialShare.projectCopyText': 'Open Design で作成: {title}\n{url}\nOpen Design リポジトリ: {repo}',
  'socialShare.deployFirst': 'デプロイして共有…',
  'socialShare.copied': 'コピーしました',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': '小紅書',
  'inlineSwitcher.chipTitle': 'CLI / モデルを切り替え',
  'inlineSwitcher.chipCli': 'ローカル CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'デフォルト',
  'inlineSwitcher.noAgent': 'エージェント未選択',
  'inlineSwitcher.modeLabel': 'モード',
  'inlineSwitcher.agentLabel': 'エージェント',
  'inlineSwitcher.providerLabel': 'プロバイダー',
  'inlineSwitcher.modelLabel': 'モデル',
  'inlineSwitcher.useCli': 'ローカル CLI を使用',
  'inlineSwitcher.useByok': '自分の API キーを使用',
  'inlineSwitcher.daemonOffline': 'デーモンがオフライン — 設定を開く',
  'inlineSwitcher.noAgentsDetected': 'PATH に CLI が見つかりません',
  'inlineSwitcher.openSettingsForModel': '設定でプロバイダーを構成してください',
  'inlineSwitcher.missingApiKey': 'API キー未設定 — 設定から追加してください。',
  'inlineSwitcher.openFullSettings': '実行設定を開く',
  'inlineSwitcher.customSuffix': '（カスタム）',
  'project.backToProjects': 'プロジェクトに戻る',
  'project.metaFreeform': 'フリーフォーム',
  'project.customInstructions': 'プロジェクト指示',
  'project.customInstructionsPlaceholder': 'このプロジェクトへの指示（すべてのメッセージに挿入されます）…',
  'project.resizeChatPanel': 'チャットパネルのサイズを変更',
  'project.instructionsActive': '有効 — すべてのメッセージに含まれます',
  'chat.tabChat': 'チャット',
  'chat.tabComments': 'コメント',
  'chat.commentsSoon': 'コメント — 近日公開',
  'chat.comments.attached': 'チャットに添付済み',
  'chat.comments.emptyAttached': '添付されたコメントはありません。',
  'chat.comments.saved': '保存済みコメント',
  'chat.comments.emptySaved': '保存されたコメントはありません。',
  'chat.comments.add': '追加',
  'chat.comments.addAll': 'すべて追加',
  'chat.comments.remove': '削除',
  'chat.comments.placeholder': 'この要素にコメント…',
  'chat.comments.addSend': '追加して送信',
  'chat.comments.updateSend': '更新して送信',
  'chat.comments.removeAttachment': 'コメントの添付を削除',
  'chat.comments.removeAttachmentAria': '{name} のコメント添付を削除',
  'chat.comments.comment': 'コメント',
  'chat.comments.sendToChat': 'チャットに送信',
  'chat.comments.sending': '送信中…',
  'chat.comments.edit': '編集',
  'chat.comments.select': '選択',
  'chat.comments.selectAll': 'すべて選択',
  'chat.comments.deselect': '選択解除',
  'chat.comments.nSelected': '{n} 件選択中',
  'chat.comments.pin': 'ピン留め',
  'chat.comments.addNote': 'メモを追加',
  'chat.comments.savedToast': 'コメントを保存しました',
  'chat.comments.pinSavedToast': 'ピンを保存しました',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} 件のキャプチャ項目',
  'chat.comments.clear': 'クリア',
  'chat.comments.targetImage': '画像',
  'chat.comments.targetControl': 'コントロール',
  'chat.comments.targetLink': 'リンク',
  'chat.comments.targetText': 'テキスト',
  'chat.comments.targetSection': 'セクション',
  'chat.comments.targetPage': 'ページ',
  'chat.comments.targetArea': 'エリア',
  'chat.annotationNotePlaceholder': 'このマークにメモを追加',
  'chat.annotationAttachImage': '画像を添付',
  'chat.annotationAttachedImages': '添付した画像',
  'chat.annotationAttachedRemove': '最後の画像を削除',
  'chat.annotationAddToInput': '入力に追加',
  'chat.annotationAddingToInput': '追加中...',
  'chat.annotationQueue': 'キューに追加',
  'chat.annotationQueueing': 'キューに追加中...',
  'chat.annotationSending': '送信中...',
  'chat.annotationSendDisabledReason': 'タスクが実行中です',
  'chat.annotationPreviewMissing': 'プレビューをキャプチャできませんでした。もう一度お試しください。',
  'chat.annotationPreviewMissingInk': 'プレビューをキャプチャできませんでした。インクのみの送信を避けるため、もう一度お試しください。',
  'chat.annotationSentWithoutScreenshot': 'プレビューをキャプチャできませんでした。注釈はスクリーンショットなしで送信されました。',
  'chat.annotationTimeout': '注釈の送信がタイムアウトしました。もう一度お試しください。',
  'chat.annotationFailed': '注釈の送信に失敗しました。もう一度お試しください。',
  'chat.annotationProjectCreateFailed': 'プロジェクトを作成できなかったため、注釈は送信されませんでした。',
  'chat.annotationUploadFailed': '添付ファイルのアップロードに失敗しました。もう一度お試しください。',
  'chat.conversationsTitle': '会話',
  'chat.conversationsAria': '会話履歴',
  'chat.newConversation': '新しい会話',
  'chat.newConversationsTitle': '新しい会話',
  'chat.conversationsHeading': '会話',
  'chat.new': '新規',
  'chat.emptyConversations': 'まだ会話がありません。',
  'chat.deleteConversation': '会話を削除',
  'chat.renameConversationLabel': '「{title}」の名前を変更',
  'chat.deleteConversationConfirm': '"{title}" を削除しますか？メッセージも削除されます。',
  'chat.untitledConversation': '無題の会話',
  'chat.forkedConversationTitle': '{title} のフォーク',
  'chat.forkConversationFailed': 'この会話をフォークできませんでした。',
  'chat.startTitle': '会話を始める',
  'chat.startHint': '生成したい内容を説明するか、以下の例から始めてください:',
  'chat.fillInputTitle': 'クリックして入力欄に入力',
  'chat.jumpToLatest': '最新にジャンプ',
  'chat.scrollToLatest': '最新にスクロール',
  'chat.you': 'あなた',
  'chat.openFile': '{name} を開く',
  'chat.copyPrompt': 'プロンプトをコピー',
  'chat.copyErrorDiagnostic': 'エラー診断をコピー',
  'chat.copyDone': 'コピーしました！',
  'chat.inspect.noEditableTargets': '編集可能なテキストまたはスタイルの対象が見つかりません。',
  'chat.inspect.noCommentTargets': 'コメント可能なテキストまたはビジュアルの対象が見つかりません。',
  'chat.inspect.editHint': '編集するには、プレビューでテキストまたはスタイルの対象を選択してください。',
  'chat.inspect.commentHint': 'コメントするには、プレビューでテキストまたは領域を選択してください。',
  'chat.composerPlaceholder': '生成したい内容を説明してください…',
  'chat.activeFileEditingLabel': '編集中',
  'chat.activeFilePlaceholder': 'Open Design に {file} の変更を依頼...',
  'chat.designArtifactsShowMore': 'さらに {count} 個のデザインファイルを表示',
  'chat.mode.chat.label': '質問',
  'chat.mode.chat.title': 'Ask モード',
  'chat.mode.chat.summary': 'デザイン成果物の作成を前提にせず、すばやい回答、修正、計画、相談に使えます。',
  'chat.mode.chat.solves': 'アイデアの整理、プロンプト改善、選択肢の比較、既存作業への質問に向いています。',
  'chat.mode.chat.query1': 'このドラフトを要約して、足りない点を教えて。',
  'chat.mode.chat.query2': 'このランディングページに最適な構成を一緒に決めて。',
  'chat.mode.chat.query3': 'このデザインをレビューして、具体的な改善案を出して。',
  'chat.mode.design.label': 'デザイン',
  'chat.mode.design.title': 'Design モード',
  'chat.mode.design.summary': 'ページ、プロトタイプ、ライブ成果物、スライド、画像、動画、HyperFrames、音声、ダッシュボード、プロジェクトファイルなど具体的な出力を作成または変更します。',
  'chat.mode.design.solves': 'Open Design にファイル生成、workspace 更新、brief からマルチモーダルな成果物への変換を任せたいときに使います。',
  'chat.mode.design.query1': 'この brief から製品ローンチ用ランディングページと HyperFrames プロトタイプを作って。',
  'chat.mode.design.query2': 'スピーカーノート付きの10枚の投資家向けデッキを作って。',
  'chat.mode.design.query3': 'このキャンペーン向けに画像、動画、音声のコンセプトを生成して。',
  'chat.mode.cardBestFor': '向いている用途',
  'chat.mode.cardTry': '質問例',
  'chat.composerHint': '⌘/Ctrl + Enter で送信 · 目的、内容、スタイル、形式を含める',
  'chat.cliSettingsTitle': 'CLI とモデルの設定',
  'chat.cliSettingsAria': 'CLI とモデルの設定を開く',
  'chat.attachTitle': 'ファイルを添付（または貼り付け / ドロップ）',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'ファイルを添付',
  'chat.importTitle': 'ソースをインポート（近日公開）',
  'chat.importLabel': 'インポート',
  'chat.importComingSoon': '近日公開',
  'chat.importSoon': '近日',
  'chat.importFig': '.fig ファイルをアップロード',
  'chat.importGitHub': 'GitHub に接続',
  'chat.importWeb': 'Web 要素を取得',
  'chat.importFolder': 'コードフォルダーをリンク',
  'chat.importSkills': 'スキルとデザインシステム',
  'chat.importProject': '別のプロジェクトを参照',
  'chat.importDesignSystemHeader': 'デザインシステムを選択',
  'chat.importDesignSystemBack': '戻る',
  'chat.importDesignSystemSearch': 'デザインシステムを検索…',
  'chat.importDesignSystemEmpty': '"{query}" に一致するデザインシステムはありません',
  'chat.importDesignSystemNone': '指定なし — フリーフォーム',
  'chat.importDesignSystemNoneSub': '今回はどのシステムにも合わせない',
  'chat.importDesignSystemActive': '現在',
  'chat.importDesignSystemSwitched': 'デザインシステムを {title} に切り替えました',
  'chat.importDesignSystemFailed': 'デザインシステムを切り替えられませんでした。もう一度お試しください。',
  'chat.importDesignSystemLoadFailed': 'デザインシステムを読み込めませんでした。',
  'browserUse.title': 'インスピレーション',
  'browserUse.summary': '{count} 件の Web アクション。アセット抽出、デザイン言語、モーション、ビジュアルチェック、コンポーネント構造を優先します。',
  'browserUse.searchAria': 'インスピレーションを検索',
  'browserUse.searchPlaceholder': 'スクリーンショット、フォント、カラー、a11y を検索…',
  'browserUse.empty': '一致するインスピレーションがありません',
  'browserUse.unavailable': 'ここではインスピレーションを利用できません',
  'browserUse.added': 'コンポーザーに追加しました',
  'browserUse.category.assets': 'アセット抽出',
  'browserUse.category.tokens': 'デザイン言語',
  'browserUse.category.motion': 'モーション',
  'browserUse.category.visual': 'ビジュアルチェック',
  'browserUse.category.structure': 'コンポーネント',
  'browserUse.category.project': 'プロジェクト実行',
  'browserUse.category.general': '一般',
  'browserUse.input.none': '入力なし',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'セレクター（任意）',
  'browserUse.input.requirementSelector': '要件、セレクター（任意）',
  'browserUse.input.selectorOptional': 'セレクター（任意）',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'セレクター、scale=2',
  'browserUse.input.gridOverlay': '12 カラム、最大 1200、ギャップ 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL、ドメイン、または検索キーワード',
  'browserUse.input.selector': 'セレクター',
  'browserUse.input.selectorText': 'セレクターとテキスト',
  'browserUse.input.scroll': 'ピクセル、top、bottom、または page',
  'browserUse.input.terminalRun': 'コマンド、タイムアウト 120 秒',
  'browserUse.input.command': 'コマンド',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'ヘッダー、ナビ、クラス名、位置、OG 画像、favicon フォールバックから抽出した最適なロゴ候補。',
  'browserUse.action.list_images.output': 'すべての img、srcset、source、CSS 背景画像を寸法と alt テキストとともに取得。',
  'browserUse.action.download_assets.output': 'ダウンロードしたアセットフォルダと、referer・cookie に対応した _manifest.json。',
  'browserUse.action.extract_svgs.output': 'インライン SVG とリンクされた .svg ファイルを個別の SVG ファイルとして保存。',
  'browserUse.action.optimize_svgs.output': '最適化された SVG ファイルと圧縮率。',
  'browserUse.action.extract_colors.output': '重み付けされたパレットと :root の CSS カラー変数を palette.json および palette.html として出力。',
  'browserUse.action.extract_fonts.output': '主要なフォントファミリー、サイズ、ウェイト、@font-face ルールを typography.json として出力。',
  'browserUse.action.extract_design_tokens.output': '角丸、シャドウ、スペーシング、CSS 変数を tokens.json として出力。',
  'browserUse.action.extract_type_scale.output': '見出し、本文、ボタンのタイプスケールをサイズ、ウェイト、行の高さ、比率とともに出力。',
  'browserUse.action.extract_buttons.output': '重複を除いたボタンスタイルライブラリを buttons.html および buttons.json として出力。',
  'browserUse.action.extract_grid_system.output': 'グリッドおよび flex コンテナ、方向、ギャップ、カラム、最大幅を layout.json として出力。',
  'browserUse.action.extract_breakpoints.output': 'レスポンシブのメディアクエリブレークポイントを breakpoints.json として出力。',
  'browserUse.action.extract_gradients.output': 'CSS グラデーションを gradients.css、gradients.json、プレビュー HTML として出力。',
  'browserUse.action.extract_shadows.output': 'ボックスシャドウ、テキストシャドウ、ドロップシャドウを shadows.json およびプレビューとして出力。',
  'browserUse.action.extract_easings.output': 'トランジションおよびアニメーションのイージング関数を easings.json として出力。',
  'browserUse.action.export_tokens.output': 'tokens.css、tokens.scss、tailwind.theme.js、style-dictionary.tokens.json。',
  'browserUse.action.extract_animations.output': '@keyframes、transition および transform ルール、検出されたモーションライブラリ、motion.css、motion.json。',
  'browserUse.action.validate_view.output': 'スクリーンショットのパスと、構造化されたビジュアルおよびレイアウトの問題。',
  'browserUse.action.audit_layout.output': 'オーバーフロー、境界、重なり、テキストの切れなどのレイアウト不具合を audit.json として出力。',
  'browserUse.action.audit_accessibility.output': 'セレクター、ラベル、ロール、フォーカス、コントラストを含む a11y の問題と、必要に応じたスクリーンショット。',
  'browserUse.action.responsive_screenshots.output': 'モバイル 390、タブレット 834、デスクトップ 1440 のスクリーンショット。',
  'browserUse.action.screenshot_full.output': 'ビューポートを超えたページ全体のスクリーンショット。',
  'browserUse.action.screenshot_element.output': 'デフォルトで 2x の単一要素スクリーンショット。',
  'browserUse.action.screenshot_with_grid.output': 'レイアウトグリッドを重ねたスクリーンショット。',
  'browserUse.action.screenshot_dark_mode.output': 'prefers-color-scheme: dark でのスクリーンショット。',
  'browserUse.action.generate_styleguide.output': 'カラー、タイプスケール、角丸、シャドウを含む1ページのスタイルガイド。',
  'browserUse.action.extract_html.output': 'script、noscript、インラインのイベント属性を含まない、クリーンで自己完結型のHTML。',
  'browserUse.action.extract_component_inventory.output': '繰り返し使われるコンポーネントのパターン、セレクター、件数、スクリーンショット。',
  'browserUse.action.extract_copy.output': '見出し、CTA、本文、説明文を copy.md および copy.json として出力。',
  'browserUse.action.extract_nav.output': '主要なナビゲーションとフッターのリンクを sitemap.md および nav.json として出力。',
  'browserUse.action.extract_forms.output': 'フォームのフィールド、ラベル、バリデーションのヒント、送信アクションを forms.json として出力。',
  'browserUse.action.run_project.output': '検出された開発サーバーのURLをBrowserタブで開きます。',
  'browserUse.action.detect_project.output': 'フレームワーク、パッケージマネージャー、インストールコマンド、開発コマンド、ポート。',
  'browserUse.action.page_info.output': 'URL、タイトル、説明、OG画像、テーマカラー、favicon、ビューポート。',
  'browserUse.action.snapshot.output': 'タグ、ラベル、href、座標を含む、表示中のインタラクティブ要素およびテキスト要素を最大120件。',
  'browserUse.action.navigate.output': 'ページを開き、page_info を返します。',
  'browserUse.action.click.output': '最初に一致した要素を表示位置までスクロールしてからクリックします。',
  'browserUse.action.type_text.output': '入力欄に入力し、input イベントと change イベントを発火させます。',
  'browserUse.action.scroll.output': '現在のスクロール位置と最大スクロール位置。',
  'browserUse.action.extract_og_metadata.output': 'メタタイトル、説明、正規URL、OG/Twitterカード、ソーシャル画像、テーマカラー。',
  'browserUse.action.terminal_run.output': 'stdout、stderr、終了コード。',
  'browserUse.action.terminal_run_background.output': 'バックグラウンドタスクのIDと最近の出力。',
  'browserUse.action.terminal_read.output': '共有ターミナルの最近の出力。',
  'chat.designToolbox.title': 'デザインツールボックス',
  'chat.designToolbox.tooltip': 'デザインツールボックス',
  'chat.designToolbox.aria': 'デザインツールボックスを開く',
  'chat.designToolbox.searchPlaceholder': 'スキル / MCP / プラグイン / コネクタ / デザインファイルを検索...',
  'chat.designToolbox.searchAria': 'デザインツールボックスのリソースを検索',
  'chat.designToolbox.followupSection': 'フォローアップ',
  'chat.designToolbox.resourcesSection': 'グローバルリソース',
  'chat.designToolbox.selected': '選択済み',
  'chat.designToolbox.noResources': '「{query}」に一致するリソースが見つかりません。',
  'chat.designToolbox.badge.video': '動画',
  'chat.designToolbox.badge.image': '画像',
  'chat.designToolbox.badge.motion': 'モーション',
  'chat.designToolbox.badge.polish': '仕上げ',
  'chat.designToolbox.action.auto-match.title': '次のステップをマッチ',
  'chat.designToolbox.action.auto-match.badge': 'マッチ',
  'chat.designToolbox.action.auto-match.description': 'まずテイストの基準を定義し、次にスキル、MCP、プラグイン、コネクタ、ファイルをマッチします。',
  'chat.designToolbox.action.motion.title': 'アニメーション／モーションを追加',
  'chat.designToolbox.action.motion.badge': 'モーション',
  'chat.designToolbox.action.motion.description': '現在のHTMLまたはページ要素に、登場・スクロール・状態遷移・マイクロインタラクションのモーションを追加します。',
  'chat.designToolbox.action.motion-polish.title': 'モーションを仕上げる',
  'chat.designToolbox.action.motion-polish.badge': 'タイミング',
  'chat.designToolbox.action.motion-polish.description': '既存のモーションについて、タイミング、イージング、パフォーマンス、reduced-motionのフォールバックを確認します。',
  'chat.designToolbox.action.anti-ai-polish.title': 'AIっぽさを除去',
  'chat.designToolbox.action.anti-ai-polish.badge': 'テイスト',
  'chat.designToolbox.action.anti-ai-polish.description': 'テンプレート感、AIっぽいグラデーション、安っぽいカードの羅列、曖昧なコピーを取り除きます。',
  'chat.designToolbox.action.visual-polish.title': 'デザインの仕上げ／出荷準備',
  'chat.designToolbox.action.visual-polish.badge': '仕上げ',
  'chat.designToolbox.action.visual-polish.description': '視覚的な階層、タイポグラフィ、余白、レスポンシブ挙動、アクセシビリティ、納品品質を監査します。',
  'chat.designToolbox.action.image-gen.title': '画像／ビジュアルリファレンスを生成',
  'chat.designToolbox.action.image-gen.badge': '画像',
  'chat.designToolbox.action.image-gen.description': '現在のページ向けに、セクションのリファレンス、アセット、アイコン、ソーシャル画像、またはムードボードを生成します。',
  'chat.designToolbox.action.video-gen.title': '動画／モーションスクリプトを生成',
  'chat.designToolbox.action.video-gen.badge': '動画',
  'chat.designToolbox.action.video-gen.description': 'デザインを短い動画、Remotion／Hyperframesのストーリーボード、または生成可能なプロンプトに変換します。',
  'chat.designToolbox.kind.skill': 'スキル',
  'chat.designToolbox.kind.plugin': 'プラグイン',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCPテンプレート',
  'chat.designToolbox.kind.connector': 'コネクタ',
  'chat.designToolbox.kind.designFile': 'デザインファイル',
  'chat.designToolbox.context.browser': 'ブラウザ',
  'chat.designToolbox.context.designFiles': 'デザインファイル',
  'chat.designToolbox.context.designSystem': 'デザインシステム',
  'chat.designToolbox.context.folder': 'フォルダ',
  'chat.designToolbox.context.terminal': 'ターミナル',
  'chat.designToolbox.context.sideChat': 'サイドチャット',
  'chat.designToolbox.context.liveArtifact': 'ライブアーティファクト',
  'chat.designToolbox.context.file': 'ファイル',
  'chat.designToolbox.prompt.contextGeneric': '現在の対象: 現在開いているHTML／デザインファイル／Web要素。',
  'chat.designToolbox.prompt.contextSpecific': '現在のターゲット: {kind} · {label}。',
  'chat.designToolbox.prompt.preserveDraft': 'コンポーザーにすでにある意図を保持してください: {draft}',
  'chat.designToolbox.prompt.selectedSkill': '選択されたスキル: {skill}。今回のターンの主要なワークフローとして使用してください。',
  'chat.designToolbox.prompt.noSkill': '特定のスキルが一致しない場合は、まず利用可能なスキル、MCP、プラグイン、コネクタ、デザインファイルの中から最適な組み合わせを選んでください。',
  'chat.designToolbox.prompt.autoMatchIntro': 'クリエイティブディレクターのオーケストレーターとして振る舞い、デザインワークフローを完了してください:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. まず「優れたデザイン」とは何かを定義します: 対象オーディエンス、ビジネス目標、ブランドの雰囲気、スタイルの参考、情報密度、カラー/タイポグラフィ/モーション/アセットの基準、避けるべき AI/テンプレートのパターン。',
  'chat.designToolbox.prompt.autoMatchStep2': '2. 上記のリソースインデックス全体を検索してマッチさせてください。design toolboxの推奨だけに頼らず、有用な場合はスキル、MCP、プラグイン、コネクタ、デザインファイルを組み合わせてください。',
  'chat.designToolbox.prompt.autoMatchStep3': '3. 対象や美的基準がまだ不明確な場合は、有限の選択肢やフォーム形式のUIで誘導し、推奨デフォルトを含めてください。十分に明確であれば、次のステップを直接実行してください。',
  'chat.designToolbox.prompt.autoMatchStep4': '4. 次の順序でフローを完了してください: 診断 -> スタイルの方向性 -> リソースの選択 -> 具体的な編集／生成 -> 検証。各ステップで、なぜこれらのリソースを選んだか、次に何を確認する必要があるかを説明してください。',
  'chat.designToolbox.prompt.motion': '現在のHTML／ページ要素に高品質なモーションを追加してください: 最も有用な1〜2か所の登場・スクロール・状態遷移・マイクロインタラクションを選んでください。控えめに保ち、transform／opacityを優先し、prefers-reduced-motionのフォールバックを含めてください。',
  'chat.designToolbox.prompt.motionPolish': '既存のモーションのタイミング、イージング、パフォーマンス、アクセシビリティを確認・仕上げしてください。唐突で安っぽい、または可読性を損なうアニメーションを取り除き、必要に応じてより洗練されたタイムラインを使用してください。',
  'chat.designToolbox.prompt.antiAiPolish': 'AIっぽさを除去する仕上げを1回行ってください: テンプレート的なレイアウト、安っぽいグラデーション／グロー、意味のないカードの羅列、曖昧なコピーを取り除いてください。情報は保持し、本物のデザイナーが納品したように感じられるようにしてください。',
  'chat.designToolbox.prompt.visualPolish': 'このデザインを出荷準備が整うまで仕上げてください: 階層、タイポグラフィ、余白、レスポンシブ挙動、ボタンの状態、空／読み込み中／エラーの状態、アクセシビリティを確認し、最も重要な問題を直接修正してください。',
  'chat.designToolbox.prompt.imageGen': 'このデザインの次のビジュアルアセット計画を作成してください: セクションのリファレンス、ヒーローアセット、イラスト、アイコン、ソーシャル画像、またはムードボード。まずどの種類の画像が不足しているかを判断し、次に実行可能な生成プロンプト／ファイル計画を提示してください。',
  'chat.designToolbox.prompt.videoGen': 'このデザインを動画へ展開します。ショート動画の絵コンテ、Hyperframes / Remotion のフレーム構成、または Sora/fal にすぐ使えるプロンプトを作成します。既存の HTML / ページコンテンツを自然にショットへ変換する方法を優先します。',
  'chat.designToolbox.prompt.useSkill': '現在のデザインに {skill} を使用します。',
  'chat.designToolbox.prompt.skillInstruction': 'まず最適な次の目標を決め、その上で具体的なパスを1つ完了します。外部アセットや API に依存する場合は、実行可能なフォールバックを用意するか、こちらが提供すべきものを明示してください。',
  'chat.designToolbox.prompt.selectedResource': '選択中のリソース: {kind} · {title}（{id}）。',
  'chat.designToolbox.prompt.resourceDescription': 'リソースの説明: {description}',
  'chat.designToolbox.prompt.pluginResource': 'このプラグインを現在のデザインフローの主要コンテキストとして使用します。入力や GenUI を提供する場合は、必要に応じて選択をガイドします。対象に適さない場合は、より適切なグローバルリソースを選び、その理由を説明します。',
  'chat.designToolbox.prompt.mcpResource': '次のデザインステップではこの MCP 機能を優先します。外部アセット、Web キャプチャ、画像/動画生成、データが必要な場合は、まずそれで対応できるか判断し、その上で実行可能なプランを提示します。',
  'chat.designToolbox.prompt.mcpTemplateResource': 'この MCP は設定可能なテンプレートです。このデザインステップで最も有用なツールであればまずセットアップをガイドします。設定済みの代替手段があれば、その代替手段で続行します。',
  'chat.designToolbox.prompt.connectorResource': '実データ、アセット、アカウントのコンテンツ、または外部ワークフローへのアクセスが必要な場合は、このコネクターを使用します。使用前に、何を読み書きするかを説明し、必要に応じて確認を求めます。',
  'chat.designToolbox.prompt.fileResource': 'このデザインファイルを現在のデザイン対象または参照アセットとして使用し、そこから次のステップを完了します。他のファイルとの比較が必要な場合は、すべてのデザインファイルを横断して検索を続けます。',
  'chat.designToolbox.prompt.resourceIndex': 'グローバルリソースインデックス: スキル({skills})、プラグイン({plugins})、MCP({mcpEnabled} 件有効 / {mcpTemplates} 件のテンプレート)、コネクター({connectors} 件接続済み)、デザインファイル({files})。',
  'chat.designToolbox.prompt.searchableSkills': '検索可能なスキル',
  'chat.designToolbox.prompt.searchablePlugins': '検索可能なプラグイン',
  'chat.designToolbox.prompt.availableMcp': '利用可能な MCP',
  'chat.designToolbox.prompt.connectedConnectors': '接続済みのコネクター',
  'chat.designToolbox.prompt.referenceDesignFiles': '参照デザインファイル',
  'chat.designToolbox.prompt.mcpTemplateName': '{name} テンプレート',
  'chat.designToolbox.prompt.processRule': 'ワークフロールール: まず美的目標と制約を定義し、その上でリソースを検索してマッチングします。ユーザーの選択が必要な場合は、有限選択肢の UI を生成し、確認後に続行します。',
  'chat.designToolbox.prompt.moreSuffix': ' 他 {count} 件',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}。',
  'chat.mentionTabsAria': 'メンション対象',
  'chat.mentionTabAll': 'すべて',
  'chat.mentionTabTabs': 'タブ',
  'chat.mentionTabPlugins': 'プラグイン',
  'chat.mentionTabSkills': 'スキル',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'コネクター',
  'chat.mentionTabFiles': 'デザインファイル',
  'chat.mentionNoResults': '「{query}」の結果はありません。',
  'chat.mentionSearchPrompt': 'デザインファイル、タブ、プラグイン、スキル、MCP サーバー、コネクターを検索します。',
  'chat.mentionSectionTabs': 'タブ',
  'chat.mentionSectionPlugins': 'プラグイン',
  'chat.mentionSectionSkills': 'スキル',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'コネクター',
  'chat.mentionSectionFiles': 'デザインファイル',
  'chat.mentionActiveSkill': '有効',
  'chat.mentionUseMcpTitle': '{name} を使用',
  'chat.mentionUseConnectorTitle': '{name} を使用',
  'chat.mentionPluginOfficial': '公式',
  'chat.mentionPluginMine': 'マイプラグイン',
  'chat.linkedFolderRemoveAria': 'リンクされたフォルダー {path} を削除',
  'chat.linkedFolderNotFound': 'フォルダーが存在しません',
  'chat.linkedFolderAlready': 'このフォルダーは既にリンクされています',
  'chat.linkedFolderPickError': 'フォルダー選択を開けません',
  'chat.queuedHeader': 'キュー',
  'chat.queuedToSend': '送信待ち',
  'chat.queuedEditQueuedTaskAria': 'キュー内のタスクを編集',
  'chat.queuedSave': '保存',
  'chat.queuedCancel': 'キャンセル',
  'chat.queuedReorder': 'ドラッグで並べ替え',
  'chat.queuedEdit': '編集',
  'chat.queuedMore': '件のキュー',
  'chat.queuedFollowUpFallback': 'キュー内のフォローアップ',
  'chat.send': '送信',
  'chat.stop': '停止',
  'chat.removeAria': '{name} を削除',
  'chat.example1Title': '編集ピッチデッキ',
  'chat.example1Tag': '雑誌',
  'chat.example1Prompt': 'シードラウンドを調達するデザインスタジオの10スライド編集ピッチデッキ — スイスグリッドレイアウト、大きなセリフ体の見出しにボールドドロップキャップ、等幅フォントのセクション番号、余白を活かしたデザイン、テキスト中心のスライドと交互に配置したフルブリード写真スライド。カバー、ビジョン、マーケット、プロダクト、トラクション、チーム、調達額、連絡先。',
  'chat.example2Title': 'SaaS 分析ダッシュボード',
  'chat.example2Tag': 'データ',
  'chat.example2Prompt': '開発者ツール SaaS の高密度な分析ダッシュボード — 前週比デルタ付き KPI ストリップ、積み上げ折れ線グラフ2本（MRR とアクティブワークスペース）、使用状況のワールドヒートマップ、コホートリテンショングリッド、トップ顧客リーダーボード、リアルタイムイベントフィード。ダークテーマ、表形式等幅数字、スパークラインアクセント。',
  'chat.example3Title': '年次報告書 長スクロール',
  'chat.example3Tag': '編集',
  'chat.example3Prompt': '気候系 NPO のインタラクティブ年次報告書 — 大きな引用ブロック、データビジュアライゼーション（積み上げ棒グラフ、アニメーションカウンター、プロジェクトサイトのコロプレスマップ）、写真ブレーカー、ドナーウォール、最後にコールトゥアクションを混在させた長スクロール編集レイアウト。モダンなセリフ体本文、サンセリフのチャートラベル、土のようなペーパーパレット。',
  'preview.usePlugin': 'プラグインを使う',
  'preview.usePluginOnly': 'プラグインのみ使う',
  'preview.usePluginOnlyDesc': 'プラグインの構造だけ使い、内容は自分で書く',
  'preview.replicateContent': 'この内容を複製',
  'preview.replicateContentDesc': 'サンプルプロンプトでプレビューと同じものを再現',
  'preview.shareMenu': '共有',
  'preview.exportMenu': 'エクスポート',
  'preview.shareTemplateBadge': 'テンプレート',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'テンプレートリンクをコピー',
  'preview.copyShareText': '共有テキストをコピー',
  'preview.shareSocialGroup': 'ソーシャルに共有',
  'preview.shareCopyGroup': 'コピー',
  'preview.shareExportGroup': 'ファイルをエクスポート',
  'preview.shareCopied': 'コピーしました',
  'preview.shareCopyFailed': 'コピーに失敗しました',
  'preview.shareTextDefault': 'Open Design テンプレート: {title}',
  'preview.openInNewTab': '新しいタブで開く',
  'preview.exit': '⤓ 終了',
  'preview.fullscreen': '⤢ フルスクリーン',
  'preview.closeTitle': '閉じる (Esc)',
  'preview.loading': '{label} を読み込み中…',
  'preview.errorTitle': 'この例を読み込めませんでした。',
  'preview.errorBody': '例の HTML を取得できませんでした。Open Design が起動していることを確認して再試行してください。',
  'preview.retry': '再試行',
  'preview.unavailableTitle': '{noun}にはプレビューが同梱されていません。',
  'preview.unavailableBody': 'チャットでプロンプトを実行して {kind} 出力を生成してください。',
  'preview.nounSkill': 'このスキル',
  'preview.nounPlugin': 'このプラグイン',
  'preview.nounTemplate': 'このテンプレート',
  'preview.showSidebar': '{label} を表示',
  'preview.hideSidebar': '{label} を非表示',
  'misc.savedTemplate': '保存済みテンプレート',
  'misc.primary': 'プライマリ',
  'misc.designSystem': 'デザインシステム',
  'workspace.designFiles': 'デザインファイル',
  'workspace.focusMode': 'ワークスペースに集中',
  'workspace.showChat': 'チャットを表示',
  'workspace.closeTab': 'タブを閉じる',
  'workspace.deleteFileConfirm': 'プロジェクトフォルダーから "{name}" を削除しますか？',
  'workspace.deleteSelectedFilesConfirm': 'プロジェクトフォルダーから選択した {n} 個のファイルを削除しますか？',
  'workspace.deleteSelectedFilesPartial': '{n} 個のファイルの削除に失敗しました。',
  'workspace.openFromDesignFiles': 'ファイルを開く: ',
  'workspace.designFilesLink': 'デザインファイル',
  'workspace.loadingSketch': 'スケッチを読み込み中…',
  'workspace.newTab': '新しいタブ',
  'workspace.searchFilesPlaceholder': 'ファイルを検索…',
  'workspace.openTabs': '開いているタブ',
  'workspace.openFile': 'ファイルを開く',
  'workspace.noFilesMatch': '一致するファイルがありません',
  'workspace.allFiles': 'すべて',
  'workspace.createNew': '新規作成',
  'workspace.tabOpen': '開いています',
  'workspace.sideChatContextBanner': '現在の会話のコンテキストを引き継ぎました',
  'workspace.sideChatDefaultTitle': 'サイドチャット',
  'workspace.newTerminal': '新しいターミナル',
  'workspace.newTerminalDescription': 'プロジェクトディレクトリのシェルを新しいタブで開く',
  'workspace.newBrowser': '新しいブラウザ',
  'workspace.newBrowserDescription': '参照サイトやブラウザ作業用の内蔵ブラウザタブを開く',
  'workspace.terminalStarting': 'ターミナルを起動しています…',
  'workspace.terminalStartingDescription': 'プロジェクトのシェルを準備しています。通常は数秒で完了します。',
  'workspace.terminalSessionEnded': 'セッションが終了しました',
  'workspace.terminalReconnecting': '再接続しています…',
  'workspace.terminalStartFailed': 'ターミナルセッションを開始できませんでした',
  'workspace.terminalRestart': '再起動',
  'designFiles.title': 'デザインファイル',
  'designFiles.upload': 'ファイルをアップロード',
  'designFiles.pasteText': 'テキストファイルとして貼り付け',
  'designFiles.newSketch': '新しいスケッチ',
  'designFiles.empty': 'ここに作品が表示されます',
  'designFiles.refresh': '更新',
  'designFiles.delete': '削除',
  'designFiles.searchPlaceholder': 'ファイルを検索…',
  'designFiles.up': '上へ',
  'designFiles.back': '戻る',
  'designFiles.crumbs': 'プロジェクト',
  'designFiles.rowMenu': '行メニュー',
  'designFiles.openInTab': 'タブで開く',
  'designFiles.download': 'ダウンロード',
  'designFiles.downloadSelected': '{n}件をZIPとしてダウンロード',
  'designFiles.deleteSelected': '{n} 件を削除',
  'designFiles.clearSelection': '選択をクリア',
  'designFiles.selectPage': 'このページをすべて選択',
  'designFiles.selectAll': 'すべて選択',
  'designFiles.dropTitle': '⤓ ファイルをここにドロップ',
  'designFiles.dropDesc': '画像、ドキュメント、参考資料、フォルダー — エージェントがコンテキストとして使用します。',
  'designFiles.dropLabel': 'ここにファイルをドロップ',
  'designFiles.upload.title': 'ファイルをアップロード',
  'designFiles.paste.title': 'テキストをファイルとして貼り付け',
  'designFiles.upload.label': 'アップロード',
  'designFiles.paste.label': '貼り付け',
  'designFiles.previewOpen': '開く',
  'designFiles.previewClose': 'プレビューを閉じる',
  'designFiles.modified': '{time} に変更 · {size}',
  'designFiles.weeksAgo': '{n}週間前',
  'designFiles.groupBy': 'グループ化',
  'designFiles.groupByKind': '種類',
  'designFiles.groupByModified': '更新日時',
  'designFiles.filterBy': '種類で絞り込み',
  'designFiles.filterClear': 'クリア',
  'designFiles.filterCount': '{n} 種類',
  'designFiles.expandGroup': '展開',
  'designFiles.collapseGroup': '折りたたむ',
  'designFiles.sectionPages': 'ページ',
  'designFiles.sectionScripts': 'スクリプト',
  'designFiles.sectionImages': '画像',
  'designFiles.sectionSketches': 'スケッチ',
  'designFiles.sectionLiveArtifacts': 'ライブアーティファクト',
  'designFiles.sectionOther': 'その他',
  'designFiles.modifiedToday': '今日',
  'designFiles.modifiedYesterday': '昨日',
  'designFiles.modifiedPrevious7Days': '過去7日間',
  'designFiles.modifiedPrevious30Days': '過去30日間',
  'designFiles.modifiedOlder': 'それ以前',
  'designFiles.showMore': 'さらに {n} 件表示',
  'designFiles.kindHtml': 'HTML ページ',
  'designFiles.kindImage': '画像',
  'designFiles.kindSketch': 'スケッチ',
  'designFiles.kindText': 'テキスト',
  'designFiles.kindCode': 'スクリプト',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'ドキュメント',
  'designFiles.kindPresentation': 'プレゼンテーション',
  'designFiles.kindSpreadsheet': 'スプレッドシート',
  'designFiles.kindLiveArtifact': 'ライブアーティファクト',
  'designFiles.kindBinary': 'バイナリ',
  'designFiles.kindFolder': 'フォルダ',
  'designFiles.folderCount': '{n} ファイル',
  'designFiles.newFolderTitle': '新しいフォルダ',
  'designFiles.newFolderLabel': 'フォルダ名',
  'designFiles.moveTitle': 'フォルダに移動',
  'designFiles.moveLabel': '移動先フォルダ',
  'designFiles.moveRoot': 'プロジェクトのルート',
  'designFiles.moveNewFolder': '新しいフォルダ…',
  'designFiles.move': '移動',
  'designFiles.copyPath': 'パスをコピー',
  'designFiles.copiedPath': 'パスをコピーしました',
  'designFiles.deleteFolderConfirm': 'フォルダ「{name}」とそのすべての内容を削除しますか?',
  'designFiles.folderCreated': 'フォルダ「{name}」を作成しました',
  'designFiles.folderDeleted': 'フォルダ「{name}」を削除しました',
  'designFiles.filesMoved': '{n} 件を {dest} に移動しました',
  'designFiles.colName': '名前',
  'designFiles.colKind': '種類',
  'designFiles.colModified': '更新日',
  'designFiles.perPage': '表示',
  'designFiles.all': 'すべて',
  'designFiles.prev': '前へ',
  'designFiles.next': '次へ',
  'designFiles.jumpToPage': 'ページにジャンプ',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'designFiles.sectionFolders': 'フォルダ',
  'designFiles.sectionStylesheets': 'スタイルシート',
  'designFiles.sectionDocuments': 'ドキュメント',
  'designFiles.kindStylesheet': 'スタイルシート',
  'designFiles.modifiedExt': '更新日時 {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': '役立つ情報',
  'designFiles.usefulInfoTip': 'ファイルをダブルクリックすると、フルタブで開きます。',
  'designFiles.usefulInfoTip2': 'チャットで @ を入力すると、ファイルをコンテキストとして参照できます。',
  'designFiles.usefulInfoTip4': 'デザインシステムを選ぶと、ブランドに沿ったデザインを生成できます。',
  'designFiles.usefulInfoTip5': 'アイデアに迷ったら、ホームのコミュニティにあるプラグインテンプレートをお試しください。',
  'designFiles.usefulInfoTip6': '質問やご意見は、Discord でお気軽にどうぞ。',
  'designFiles.usefulInfoTip7': '気に入ったら、GitHub でスターをお願いします。',
  'designFiles.usefulInfoTip8': 'X で @nexudotio をフォローして最新情報をチェック。',
  'designFiles.usefulInfoTip9': '画像やドキュメント、フォルダーごとこのパネルにドラッグすると、エージェントがコンテキストとして使用します。',
  'designFiles.usefulInfoTip10': 'スケッチ機能でラフなレイアウトを描くと、エージェントがそれを元に生成します。',
  'designFiles.usefulInfoTip11': 'プレビューで要素を選択してコメントすると、エージェントがその箇所を修正します。',
  'designFiles.usefulInfoTip12': '結果がいまいち？言葉で説明し直すより、プレビューで囲んで指示するほうが速いです。',
  'designFiles.usefulInfoTip13': 'デザインは PDF・画像・単体 HTML にワンクリックで書き出せます。',
  'designFiles.usefulInfoTip14': '気に入ったプロジェクトは「共有」メニューからテンプレートとして保存し、再利用できます。',
  'designFiles.usefulInfoTip15': 'デプロイ後は、SNS シェア用カードをすぐに生成できます。',
  'quickSwitcher.placeholder': 'ファイルを開く…',
  'quickSwitcher.empty': 'このプロジェクトにファイルがありません',
  'quickSwitcher.noMatches': '一致なし',
  'quickSwitcher.navigate': '移動',
  'quickSwitcher.open': '開く',
  'quickSwitcher.close': '閉じる',
  'pasteDialog.title': 'テキストを貼り付け',
  'pasteDialog.hint': 'プロジェクトフォルダーに保存されます。任意の名前を付けてください。',
  'pasteDialog.fileNameLabel': 'ファイル名',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'コンテンツ',
  'pasteDialog.contentPlaceholder': '何でも貼り付け…',
  'pasteDialog.save': '保存',
  'pasteDialog.cancel': 'キャンセル',
  'sketch.save': 'スケッチを保存',
  'sketch.cancel': 'キャンセル',
  'sketch.saving': '保存中…',
  'sketch.saved': '保存済み',
  'sketch.tooltipDirty': '未保存の変更があります',
  'sketch.tooltipClean': '保存済み',
  'fileViewer.empty': 'ファイルを選択して表示します。',
  'fileViewer.loading': '読み込み中…',
  'fileViewer.exportPptx': 'PPTX としてエクスポート',
  'fileViewer.openInNewTab': '新しいタブで開く',
  'fileViewer.copyPath': 'パスをコピー',
  'fileViewer.copied': 'コピーしました！',
  'fileViewer.share': '共有',
  'fileViewer.binaryMeta': 'バイナリ · {size}',
  'fileViewer.binaryNote': 'バイナリファイル（{size} バイト）。ダウンロードするかディスクから開いて確認してください。',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'ドキュメント',
  'fileViewer.presentationMeta': 'プレゼンテーション',
  'fileViewer.spreadsheetMeta': 'スプレッドシート',
  'fileViewer.previewUnavailable': 'プレビューは利用できません。ファイルをダウンロードするか開いて確認してください。',
  'fileViewer.download': 'ダウンロード',
  'fileViewer.open': '開く',
  'fileViewer.imageMeta': '画像 · {size}',
  'fileViewer.reactMeta': 'React コンポーネント · {size}',
  'fileViewer.sketchMeta': 'スケッチ · {size}',
  'fileViewer.markdownStreamingMeta': 'ストリーミングプレビュー中…',
  'fileViewer.markdownErrorMeta': 'プレビューが不完全な場合があります（生成エラー）。',
  'fileViewer.markdownStreamingStatus': 'ストリーミング中… 部分的な Markdown を表示しています。',
  'fileViewer.markdownErrorStatus': '生成エラー。最後に利用可能なコンテンツを表示しています。',
  'fileViewer.videoMeta': '動画 · {size}',
  'fileViewer.audioMeta': '音声 · {size}',
  'fileViewer.reload': '再読み込み',
  'fileViewer.reloadDisk': 'ディスクから再読み込み',
  'fileViewer.copy': 'コピー',
  'fileViewer.copyTitle': 'ファイルの内容をコピー',
  'fileViewer.saveDisabled': '保存（読み取り専用ビューアー）',
  'fileViewer.save': '保存',
  'fileViewer.preview': 'プレビュー',
  'fileViewer.source': 'ソース',
  'fileViewer.tweaks': '調整',
  'fileViewer.tweaksUnavailable': 'このアーティファクトには調整パネルがありません',
  'fileViewer.jsxModuleTitle': '単独プレビューはありません',
  'fileViewer.jsxModuleBody': 'このファイルは別のページから読み込まれるコンポーネントモジュールです。',
  'fileViewer.jsxModuleCta': '表示するページを開いてください:',
  'fileViewer.comment': 'コメント',
  'fileViewer.edit': '編集',
  'fileViewer.draw': '描画',
  'fileViewer.mark': 'マーク',
  'fileViewer.markTool': 'マークツール',
  'fileViewer.boxSelect': '範囲選択',
  'fileViewer.screenshot': 'スクリーンショット',
  'manualEdit.layers': 'レイヤー',
  'manualEdit.editableCount': '{count} 件編集可能',
  'manualEdit.hiddenBadge': '非表示',
  'manualEdit.title': '手動エディター',
  'manualEdit.fallbackTitle': '編集',
  'manualEdit.movePanel': '編集パネルを移動',
  'manualEdit.editParams': 'パラメーターを編集',
  'manualEdit.closePanel': '編集パネルを閉じる',
  'manualEdit.selectLayer': 'レイヤーを選択',
  'manualEdit.empty': 'プレビュー内の要素をクリックするか、レイヤーを選択してください。',
  'manualEdit.noEditableLayers': '編集可能なレイヤーが見つかりません。',
  'manualEdit.noClass': 'クラスなし',
  'manualEdit.tabsAria': '手動編集タブ',
  'manualEdit.tabContent': 'コンテンツ',
  'manualEdit.tabStyle': 'スタイル',
  'manualEdit.tabAttributes': '属性',
  'manualEdit.tabHtml': 'HTML',
  'manualEdit.tabSource': 'ソース',
  'manualEdit.attributesJson': '属性 JSON',
  'manualEdit.selectedHtml': '選択中の要素の HTML',
  'manualEdit.fullSource': 'アーティファクト全体のソース',
  'manualEdit.applyContent': 'コンテンツを適用',
  'manualEdit.applyStyle': 'スタイルを適用',
  'manualEdit.applyAttributes': '属性を適用',
  'manualEdit.applyHtml': 'HTML を適用',
  'manualEdit.applySource': 'ソースを適用',
  'manualEdit.invalidAttributes': '属性 JSON が無効です。',
  'manualEdit.changes': '変更',
  'manualEdit.undo': '元に戻す',
  'manualEdit.redo': 'やり直す',
  'manualEdit.noChanges': 'まだ手動編集はありません。',
  'manualEdit.imageUrl': '画像 URL',
  'manualEdit.altText': '代替テキスト',
  'manualEdit.label': 'ラベル',
  'manualEdit.text': 'テキスト',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': '文字色',
  'manualEdit.background': '背景',
  'manualEdit.fontSize': 'フォントサイズ',
  'manualEdit.weight': '太さ',
  'manualEdit.align': '配置',
  'manualEdit.padding': 'パディング',
  'manualEdit.margin': 'マージン',
  'manualEdit.radius': '角丸',
  'manualEdit.border': '枠線',
  'manualEdit.width': '幅',
  'manualEdit.minHeight': '最小の高さ',
  'manualEdit.deleteElement': '要素を削除',
  'manualEdit.deleteElementConfirm': '選択した要素を削除しますか？「元に戻す」で取り消せます。',
  'manualEdit.uploadImage': '画像をアップロード',
  'manualEdit.uploadingImage': '画像をアップロード中…',
  'manualEdit.uploadImageFailed': '画像をアップロードできませんでした。',
  'manualEdit.focusSlides': 'スライドにフォーカス',
  'manualEdit.showPanels': 'パネルを表示',
  'fileViewer.zoomOut': 'ズームアウト',
  'fileViewer.zoomIn': 'ズームイン',
  'fileViewer.resetZoom': 'ズームをリセット',
  'fileViewer.viewportAria': 'プレビューのビューポート',
  'fileViewer.viewportDesktop': 'デスクトップ',
  'fileViewer.viewportDesktopTitle': '全幅デスクトッププレビュー',
  'fileViewer.viewportTablet': 'タブレット',
  'fileViewer.viewportTabletTitle': 'タブレットプレビュー 820 × 1180（最新の縦向き基準）',
  'fileViewer.viewportMobile': 'モバイル',
  'fileViewer.viewportMobileTitle': 'モバイルプレビュー 390 × 844',
  'fileViewer.reloadAria': '再読み込み',
  'fileViewer.previousSlide': '前のスライド',
  'fileViewer.nextSlide': '次のスライド',
  'fileViewer.slideNavAria': 'スライドナビゲーション',
  'fileViewer.present': 'プレゼン',
  'fileViewer.presentInTab': 'このタブで',
  'fileViewer.presentFullscreen': 'フルスクリーン',
  'fileViewer.presentNewTab': '新しいタブ',
  'fileViewer.exitPresentation': 'プレゼンを終了',
  'fileViewer.shareLabel': '共有',
  'fileViewer.shareMenuShareLink': '共有',
  'fileViewer.shareMenuPublishOnline': 'オンライン公開',
  'fileViewer.shareMenuDownload': 'ダウンロード',
  'fileViewer.shareMenuPresentation': 'プレゼンテーション',
  'fileViewer.shareMenuSourceFiles': 'ソースファイル',
  'fileViewer.shareMenuSave': '保存',
  'fileViewer.copyShareLink': '共有リンクをコピー',
  'fileViewer.openSharePage': '共有ページを開く',
  'fileViewer.shareLinkRequiresDeploy': 'リンクを取得するには先にオンライン公開してください',
  'fileViewer.shareLinkPublishGuide': '上でオンライン公開すると共有できます ↑',
  'fileViewer.shareAfterGenerationComplete': '生成完了後に共有できます',
  'fileViewer.copyProviderLink': '{provider} リンクをコピー',
  'fileViewer.copyCloudflareLink': 'Cloudflare リンクをコピー',
  'fileViewer.screenshotCopying': 'スクリーンショットをコピー中…',
  'fileViewer.screenshotCopied': 'スクリーンショットをクリップボードにコピーしました',
  'fileViewer.screenshotClipboardDenied': 'ブラウザがクリップボードへのアクセスをブロックしました',
  'fileViewer.screenshotPreviewLoading': 'プレビューを読み込み中です。しばらくしてからもう一度お試しください。',
  'fileViewer.screenshotCaptureFailed': 'プレビューをキャプチャできませんでした。もう一度お試しください。',
  'fileViewer.exportPdf': 'PDFとしてエクスポート',
  'fileViewer.exportPdfAllSlides': 'PDFとしてエクスポート（全スライド）',
  'fileViewer.exportPptxBusy': '現在のターンが終わるまでお待ちください。',
  'fileViewer.exportPptxHint': 'エージェントにこのデザインを PPTX に変換するようリクエストを送信します。',
  'fileViewer.exportPptxNa': 'ここでは PPTX エクスポートは利用できません。',
  'fileViewer.exportZip': '.zip としてダウンロード',
  'fileViewer.exportHtml': 'スタンドアロン HTML としてエクスポート',
  'fileViewer.exportMd': 'Markdown としてエクスポート',
  'fileViewer.exportImage': '画像としてエクスポート',
  'fileViewer.exportImageFailed': '画像のキャプチャに失敗しました。再試行するか、ブラウザのスクリーンショット機能をご利用ください。',
  'fileViewer.exportImageModalSubtitle': '形式を選択して、現在のプレビューを画像としてダウンロードします。',
  'fileViewer.exportImageFormatLabel': '形式',
  'fileViewer.exportImageSaving': '画像を保存中…',
  'fileViewer.exportImageSaved': '画像を保存しました',
  'fileViewer.exportImageDownloadStarted': 'ダウンロードを開始しました',
  'fileViewer.exportImageDownloadDetails': '保存ダイアログが表示されなかった場合は、ブラウザのダウンロードフォルダで {filename} を確認してください。',
  'fileViewer.exportJsx': 'JSX としてエクスポート',
  'fileViewer.exportReactHtml': 'プレビューを HTML としてエクスポート',
  'fileViewer.exportStarted': 'エクスポートを開始しました',
  'fileViewer.saveAsTemplate': 'テンプレートとして保存…',
  'fileViewer.savingTemplate': 'テンプレートを保存中…',
  'fileViewer.savedTemplate': '"{name}" として保存しました',
  'fileViewer.savedTemplateFail': 'テンプレートを保存できませんでした — もう一度試してください。',
  'fileViewer.templateNamePrompt': 'テンプレート名',
  'fileViewer.templateNameDefault': '無題のテンプレート',
  'fileViewer.templateDescPrompt': '短い説明（省略可 — このテンプレートの使いどころは？）',
  'liveArtifact.refresh.button': '更新',
  'liveArtifact.refresh.buttonTitle': 'このライブアーティファクトを更新',
  'liveArtifact.refresh.loadingTitle': 'ライブアーティファクトを読み込み中…',
  'liveArtifact.refresh.noSourceTitle': '利用可能な更新ソースがまだありません。',
  'liveArtifact.refresh.running': '更新中…',
  'liveArtifact.refresh.runningMessage': 'データとプレビューを更新しています。少し時間がかかる場合があります。',
  'liveArtifact.refresh.runningAction': '更新が成功するまで、前のプレビューが表示されたままになります。',
  'liveArtifact.refresh.successOne': '更新が完了しました。データを更新しました。',
  'liveArtifact.refresh.successMany': '更新が完了しました。データを更新しました。',
  'liveArtifact.refresh.successAction': '最新のコミット済みデータでプレビューを再読み込みしました。',
  'liveArtifact.refresh.previousFailure': '前回の更新に失敗しました: {message}',
  'liveArtifact.refresh.failureAction': '更新履歴を確認し、ソースまたは権限の問題を修正してから、もう一度お試しください。',
  'liveArtifact.refresh.networkFailure': '更新リクエストに失敗しました。接続を確認して、もう一度お試しください。',
  'liveArtifact.refresh.genericFailure': '更新に失敗しました。',
  'liveArtifact.refresh.statusNever': '更新不可',
  'liveArtifact.refresh.statusReady': '更新可能',
  'liveArtifact.refresh.statusSucceeded': '最新の状態',
  'liveArtifact.refresh.statusFailed': '更新に失敗',
  'liveArtifact.refresh.statusRunning': '更新中',
  'liveArtifact.refresh.statusRunningDescription': '現在、更新の実行が進行中です。',
  'liveArtifact.refresh.statusSucceededDescription': '前回の更新は正常に完了しました。',
  'liveArtifact.refresh.statusFailedDescription': '前回の更新は正常に完了しませんでした。',
  'liveArtifact.refresh.statusReadyDescription': '更新可能なソースが設定されていますが、実行は進行していません。',
  'liveArtifact.refresh.statusNeverDescription': 'このライブアーティファクトにはまだ更新ソースがありません。',
  'liveArtifact.refresh.eventStarted': '開始',
  'liveArtifact.refresh.eventSucceeded': '成功',
  'liveArtifact.refresh.eventFailed': '失敗',
  'liveArtifact.refresh.eventStartedDetail': '更新を開始しました…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n}件のソースを更新',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n}件のソースを更新',
  'liveArtifact.refresh.timelineEmpty': 'このセッションではまだ更新アクティビティがありません。更新を実行してタイムラインを記録するか、自動実行をお待ちください。',
  'liveArtifact.refresh.heroLastRefreshedLabel': '最終更新',
  'liveArtifact.refresh.heroLastRefreshedNever': 'なし',
  'liveArtifact.refresh.justNow': 'たった今',
  'liveArtifact.refresh.factCreated': '作成日時',
  'liveArtifact.refresh.factLastUpdated': '最終更新',
  'liveArtifact.refresh.factUnknown': '不明',
  'liveArtifact.refresh.persistedTitle': '保存された更新履歴',
  'liveArtifact.refresh.persistedHint': 'refreshes.jsonl から読み込まれたエントリ',
  'liveArtifact.refresh.persistedEmpty': '保存された更新履歴はまだありません。',
  'liveArtifact.refresh.persistedStatusSucceeded': '成功',
  'liveArtifact.refresh.persistedStatusRunning': '実行中',
  'liveArtifact.refresh.persistedStatusFailed': '失敗',
  'liveArtifact.refresh.persistedStatusCancelled': 'キャンセル',
  'liveArtifact.refresh.persistedStatusSkipped': 'スキップ',
  'liveArtifact.refresh.sessionTitle': 'セッションアクティビティ',
  'liveArtifact.refresh.sessionHint': 'このタブを開いている間に観測されたイベント',
  'liveArtifact.refresh.docSourceTitle': 'ドキュメントソース',
  'liveArtifact.refresh.docSourceHint': 'ソースを設定済み',
  'liveArtifact.refresh.docSourceType': 'タイプ',
  'liveArtifact.refresh.docSourceTool': 'ツール',
  'liveArtifact.refresh.docSourceConnector': 'コネクタ',
  'liveArtifact.refresh.debugSummary': '高度なデバッグメタデータ',
  'liveArtifact.refresh.debugNote': 'コネクタID、ファイル名、ソースメタデータ、内部アーティファクトパスが含まれる場合があります。',
  'liveArtifact.viewer.tabPreview': 'プレビュー',
  'liveArtifact.viewer.tabCode': 'コード',
  'liveArtifact.viewer.tabData': 'データ',
  'liveArtifact.viewer.tabRefreshHistory': '更新履歴',
  'liveArtifact.viewer.dataEmpty': 'data.json キャッシュはありません。',
  'liveArtifact.viewer.code.templateHeading': 'テンプレート HTML',
  'liveArtifact.viewer.code.renderedHeading': 'レンダリング済み HTML',
  'liveArtifact.viewer.code.templateHelp': 'data.json と共にプレビュー生成に使われる編集可能なテンプレートです。',
  'liveArtifact.viewer.code.renderedHelp': 'プレビューで現在読み込まれている生成済み index.html です。',
  'liveArtifact.viewer.code.variantAria': 'コードの種類',
  'liveArtifact.viewer.code.variantTemplate': 'テンプレート',
  'liveArtifact.viewer.code.variantRendered': 'レンダリング済み',
  'liveArtifact.viewer.code.loading': 'コードを読み込み中…',
  'liveArtifact.viewer.code.unavailable': 'コードはまだ利用できません。',
  'liveArtifact.viewer.code.empty': 'このコードファイルは空です。',
  'fileViewer.deployToVercel': 'Vercel にデプロイ',
  'fileViewer.redeployToVercel': '再デプロイ',
  'fileViewer.deployingToVercel': 'Vercel にデプロイ中…',
  'fileViewer.deployProviderLabel': 'プロバイダー',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': '{provider} にデプロイ',
  'fileViewer.redeployToProvider': '{provider} に再デプロイ',
  'fileViewer.deployingToProvider': '{provider} にデプロイ中…',
  'fileViewer.preparingPublicLink': '公開リンクを準備中…',
  'fileViewer.copyDeployLink': 'リンクをコピー',
  'fileViewer.deployModalTitle': 'デプロイ',
  'fileViewer.deployModalSubtitle': '選択したプロバイダーのアカウントを使用して、この HTML プレビューをデプロイします。',
  'fileViewer.vercelToken': 'Vercel トークン',
  'fileViewer.vercelTokenGetLink': 'Vercel トークンを取得',
  'fileViewer.vercelTokenPlaceholder': 'Vercel トークンを貼り付け',
  'fileViewer.vercelTokenReuseHint': '保存済みトークンが使用されます。新しいトークンを入力すると置き換えられます。',
  'fileViewer.vercelTokenRequired': '最初に Vercel トークンを入力して保存してください。',
  'fileViewer.cloudflareApiToken': 'Cloudflare API トークン',
  'fileViewer.cloudflareApiTokenGetLink': 'API トークンを取得',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cloudflare API トークンを貼り付け',
  'fileViewer.cloudflareApiTokenReuseHint': '保存済みの Cloudflare API トークンが使用されます。新しいトークンを入力すると置き換えられます。',
  'fileViewer.cloudflareApiTokenRequired': '最初に Cloudflare API トークンを入力して保存してください。',
  'fileViewer.cloudflareApiTokenScopeHint': 'API トークン作成時に Pages Edit を選択してください。カスタムドメインには Zone Read / DNS Edit が必要です。',
  'fileViewer.vercelTeamId': 'チーム ID',
  'fileViewer.vercelTeamSlug': 'チームスラッグ',
  'fileViewer.cloudflareAccountId': 'アカウント ID',
  'fileViewer.cloudflareAccountIdHint': 'Cloudflare ダッシュボードでアカウント ID を確認できます。',
  'fileViewer.cloudflareAccountIdRequired': '最初に Cloudflare Account ID を入力して保存してください。',
  'fileViewer.cloudflareZoneLabel': 'ドメイン',
  'fileViewer.cloudflareZonePlaceholder': 'Cloudflare 設定を保存するとドメインが読み込まれます',
  'fileViewer.cloudflareZoneRequired': '先に Cloudflare ドメインを選択してください。',
  'fileViewer.cloudflareZonesLoading': 'Cloudflare ドメインを読み込み中…',
  'fileViewer.cloudflareZonesRefresh': 'ドメインを更新',
  'fileViewer.cloudflareZonesLoadFailed': 'Cloudflare ドメインを読み込めませんでした。',
  'fileViewer.cloudflareZonesEmpty': 'このアカウントでは有効なフル Cloudflare ドメインが見つかりませんでした。',
  'fileViewer.cloudflareDomainPrefixLabel': 'サブドメインのプレフィックス',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'DNS ラベルは1つのみ使用してください：英小文字、数字、ハイフン。',
  'fileViewer.cloudflareHostnamePreview': 'カスタムドメインのプレビュー：{hostname}',
  'fileViewer.cloudflareCustomDomainHint': '任意: カスタムドメインを紐付けます。空欄のままでも pages.dev リンクは作成されます。',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'カスタムドメイン',
  'fileViewer.optional': '省略可',
  'fileViewer.vercelPreviewOnly': 'デプロイは現在 Preview のみです。',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages は Direct Upload を使用します。',
  'fileViewer.savingConfig': '保存中…',
  'fileViewer.deployConfigSaveFailed': 'Vercel の設定を保存できませんでした。',
  'fileViewer.deployFailed': 'デプロイに失敗しました。Vercel の設定を確認して再試行してください。',
  'fileViewer.deployProviderConfigSaveFailed': '{provider} の設定を保存できませんでした。',
  'fileViewer.deployProviderFailed': '{provider} のデプロイに失敗しました。設定を確認して再試行してください。',
  'fileViewer.deployResultLabel': 'デプロイ URL',
  'fileViewer.deployLinkReady': '準備完了',
  'fileViewer.deploySuccessToast': 'デプロイを正常にアップロードしました',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': '公開リンク準備中',
  'fileViewer.deployLinkDelayed': 'サイトはデプロイされました。プロバイダーが公開リンクを準備中です。',
  'fileViewer.deployLinkFailed': 'カスタムドメインに失敗しました',
  'fileViewer.deployLinkProtectedLabel': 'デプロイ保護が有効',
  'fileViewer.deployLinkProtected': 'サイトはデプロイされましたが、このプレビューリンクには認証が必要です。Deployment Protection を無効にするか、カスタムドメインを使用してください。',
  'fileViewer.retryLink': '今すぐ再試行',
  'questionForm.submit': '送信',
  'questionForm.skip': 'スキップ',
  'questionForm.locked': '回答済み',
  'conv.switch': '会話を切り替え',
  'conv.label': '会話',
  'conv.heading': '会話',
  'conv.new': '+ 新規',
  'conv.empty': 'まだ会話がありません。',
  'conv.untitled': '無題の会話',
  'conv.renameTooltip': 'ダブルクリックで名前を変更',
  'conv.delete': '会話を削除',
  'conv.deleteConfirm': '"{title}" を削除しますか？メッセージも削除されます。',
  'agentPicker.label': 'エージェント',
  'agentPicker.modeChoose': '実行モードを選択',
  'agentPicker.localCli': 'ローカル CLI',
  'agentPicker.daemonOff': 'デーモン停止中',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': '検出されたコードエージェント CLI を選択',
  'agentPicker.noAgents': 'PATH 上にエージェントなし',
  'agentPicker.notInstalled': '未インストール',
  'agentPicker.rescan': 'エージェントのローカル PATH を再スキャン',
  'tool.openInTab': '{name} をタブで開く',
  'tool.open': '開く',
  'tool.todos': 'To-Do',
  'tool.todosExpand': 'タスクを表示',
  'tool.todosCollapse': 'タスクを非表示',
  'tool.todosDone': '完了',
  'tool.todosDismiss': 'タスクリストを閉じる',
  'tool.write': '書き込み',
  'tool.edit': '編集',
  'tool.read': '読み取り',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'フェッチ',
  'tool.search': '検索',
  'tool.lines': '{n} 行',
  'tool.changeSingular': '変更',
  'tool.changePlural': '変更',
  'tool.in': '{path} 内',
  'tool.hide': '隠す',
  'tool.output': '出力',
  'tool.running': '実行中…',
  'tool.error': 'エラー',
  'tool.done': '完了',
  'assistant.role': 'アシスタント',
  'assistant.workingLabel': '作業中',
  'assistant.doneLabel': '完了',
  'assistant.copyMarkdown': '応答のMarkdownをコピー',
  'assistant.forkConversation': 'ここからフォーク',
  'assistant.forkingConversation': 'フォーク中…',
  'assistant.shareToOpenDesign': 'Open Design に共有',
  'assistant.shareToOpenDesignBusy': 'パッケージを準備中…',
  'assistant.feedbackPrompt': 'フィードバック',
  'assistant.feedbackPositive': '役に立った',
  'assistant.feedbackNegative': '役に立たなかった',
  'assistant.feedbackReasonTitle': '理由をお聞かせください',
  'assistant.feedbackReasonPositiveMatched': '要望どおりだった',
  'assistant.feedbackReasonPositiveVisual': '見た目が良い',
  'assistant.feedbackReasonPositiveUseful': '構造が役立つ',
  'assistant.feedbackReasonPositiveEasy': '編集を続けやすい',
  'assistant.feedbackReasonPositiveDesignSystem': 'デザインシステムに準拠している',
  'assistant.feedbackReasonNegativeMissed': '要望に応えていない',
  'assistant.feedbackReasonNegativeVisual': 'ビジュアル品質に改善が必要',
  'assistant.feedbackReasonNegativeIncomplete': '出力が不完全',
  'assistant.feedbackReasonNegativeHard': '使いにくい',
  'assistant.feedbackReasonNegativeDesignSystem': 'デザインシステムに準拠していない',
  'assistant.feedbackReasonOther': 'その他',
  'assistant.feedbackReasonPlaceholder': '短いメモを追加...',
  'assistant.feedbackReasonSubmit': '送信',
  'assistant.emptyResponseLabel': '出力なし',
  'assistant.emptyResponseMessage': 'プロバイダーがテキストやアーティファクトを返さずにリクエストを終了しました。別のモデルやプロバイダーを試す、クォータを確認する、または再試行してください。',
  'assistant.unfinishedLabel': '未完了の作業があります',
  'assistant.unfinishedSummary': '{n} 件のタスクが残っています',
  'assistant.unfinishedMore': '+{n} 件',
  'assistant.continueRemaining': '残りのタスクを続ける',
  'chat.resumeRunCta': '実行を続ける',
  'assistant.outTokens': '{n} 出力',
  'assistant.producedFiles': 'このターンのファイル',
  'assistant.openFile': '開く',
  'assistant.downloadFile': 'ダウンロード',
  'nextStep.title': '次のステップ',
  'nextStep.more': 'もっと見る',
  'nextStep.share': '共有',
  'nextStep.download': 'ダウンロード',
  'nextStep.contribute': 'コミュニティに貢献',
  'assistant.thinking': '考え中',
  'assistant.thought': '思考完了',
  'assistant.thoughtFor': '{s}秒間思考',
  'assistant.systemReminder': 'システムリマインダー',
  'assistant.possiblePromptInjection': 'プロンプトインジェクションの疑い',
  'assistant.waitingFirstOutput': '最初の出力を待っています',
  'assistant.statusBootingAgent': 'エージェントを起動中',
  'assistant.statusPreparing': '準備中...',
  'assistant.statusStarting': '開始中',
  'assistant.statusRequesting': 'リクエストを送信中',
  'assistant.statusThinking': '考え中',
  'assistant.statusStreaming': 'ストリーミング中',
  'assistant.slowHint': '通常より時間がかかっています。フォームは通常 5〜10 秒で表示されます — 停止して言い換えることもできます。',
  'assistant.verbEditing': '編集中',
  'assistant.verbWriting': '生成中',
  'assistant.verbReading': '読み取り中',
  'assistant.verbSearching': '検索中',
  'assistant.verbRunning': '実行中',
  'assistant.verbTodos': 'To Do',
  'assistant.verbFetching': 'フェッチ中',
  'assistant.verbCalling': '呼び出し中',
  'qf.answered': '回答済み',
  'qf.choose': '選択…',
  'qf.required': '必須',
  'qf.lockedSubmitted': '回答を送信しました — エージェントがセッション終了まで参照します。',
  'qf.lockedPrev': 'このフォームは前のターンのものです。',
  'qf.hint': '適切なものを選んでください。気にしない任意フィールドはスキップしてください — エージェントが適切なデフォルト値を使用します。',
  'qf.submitDefault': '回答を送信',
  'qf.submitDisabledTitle': '最初に必須フィールドを入力してください',
  'qf.submitTitle': '回答を送信',
  'qf.cardSelected': '選択済み',
  'qf.cardRefs': '参照:',
  'qf.cardSampleText': 'いろはにほへと · 0123',
  'questions.tabLabel': '質問',
  'questions.banner': 'いくつか簡単な質問をしてもよろしいですか？',
  'questions.bannerAnswered': '質問に回答済み',
  'questions.continue': '続ける',
  'questions.generating': '質問を生成中…',
  'questions.skipAll': 'すべてスキップ',
  'questions.autoSkipHint': 'タイマー終了時に自動で続行します',
  'sketch.toolSelect': '選択（操作なし）',
  'sketch.toolPen': 'ペン',
  'sketch.toolText': 'テキスト',
  'sketch.toolRect': '四角形',
  'sketch.toolArrow': '矢印',
  'sketch.toolEraser': '消しゴム',
  'sketch.color': '色',
  'sketch.strokeSize': 'ストロークサイズ',
  'sketch.undo': '元に戻す',
  'sketch.clear': 'クリア',
  'sketch.close': '閉じる',
  'sketch.closeConfirm': 'スケッチを閉じて未保存の変更を破棄しますか？',
  'sketch.textPrompt': 'テキスト:',
  'sketch.textModalTitle': 'テキストを追加',
  'critiqueTheater.userFacingName': 'デザイン陪審',
  'critiqueTheater.roleDesigner': 'デザイナー',
  'critiqueTheater.roleCritic': '批評家',
  'critiqueTheater.roleBrand': 'ブランド',
  'critiqueTheater.roleA11y': 'アクセシビリティ',
  'critiqueTheater.roleCopy': 'コピー',
  'critiqueTheater.roundLabel': 'ラウンド {n} / {m}',
  'critiqueTheater.mustFix': '要修正 {n} 件',
  'critiqueTheater.composite': '総合スコア',
  'critiqueTheater.threshold': 'しきい値',
  'critiqueTheater.consensus': '合意',
  'critiqueTheater.interrupt': '中断',
  'critiqueTheater.interrupting': '中断中…',
  'critiqueTheater.interrupted': '中断済み',
  'critiqueTheater.degradedHeading': 'この実行ではパネル無効',
  'critiqueTheater.degradedReasonMalformed': 'パネル出力の形式が不正です（パーサーが拒否）。',
  'critiqueTheater.degradedReasonOversize': 'パネル出力が安全なバイト予算を超えました。',
  'critiqueTheater.degradedReasonAdapter': 'アダプター {adapter} は批評プロトコルをサポートしていません。',
  'critiqueTheater.degradedReasonProtocol': 'アダプター {adapter} はサポート対象外のプロトコルバージョンを使用しています。',
  'critiqueTheater.degradedReasonMissingArtifact': '実行は完了しましたが最終成果物がありません。',
  'critiqueTheater.replay': 'リプレイ',
  'critiqueTheater.replaySpeed': 'リプレイ速度',
  'critiqueTheater.readOnly': '読み取り専用',
  'critiqueTheater.shippedSummary': 'ラウンド {round} で出荷 · 総合 {composite}',
  'critiqueTheater.interruptedSummary': 'ラウンド {round} で中断 · 最高総合 {composite}',
  'critiqueTheater.shippedBadge': '出荷済み',
  'critiqueTheater.belowThresholdBadge': 'しきい値未達',
  'critiqueTheater.timedOutBadge': 'タイムアウト',
  'critiqueTheater.failedHeading': '実行に失敗しました',
  'critiqueTheater.failedReasonCliExit': 'エージェント CLI がパネル完了前に異常終了しました。',
  'critiqueTheater.failedReasonPerRoundTimeout': 'いずれかのラウンドが時間予算を超過しました。',
  'critiqueTheater.failedReasonTotalTimeout': '実行全体が時間予算を超過しました。',
  'critiqueTheater.failedReasonOrchestrator': 'オーケストレーターの内部エラー。',
  'critiqueTheater.transcriptEmpty': '再生できるトランスクリプトがありません。批評を実行して記録してください。',
  'critiqueTheater.transcriptLoading': 'トランスクリプトを読み込み中…',
  'critiqueTheater.transcriptError': 'トランスクリプトを読み込めませんでした: {error}',
  'critiqueTheater.replaySpeedPaused': '一時停止',
  'critiqueTheater.replaySpeedInstant': '即時',
  'critiqueTheater.replaySpeedLive': 'ライブ',
  'critiqueTheater.replaySpeedFast': '高速',
  'critiqueTheater.settingsNav': 'デザイン陪審',
  'critiqueTheater.settingsNavHint': 'エージェント実行中の 5 名パネルレビュー',
  'critiqueTheater.settingsEnabledLabel': 'エージェント実行中にデザイン陪審を表示',
  'critiqueTheater.settingsEnabledDescription': '有効にすると、エージェント生成中に 5 名のパネルレビューが並走し、出荷前に結果を採点します。いつでも中断できます。',
  'critiqueTheater.settingsEnabledProjectHint': 'このプロジェクトに保存しました。今後の実行はサーバ側でデザイン陪審を通ります。',
  'critiqueTheater.settingsEnabledNoProjectHint': 'サーバ側に保存するにはプロジェクトを開いてください。それまではブラウザ内の設定のみ変更されます。',
  'pet.title': 'ペット',
  'pet.subtitle': 'ワークスペースに浮かぶ小さな相棒を迎えましょう。',
  'pet.navTitle': 'ペット',
  'pet.navHint': '迎える・カスタマイズ',
  'pet.tabBuiltIn': '組み込み',
  'pet.tabBuiltInHint': 'Open Design に同梱された厳選コンパニオン — 選んで迎え入れよう。',
  'pet.builtInEmpty': '組み込みペットを今は読み込めません。デーモンが復帰したらコミュニティタブを更新してください。',
  'pet.tabCustom': 'カスタム',
  'pet.tabCustomHint': '名前・絵文字・色・スプライトを自分で設定。',
  'pet.tabCommunity': 'コミュニティ',
  'pet.tabCommunityHint': 'Codex で孵ったペット — 養子に取るか AI で新しく作る。',
  'pet.tabsAria': 'ペットのソース',
  'pet.adopt': '迎える',
  'pet.adoptedBadge': '迎え済み',
  'pet.adoptCallout': 'ペットを迎える',
  'pet.changePet': 'ペットを変更',
  'pet.wake': '呼び出す',
  'pet.tuck': 'しまう',
  'pet.wakeTitle': 'ペットを呼び出す — 浮かぶオーバーレイを表示。',
  'pet.tuckTitle': 'ペットをしまう — オーバーレイを非表示。',
  'pet.settingsTitle': 'ペット設定を開く',
  'pet.useCustom': 'マイペットを使う',
  'pet.customTitle': '自分で作る',
  'pet.customHint': '名前、アイコン、アクセントカラーを選ぶと、オーバーレイが即時に更新されます。',
  'pet.customGreetingPlaceholder': 'ペットからのあいさつ…',
  'pet.fieldName': '名前',
  'pet.fieldGlyph': 'アイコン',
  'pet.fieldGlyphHint': '絵文字 1 つが最適です（例：🐝、🦄、🐢）。',
  'pet.fieldGreeting': 'あいさつ',
  'pet.fieldAccent': 'アクセントカラー',
  'pet.fieldAccentCustom': 'カスタムカラー',
  'pet.fieldAccentDefault': 'デフォルトのアクセントカラー',
  'pet.overlayAria': 'ペットの相棒',
  'pet.spriteAria': '{name} — ドラッグで移動、クリックで会話',
  'pet.spriteTitle': '{name} からこんにちは！クリックで会話。',
  'pet.taskSummarySingle': '{count} 件の Agent タスクを実行中です。',
  'pet.taskSummaryMultiple': '{projects} 個のプロジェクトで {count} 件の Agent タスクを実行中です。',
  'pet.taskSummaryRecentSingle': '{count} 件の Agent タスクが最近完了しました。',
  'pet.taskSummaryRecentMultiple': '{count} 件の Agent タスクが最近完了しました。',
  'pet.taskListAria': '実行中の Agent タスク',
  'pet.taskOpenProject': '{project} を開く',
  'pet.taskGroup.running': '実行中',
  'pet.taskGroup.queued': '待機中',
  'pet.taskGroup.recent': '最近完了',
  'pet.idleQuote.leonardo.text': '学ぶことに、心が尽きることはない。',
  'pet.idleQuote.leonardo.author': 'レオナルド・ダ・ヴィンチ',
  'pet.idleQuote.michelangelo.text': '私は大理石の中に天使を見出し、彼を解き放つまで彫り続けた。',
  'pet.idleQuote.michelangelo.author': 'ミケランジェロ',
  'pet.idleQuote.bernini.text': '彫刻家を助ける手段は二つある。光と影だ。',
  'pet.idleQuote.bernini.author': 'ジャン・ロレンツォ・ベルニーニ',
  'pet.idleQuote.raphael.text': '絵を描いているとき、人は何も考えていない。',
  'pet.idleQuote.raphael.author': 'ラファエロ',
  'pet.idleQuote.caravaggio.text': 'いかなる作品も、誰が描いたものであれ、生身の対象から作り描かれたものでなければ、取るに足らない児戯にすぎない。',
  'pet.idleQuote.caravaggio.author': 'カラヴァッジョ',
  'pet.idleQuote.rodin.text': '大切なのは、心を動かされること、愛すること、希望を抱くこと、震えること、生きることだ。',
  'pet.idleQuote.rodin.author': 'オーギュスト・ロダン',
  'pet.composerTitle': 'ペット — 呼び出す・しまう・選ぶ',
  'pet.composerMenuTitle': 'ペット',
  'pet.composerMenuHint': 'ヒント：/pet と入力で切替',
  'pet.composerOpenSettings': 'ペットを管理',
  'pet.welcomeTeaserTitle': 'ペットを迎える',
  'pet.welcomeTeaserBody': 'ワークスペースに浮かぶ小さな相棒です。',
  'pet.welcomeTeaserCta': '選ぶ',
  'pet.imageUpload': 'スプライトをアップロード',
  'pet.imageReplace': 'スプライトを差し替える',
  'pet.imageRemove': '絵文字に戻す',
  'pet.imageHintIdle': 'PNG / JPG / WebP / GIF / SVG に対応。スプライトシート？横長の帯をアップしてフレーム数を指定してください。',
  'pet.imageHintActive': 'アップしたスプライトを表示中。フレーム数を 1 より大きくすると横スプライトシートが動きます。',
  'pet.fieldFrames': 'フレーム数',
  'pet.fieldFramesHint': '1 = 静止。2 以上 = 横スプライトシート。',
  'pet.fieldFps': '速度 (fps)',
  'pet.fieldFpsHint': 'フレーム切替の速さ。',
  'pet.atlasImport': 'Codex スプライトを取り込む',
  'pet.atlasImportTitle': 'hatch-pet の 8x9 / 192x208 アトラス(PNG または WebP)を取り込みます。',
  'pet.atlasPickerTitle': 'アニメーション行を選択',
  'pet.atlasPickerHint': 'Codex ペットは 9 種類のアニメーション行を持っています。デフォルトはアトラス全体を保持し、ホバー・ドラッグ方向・長時間アイドルに応じて行が切り替わります。1 行だけにロックすることもできます。',
  'pet.atlasCancel': 'アトラスを破棄',
  'pet.atlasAdopt': 'この行に固定',
  'pet.atlasAdoptFull': 'アトラス全体を使う(アニメーション)',
  'pet.atlasAdoptFullTitle': 'すべての行を保持して、ホバー・ドラッグ方向・長時間アイドルに反応させます。',
  'pet.atlasAdoptRowTitle': 'ハイライト中の行だけをループするストリップに切り出します。',
  'pet.atlasActiveHint': 'アニメーションアトラス有効 — 操作(ホバー・ドラッグ・アイドル)に応じてペットが行を切り替えます。',
  'pet.atlasRow.idle': 'アイドル',
  'pet.atlasRow.running-right': '右に走る',
  'pet.atlasRow.running-left': '左に走る',
  'pet.atlasRow.waving': '手を振る',
  'pet.atlasRow.jumping': 'ジャンプ',
  'pet.atlasRow.failed': '失敗',
  'pet.atlasRow.waiting': '待機',
  'pet.atlasRow.running': '走る',
  'pet.atlasRow.review': 'レビュー',
  'pet.hatchTitle': 'AI で新しいペットを孵化',
  'pet.hatchHint': '同梱の hatch-pet スキルをチャットで実行して Codex 風のスプライトシートを生成し、ここから取り込んでください。',
  'pet.hatchConcept': 'ペットのコンセプト(任意)',
  'pet.hatchConceptPlaceholder': '例: セーターを着た小さなピクセル風の柴犬',
  'pet.hatchCopy': 'プロンプトをコピー',
  'pet.hatchCopied': 'コピー済み!',
  'pet.hatchFoot': 'スキルがペットを保存したら、ここに戻って「Codex スプライトを取り込む」を選んでください。',
  'pet.slashPopoverAria': 'スラッシュコマンド',
  'pet.slashPopoverTitle': 'コマンド',
  'pet.slashPopoverHint': '↑↓ で移動 · enter で選択 · esc で閉じる',
  'pet.slashPet': 'ペットを切替・採用、または設定を開く。',
  'pet.slashPetWake': '浮遊ペットを起こす。',
  'pet.slashPetTuck': 'ペットを一旦しまう。',
  'pet.slashHatch': 'hatch-pet スキルで Codex ペットを生成。',
  'pet.slashHatchArg': '<コンセプト>',
  'pet.slashSearch': 'OD research コマンドで Web 検索します。',
  'pet.slashSearchArg': '<検索クエリ>',
  'pet.codexTitle': '最近の孵化',
  'pet.codexSubtitle': 'hatch-pet スキルがパッケージしたペットがここに表示され、ワンクリックで採用できます。',
  'pet.codexSubtitleWithDir': '{dir} を hatch-pet スキルのパッケージのために走査中。',
  'pet.codexEmpty': '孵化したペットはまだありません。チャットで /hatch を入力して生成しましょう。',
  'pet.codexLoading': '孵化したペットを探しています…',
  'pet.codexRefresh': '更新',
  'pet.codexAdopt': '採用',
  'pet.codexAdopting': '採用中…',
  'pet.communitySync': 'コミュニティペットをダウンロード',
  'pet.communitySyncing': 'ダウンロード中…',
  'pet.communitySyncTitle': 'Codex Pet Share と j20 Hatchery の最新ペットを ~/.codex/pets/ に同期します。',
  'pet.communitySyncDone': '{wrote} 体の新しいペットを同期しました（合計 {total} 体）。',
  'pet.communitySyncFailed': '同期に失敗しました: {error}',
  'pet.codexBundled': '同梱',
  'pet.codexBundledTitle': 'Open Design に同梱 — ダウンロード不要。',
  'settings.notifications': '通知',
  'settings.notificationsHint': 'タスク完了時の効果音とデスクトップ通知',
  'settings.notifyCompletionSound': '完了サウンド',
  'settings.notifyCompletionSoundHint': '1ターン終了時に再生されます。既定ではオフです。',
  'settings.notifySuccessSound': '成功サウンド',
  'settings.notifyFailureSound': '失敗サウンド',
  'settings.notifyDesktop': 'デスクトップ通知',
  'settings.notifyDesktopHint': 'ウィンドウが非アクティブのときに送信されます。',
  'settings.notifyDesktopBlocked': 'ブラウザにブロックされています。サイト設定で許可してください。',
  'settings.notifyDesktopUnsupported': 'この環境ではデスクトップ通知に対応していません。',
  'settings.notifyTest': 'テスト送信',
  'settings.notifyTestSent': 'テスト通知を送信しました。バナーが出ない場合は、ブラウザとシステムの通知設定を確認してください。',
  'settings.notifyTestFailed': '通知の呼び出しに失敗しました。ブラウザとシステムの通知設定を確認してください。',
  'settings.notifySoundDing': 'ティン',
  'settings.notifySoundChime': 'チャイム',
  'settings.notifySoundTwoToneUp': '上昇2音',
  'settings.notifySoundPluck': 'プラック',
  'settings.notifySoundBuzz': 'ブザー',
  'settings.notifySoundTwoToneDown': '下降2音',
  'settings.notifySoundThud': 'ドスン',
  'settings.skills': 'スキル',
  'settings.skillsHint': 'エージェントがタスク中に呼び出せる機能スキル',
  'settings.skillsNew': '新規スキル',
  'settings.skillsEmpty': '左からスキルを選ぶか、新規作成してください。',
  'settings.skillsEdit': '編集',
  'settings.skillsDelete': '削除',
  'settings.skillsDeleteConfirm': '削除を確定',
  'settings.skillsName': '名前',
  'settings.skillsTriggers': 'トリガー（カンマ／改行区切り）',
  'settings.skillsDescription': '説明',
  'settings.skillsBody': 'SKILL.md 本文',
  'settings.skillsCreate': '作成',
  'settings.skillsSave': '保存',
  'settings.skillsSaving': '保存中…',
  'settings.skillsFiles': 'ファイル',
  'settings.skillsNoFiles': 'このスキルフォルダーにファイルはありません。',
  'settings.skillsNameRequired': 'スキル名は必須です。',
  'settings.skillsBodyRequired': 'スキルの内容は必須です。',
  'settings.designSystems': 'デザインシステム',
  'settings.designSystemsHint': 'エージェントが利用できるデザインシステムを管理',
  'settings.designSystemsInstalled': 'インストール済み',
  'settings.designSystemsAdd': 'デザインシステムを追加',
  'settings.designSystemsHiddenCount': '{count} 件をホームギャラリーから非表示',
  'settings.designSystemsShowAll': 'すべて表示',
  'settings.designSystemsShowHidden': '非表示を表示',
  'settings.designSystemsSource': 'ソース',
  'settings.designSystemsSourceLocal': 'ローカル',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn レジストリ参照',
  'settings.designSystemsImportShadcn': 'shadcn からインポート',
  'settings.designSystemsStructure': '構造',
  'settings.designSystemsModeHybrid': 'ハイブリッド',
  'settings.designSystemsModeNormalized': '正規化',
  'settings.designSystemsModeVerbatim': 'そのまま',
  'settings.designSystemsCraft': 'クラフト',
  'settings.designSystemsCraftColor': 'カラー',
  'settings.designSystemsCraftAccessibility': 'アクセシビリティ',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': 'プロジェクトパス',
  'settings.designSystemsImportGithub': 'GitHub からインポート',
  'settings.designSystemsImportProject': 'プロジェクトからインポート',
  'settings.designSystemsImportedStatus': '{title} をインポートしました',
  'settings.designSystemsViewImported': 'インポートしたデザインシステムを表示',
  'settings.designSystemsCategory': 'カテゴリー',
  'settings.designSystemsAllCategories': 'すべてのカテゴリー',
  'settings.designSystemsShowInHomeGallery': 'ホームギャラリーに表示',
  'settings.projectLocations': 'プロジェクトの場所',
  'settings.projectLocationsHint': 'ワークスペース保存ルート',
  'settings.projectLocationsDescription': '複数の Open Design プロジェクトフォルダを含められる作業ベースを追加します。新しいプロジェクトは選択したベース内の 1 つのフォルダとして保存されます。',
  'settings.projectLocationsSaveError': 'プロジェクトの場所を保存できませんでした。各パスがアクセス可能なフォルダであることを確認してください。',
  'settings.projectLocationsSaved': 'プロジェクトの場所を保存しました。',
  'settings.projectLocationsScanError': 'プロジェクトの場所をスキャンできませんでした。',
  'settings.projectLocationsScanComplete': 'スキャン完了: {imported} 件をインポート、{existing} 件は登録済みです。',
  'settings.projectLocationsNoFolderSelected': 'フォルダが選択されていません。',
  'settings.projectLocationsDuplicate': 'その作業ベースはすでに追加されています。',
  'settings.projectLocationsWorkBaseMeta': '作業ベース · プロジェクトはここにサブフォルダとして作成されます',
  'settings.projectLocationsAddFolder': 'フォルダを追加…',
  'settings.projectLocationsDefaultBadge': 'デフォルトの場所',
  'settings.projectLocationsMakeDefault': 'デフォルトにする',
  'settings.projectLocationsDefaultSaved': 'デフォルトのプロジェクト場所を更新しました。',
  'settings.librarySkills': 'スキル',
  'settings.libraryDesignSystems': 'デザインシステム',
  'settings.librarySearch': '検索...',
  'settings.libraryAll': 'すべて',
  'settings.libraryPreview': 'プレビュー',
  'settings.libraryPreviewClose': '閉じる',
  'settings.libraryLoading': '読み込み中...',
  'settings.libraryNoResults': '検索条件に一致する項目がありません。',
  'settings.libraryEnabled': '有効',
  'settings.libraryDisabled': '無効',
  'settings.connectorsNavHint': '外部システム接続',
  'settings.connectorsHint': 'このデバイスのコネクターとツールプロバイダー設定を管理します。',
  'settings.connectorsComposioApiKey': 'Composio API キー',
  'settings.connectorsSavedTitle': 'ローカル daemon に保存済み',
  'settings.connectorsSavedWithTail': '保存済み · ••••{tail}',
  'settings.connectorsSaved': '保存済み',
  'settings.connectorsGetApiKey': 'API キーを取得',
  'settings.connectorsReplaceKeyPlaceholder': '保存済みキーを置き換えるには新しいキーを貼り付け',
  'settings.connectorsApiKeyPlaceholder': 'Composio API キーを貼り付け',
  'settings.connectorsClear': 'クリア',
  'settings.connectorsClearConfirmTitle': '保存された Composio API キーを削除しますか？',
  'settings.connectorsClearConfirmBody': 'キーを削除すると、このワークスペースに紐づくすべての Composio コネクタが切断されます。接続中のアカウント、OAuth 認可、ツールへのアクセス権はすべて取り消されます。',
  'settings.connectorsClearConfirmContinue': '続行',
  'settings.connectorsClearFinalTitle': 'すべてのコネクタが切断されます',
  'settings.connectorsClearFinalBody': '元には戻せません。新しいキーを貼り付けたあと、各インテグレーションをイチから接続し直す必要があります。',
  'settings.connectorsClearFinalConfirm': 'キーを削除して切断',
  'settings.connectorsClearArming': '少々お待ちを…',
  'settings.connectorsClearCancel': 'キャンセル',
  'settings.connectorsSaveKey': 'キーを保存',
  'settings.connectorsSaveKeyTitle': 'このキーをローカルの daemon に送信',
  'settings.connectorsKeySaving': '保存中…',
  'settings.connectorsKeySaved': '保存完了 ✓',
  'settings.connectorsKeyError': 'キーを保存できませんでした。ローカルの daemon が起動しているか確認して、もう一度お試しください。',
  'settings.connectorsHelpSaved': 'キーは下のカタログを有効にし、ローカル daemon に保持されます。置き換えるには新しいキーを貼り付け、削除するにはクリアしてください。',
  'settings.connectorsHelpUnsaved': '未保存の変更があります — 「キーを保存」をクリックすると、この資格情報がローカル daemon に保存され、下のカタログが解除されます。',
  'settings.connectorsHelpEmpty': '下のカタログを有効にするにはキーを追加してください。キーは daemon にローカル保存され、環境変数経由で送信されることはありません。',
  'settings.connectorsLoadingSavedKey': 'ローカル daemon に保存されたキーを確認しています…',
  'settings.autosaveSaving': '保存中…',
  'settings.autosaveSaved': 'すべての変更を保存しました',
  'settings.autosaveError': '変更を保存できませんでした。ローカル daemon がオフラインの可能性があります。',
  'settings.libraryToggleLabel': '切り替え',
  'settings.memory': 'メモリ',
  'settings.memoryHint': 'チャットから自動抽出された個人情報',
  'settings.customInstructionsTitle': 'グローバルルール',
  'settings.customInstructionsHint': 'OpenDesignがすべてのチャットで従うべき固定の指示。事実、設定、プロジェクトのコンテキストをメモリとして保存します。',
  'settings.customInstructionsPlaceholder': '例:「常にTypeScriptを使用。関数コンポーネントを優先。回答は簡潔に。」',
  'settings.memoryDescription': 'あなたの好みや背景情報を自動的に抽出し、Markdown ファイルとして保存します。次回以降のチャットに自動で反映されます。',
  'settings.memoryEnabled': '有効',
  'settings.memoryDisabled': '無効',
  'settings.memoryEnableLabel': 'メモリの挿入を有効にする',
  'settings.memoryDisabledBanner': 'メモリは現在オフです。既存の事実はディスク上に残りますが、新しい会話には注入されず、新しい情報の抽出も行われません。',
  'settings.memoryNew': '新規メモリ',
  'settings.memoryEdit': '編集',
  'settings.memoryDelete': '削除',
  'settings.memoryPreview': 'プレビュー',
  'settings.memoryEmpty': 'まだメモリはありません。',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'ダークモードが好みです',
  'settings.memoryName': '名前',
  'settings.memoryDesc': '1 行の説明',
  'settings.memoryBody': 'メモリ本文（Markdown 対応）',
  'settings.memoryBodyHint': 'ルール本体を先に書き、Why と How to apply の 2 行を続けて。',
  'settings.memoryStartersLabel': '出発点が必要ですか？クリックしてフォームに入力:',
  'settings.memoryStarterUserName': '私の役割',
  'settings.memoryStarterUserDesc': '私はSaaSデザインツールに取り組むフロントエンドエンジニアです',
  'settings.memoryStarterUserBody': '- 役割: シニアフロントエンドエンジニア\n- スタック: React, TypeScript, Vite\n- 領域: デザイン / コラボレーションツール\n- タイムゾーン: GMT+8 (Asia/Shanghai)\n\n適用タイミング: あらゆるチャット — Webフロントエンドを軸に例示する。',
  'settings.memoryStarterFeedbackName': 'UIの好み',
  'settings.memoryStarterFeedbackDesc': 'ダークモード、大きな本文テキスト、低い情報密度',
  'settings.memoryStarterFeedbackBody': '- テーマ: デフォルトはダーク\n- 本文テキスト: 18px以上\n- 情報密度: 余白を優先し、画面あたりの項目を少なく\n\n理由: 長時間の作業中の目の疲れを軽減するため。\n適用タイミング: UI、Webページ、スライドを生成するとき。',
  'settings.memoryStarterProjectName': '現在のプロジェクト',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — チャット駆動のデザインエディター',
  'settings.memoryStarterProjectBody': '- 目標: 今四半期にチャット駆動エディターをリリースする\n- 優先事項: ストリーミングレンダリング、ローカルマルチモーダル、オフラインファースト\n- スタック: Next.js 16、Express デーモン、SQLite\n\n適用するタイミング: このプロジェクトに関するあらゆる会話で。',
  'settings.memorySaveHint': '自動保存されません — 適用するには「作成」/「保存」をクリックしてください。',
  'settings.memoryIndexSaveHint': 'インデックスへの編集は自動保存されません — 適用するには「インデックスを保存」をクリックしてください。',
  'settings.memoryIndexUnsaved': '未保存の変更',
  'settings.memoryFlashCreated': '✓ メモリを作成しました',
  'settings.memoryFlashSaved': '✓ メモリを保存しました',
  'settings.memoryFlashDeleted': '✓ メモリを削除しました',
  'settings.memoryFlashIndexSaved': '✓ インデックスを保存しました',
  'settings.memoryFlashPathCopied': '✓ パスをコピーしました',
  'settings.memoryNameLabel': 'タイトル',
  'settings.memoryTypeLabel': 'タイプ',
  'settings.memoryDescLabel': '説明',
  'settings.memoryBodyLabel': '内容',
  'settings.memoryTypeUser': 'ユーザー',
  'settings.memoryTypeFeedback': 'フィードバック',
  'settings.memoryTypeProject': 'プロジェクト',
  'settings.memoryTypeReference': '参照',
  'settings.memoryIndex': 'MEMORY.md（索引）',
  'settings.memoryIndexSave': '索引を保存',
  'settings.memoryIndexReset': 'リセット',
  'settings.memoryToastChanged': 'メモリを更新しました',
  'settings.memoryToastClickHint': '表示',
  'settings.memoryAll': 'すべて',
  'settings.memoryExtractions': '抽出履歴',
  'settings.memoryExtractionsHint': '正規表現が最初に実行され、LLM はバックグラウンドで実行されます。',
  'settings.memoryExtractionsEmpty': 'まだ抽出はありません。次のチャットのやり取りでこのリストに反映されます。',
  'settings.memoryExtractionsRefresh': '更新',
  'settings.memoryExtractionsRefreshing': '更新中…',
  'settings.memoryExtractionPhaseRunning': '実行中…',
  'settings.memoryExtractionPhaseSuccess': '成功',
  'settings.memoryExtractionPhaseSkipped': 'スキップ',
  'settings.memoryExtractionPhaseFailed': '失敗',
  'settings.memoryExtractionSkipNoProvider': 'LLM メモリ抽出用の API key が設定されていません。',
  'settings.memoryExtractionSkipDisabled': 'メモリは無効になっています。',
  'settings.memoryExtractionSkipEmpty': 'ユーザーメッセージが空です — 抽出する内容がありません。',
  'settings.memoryExtractionSkipNoMatch': 'このやり取りに一致する正規表現パターンはありませんでした。',
  'settings.memoryExtractionKindHeuristic': '正規表現',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'メディア設定',
  'settings.memoryExtractionProviderOverride': 'メモリ設定',
  'settings.memoryExtractionProposed': '提案済み',
  'settings.memoryExtractionWritten': '書き込み済み',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': '削除',
  'settings.memoryExtractionsClear': 'クリア',
  'settings.memoryExtractionsClearTitle': 'すべての抽出履歴をクリア',
  'settings.memoryExtractionsClearConfirm': 'すべての抽出履歴をクリアしますか？この操作は元に戻せません。',
  'settings.memoryNoProviderBannerTitle': 'LLM メモリ抽出が実行されていません',
  'settings.memoryNoProviderBannerBody': 'メモリ抽出用の API key が見つかりません。LLM 駆動の抽出を有効にするには、メディアプロバイダーで OpenAI key を追加するか、環境変数に ANTHROPIC_API_KEY / OPENAI_API_KEY を設定してください。ヒューリスティックな正規表現抽出は引き続き有効です。',
  'settings.libraryInstall': 'インストール',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'ローカルパス',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'インストール',
  'settings.libraryUninstall': 'アンインストール',
  'settings.libraryBuiltIn': '内蔵',
  'settings.libraryInstalled': 'インストール済み',
  'notify.successTitle': 'タスクが完了しました',
  'notify.failureTitle': 'タスクが失敗しました',
  'notify.successBody': '1ターンが終了しました。',
  'notify.failureBody': 'タスクはエラーで終了しました。',
  'updater.available': 'アップデートがあります',
  'updater.availableBody': 'Open Design {version} を利用できます。インストーラーを開く前にダウンロードします。',
  'updater.checking': 'アップデートを確認中',
  'updater.download': 'アップデートをダウンロード',
  'updater.downloading': 'アップデートをダウンロード中',
  'updater.downloadingPercent': 'アップデートをダウンロード中 {percent}%',
  'updater.done': '完了',
  'updater.failed': 'アップデートに失敗しました',
  'updater.installerOpenBody': 'インストーラーが開いています。更新を完了できるよう Open Design を終了しています。',
  'updater.installerOpened': 'インストーラーを開きました',
  'updater.later': '後で',
  'updater.openFailedFallback': 'インストーラーを開けませんでした。',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': '更新をインストール',
  'updater.opening': 'インストーラーを開いています...',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'Open Design を終了',
  'updater.quitFailedBody': 'インストーラーは開いていますが、Open Design を終了できませんでした。アプリを置き換える前に Open Design を終了してください。',
  'updater.quitFailedTitle': '終了できませんでした',
  'updater.quitting': '終了しています...',
  'updater.ready': 'アップデート準備完了',
  'updater.readyGeneric': '新しいバージョンの準備ができました。Open Design を閉じてインストーラーを開きます。',
  'updater.readyVersion': 'Open Design {version} の準備ができました。Open Design を閉じてインストーラーを開きます。',
  'updater.upToDate': 'すでに最新バージョンです。',
  'newsletter.label': 'ニュースレター（任意）',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': '自動化',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': '日次コネクターサマリー',
  'settings.orbit.lede': 'コネクターのアクティビティをスケジュールで収集し、結果を更新可能な live artifact として公開します。',
  'settings.orbit.statusOnTitle': '毎日のスケジュール実行はオンです',
  'settings.orbit.statusOffTitle': '毎日のスケジュール実行はオフです',
  'settings.orbit.statusActive': '有効',
  'settings.orbit.statusOff': 'オフ',
  'settings.orbit.runTitle': 'Orbit 実行を開始してライブ会話を開く',
  'settings.orbit.running': '実行中…',
  'settings.orbit.runOpen': '今すぐ実行',
  'settings.orbit.dailySummaryTitle': '日次サマリー',
  'settings.orbit.dailySummarySub': 'スケジュールされたローカル時刻に 1 日 1 回実行します。',
  'settings.orbit.on': 'オン',
  'settings.orbit.off': 'オフ',
  'settings.orbit.runTimeTitle': '実行時刻',
  'settings.orbit.runTimeSub': '既定は 08:00。保存すると daemon のスケジュールに適用されます。',
  'settings.orbit.runTimeAria': '毎日の Orbit 実行時刻',
  'settings.orbit.nextRun': '次の実行',
  'settings.orbit.nextRunScheduledAfterSave': '保存後にスケジュール',
  'settings.orbit.schedule': 'スケジュール',
  'settings.orbit.pausedManualOnly': '一時停止 — 手動実行のみ',
  'settings.orbit.templateTitle': 'プロンプトテンプレート',
  'settings.orbit.templateMissing': 'テンプレート {id} はインストールされていません。',
  'settings.orbit.templateMissingOption': '{id}（不足）',
  'settings.orbit.templateMissingInstall': 'プロンプトを制御するには Orbit skill をインストールしてください。',
  'settings.orbit.templateMissingPickAnother': 'ドロップダウンから別のテンプレートを選択してください。',
  'settings.orbit.templateResetTitle': '{id} にリセット',
  'settings.orbit.templateReset': 'リセット',
  'settings.orbit.templateHelp': 'skill で Orbit を制御します — 選択したテンプレートのサンプルプロンプトが各 Orbit 実行に挿入され、サマリーがそのテンプレートの形に従います。',
  'settings.orbit.templateAria': 'Orbit プロンプトテンプレート',
  'settings.orbit.templatesLoading': 'テンプレートを読み込み中…',
  'settings.orbit.templatesOptgroup': 'Orbit skill テンプレート',
  'settings.orbit.lastRun': '前回の実行',
  'settings.orbit.triggerManual': '手動',
  'settings.orbit.triggerScheduled': 'スケジュール済み',
  'settings.orbit.meterAria': 'チェック {checked} 件中、成功 {succeeded} 件、スキップ {skipped} 件、失敗 {failed} 件',
  'settings.orbit.countChecked': 'チェック済み',
  'settings.orbit.countSucceeded': '成功',
  'settings.orbit.countSkipped': 'スキップ',
  'settings.orbit.countFailed': '失敗',
  'settings.orbit.runError': 'Orbit を実行できませんでした。ローカル daemon が実行中で、コネクターが設定されていることを確認してください。',
  'settings.orbit.gateAriaLabel': 'Orbit を使うにはコネクタが必要です',
  'settings.orbit.gateEyebrow': 'セットアップが必要',
  'settings.orbit.gateTitle': 'ツールを接続して Orbit を動かしましょう',
  'settings.orbit.gateBody': 'Orbit はコネクタの活動を要約します。まだ何も接続されていません — 少なくとも 1 つの連携を追加すると、Orbit が報告できるようになります。',
  'settings.orbit.gateBodyNoKey': 'Orbit はコネクタの活動を要約し、コネクタは Composio を通して動作します。コネクタ画面で Composio API キーを追加すると、カタログが解放され最初の連携を選べます。',
  'settings.orbit.gateAction': 'コネクタを開く',
  'settings.orbit.gateActionNoKey': 'Composio を設定',
  'settings.orbit.gateLoading': 'コネクタを確認中…',
  'settings.orbit.controlsLockedBadge': 'ロック中',
  'settings.orbit.controlsLockedHint': 'ツールを接続すると、Orbit のスケジュールとテンプレート設定が有効になります。',
  'settings.orbit.artifactKickerLive': 'ライブアーティファクト',
  'settings.orbit.artifactKickerLegacy': 'レガシーサマリー',
  'settings.orbit.artifactTitle': '日次 Orbit アクティビティサマリー',
  'settings.orbit.artifactMetaLive': 'コネクターアクティビティから生成された更新可能な HTML artifact。',
  'settings.orbit.artifactMetaLegacy': 'live artifact サポートが有効になる前に生成されました — 公開するには Orbit をもう一度実行してください。',
  'settings.orbit.copyMarkdownTitle': 'Markdown サマリーをクリップボードにコピー',
  'settings.orbit.copied': 'コピー済み',
  'settings.orbit.copy': 'コピー',
  'settings.orbit.openArtifact': 'artifact を開く',
  'settings.orbit.sourceMarkdown': 'ソース Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'メモリはチャットとは別のモデルを使用します。デフォルトはチャットモデルです。',
  'diagnostics.exportTitle': '診断情報をエクスポート',
  'diagnostics.exportButton': '診断情報をエクスポート',
  'diagnostics.exportHint': '最近のアプリログとマシン情報を zip にまとめて、チームに共有できるようにします。',
  'diagnostics.exporting': 'エクスポート中…',
  'diagnostics.exportSuccess': '診断情報を {path} に保存しました',
  'diagnostics.exportFailed': '診断情報のエクスポートに失敗しました: {message}',
  'automations.eyebrow': 'スケジュール実行のエージェントセッション',
  'automations.title': 'オートメーション',
  'automations.lede': 'プロジェクト作業・Orbit ダイジェスト・ライブアーティファクトの定期会話を計画します。',
  'automations.summaryAria': 'オートメーションの概要',
  'automations.metricActive': '有効',
  'automations.metricPaused': '一時停止',
  'automations.metricTemplates': 'テンプレート',
  'automations.newAutomation': 'オートメーションを作成',
  'automations.yourAutomations': 'あなたのオートメーション',
  'automations.loading': '読み込み中',
  'automations.emptyTitle': 'オートメーションはまだありません',
  'automations.emptyBody': 'テンプレートから作成するか、空のスケジュールから始めましょう。',
  'automations.targetNewEachRun': '実行ごとに新規プロジェクト',
  'automations.lastRun': '前回の実行 {time}',
  'automations.openResult': '結果を開く',
  'automations.run': '実行',
  'automations.runNowTitle': '今すぐ実行して会話を開く',
  'automations.history': '履歴',
  'automations.hideHistory': '履歴を隠す',
  'automations.edit': '編集',
  'automations.pause': '一時停止',
  'automations.resume': '再開',
  'automations.deleteAria': 'オートメーションを削除',
  'automations.deleteTitle': 'このオートメーションを削除',
  'automations.deleteConfirm': 'このオートメーションを削除しますか？過去の実行とそのプロジェクトは保持されます。',
  'automations.proposalsTitle': '進化の提案',
  'automations.proposalsSub': 'メモリ・スキル・デザインシステムを変更する前に、オートメーションの出力を確認します。',
  'automations.proposalsPending': '{n} 件保留中',
  'automations.apply': '適用',
  'automations.reject': '却下',
  'automations.proposalsDismissReason': 'オートメーションで却下しました',
  'automations.templatesTitle': 'テンプレート',
  'automations.templatesSub': 'Orbit とライブアーティファクトは、同じオートメーションフロー内のテンプレートです。',
  'automations.templatesCount': '{total} 件中 {filtered} 件',
  'automations.templateFiltersAria': 'テンプレートのフィルター',
  'automations.templatesEmptyTitle': 'このカテゴリにはまだテンプレートがありません。',
  'automations.templatesEmptyBody': '別のフィルターを試すか、空のオートメーションから始めましょう。',
  'automations.useTemplate': 'テンプレートを使う',
  'automations.runHistoryLoading': '実行履歴を読み込み中…',
  'automations.runHistoryEmpty': 'まだ実行はありません。',
  'automations.runHistoryTitle': '実行履歴',
  'automations.runHistoryLatest': '最新 10 件',
  'automations.crystallize': '結晶化',
  'automations.crystallizing': '結晶化中',
  'automations.crystallizeTitle': 'この実行からスキルとメモリの提案を作成',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': '会話を開く',
  'automations.runHistoryAria': 'オートメーションの実行履歴',
  'automations.proposalsAria': 'オートメーションの進化提案',
  'automations.templatesAria': 'オートメーションのテンプレート',
  'automations.runInProgress': '進行中',
  'automations.scheduleStatusPaused': '一時停止',
  'automations.nextRunManualOnly': '手動のみ',
  'automations.nextRunScheduled': 'スケジュール済み',
  'automations.nextRunAt': '次回 {time}',
  'automations.statusSucceeded': '成功',
  'automations.statusFailed': '失敗',
  'automations.statusRunning': '実行中',
  'automations.statusQueued': 'キュー待ち',
  'automations.statusCanceled': 'キャンセル済み',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'ライブアーティファクト',
  'automations.kindAutomation': 'オートメーション',
  'automations.proposalTargetMemory': 'メモリ',
  'automations.proposalTargetDesignSystem': 'デザインシステム',
  'automations.proposalTargetSkill': 'スキル',
  'automations.proposalTargetTemplate': 'オートメーションテンプレート',
  'automations.proposalActionCreate': '作成',
  'automations.proposalActionUpdate': '更新',
  'automations.proposalActionMerge': 'マージ',
  'automations.proposalActionMove': '移動',
  'automations.proposalActionDelete': '削除',
  'automations.proposalActionPromote': '昇格',
  'automations.filterAll': 'すべて',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'ライブアーティファクト',
  'automations.filterMemory': 'メモリ',
  'automations.filterDesignSystems': 'デザインシステム',
  'automations.filterSkills': 'スキル',
  'automations.filterConnectors': 'コネクター',
  'automations.filterCompression': '圧縮',
  'automations.filterRelease': 'リリース',
  'automations.filterQuality': '品質',
  'automations.tpl.memoryRefresh.title': '最近の作業からプロジェクトメモリを更新します。',
  'automations.tpl.memoryRefresh.desc': '繰り返される決定・好み・フィードバックを、再利用可能なメモリ更新に変えます。',
  'automations.tpl.designSystemRefresh.title': '出荷済みのアーティファクトからデザインシステムを更新します。',
  'automations.tpl.designSystemRefresh.desc': '最近のデザイン作業から再利用可能な Token・コンポーネント・ルールを見つけます。',
  'automations.tpl.liveArtifactRegistry.title': 'ライブアーティファクトを点検し、古いバージョンを更新します。',
  'automations.tpl.liveArtifactRegistry.desc': '永続的なダッシュボード・レポート・プレビューを複製せず最新に保ちます。',
  'automations.tpl.orbitDashboard.title': 'コネクターのアクティビティダッシュボードを作成します。',
  'automations.tpl.orbitDashboard.desc': '選択したコネクターを Orbit スタイルのライブダッシュボードに集約します。',
  'automations.tpl.releaseNotes.title': '出荷済みのデザイン作業からリリースノートを作成します。',
  'automations.tpl.releaseNotes.desc': 'マージ済みの PR・アーティファクト・プロダクト向けの変更をリリースノートにまとめます。',
  'automations.tpl.qualityRegressionWatch.title': 'デザインと実装のリグレッションを監視します。',
  'automations.tpl.qualityRegressionWatch.desc': '最近の変更をベンチマーク・トレース・承認済みの参照と比較します。',
  'automations.tpl.orbitDaily.title': 'コネクターの日次ダイジェスト。',
  'automations.tpl.orbitDaily.desc': 'コネクターのアクティビティダイジェストをスケジュールで更新します。',
  'automations.tpl.liveStatusBoard.title': 'ライブのステータスアーティファクトを最新に保ちます。',
  'automations.tpl.liveStatusBoard.desc': '実行ごとに新しいレポートを作らず、ひとつの永続アーティファクトを更新します。',
  'dsManager.areaAria': 'デザインシステム領域',
  'dsManager.tabDesignSystem': 'デザインシステム',
  'dsManager.tabTemplate': 'テンプレート',
  'dsManager.sourceAria': 'デザインシステムのソース',
  'dsManager.templateSourceAria': 'テンプレートのソース',
  'dsManager.yourSystems': 'あなたのシステム',
  'dsManager.officialPresets': '公式プリセット',
  'dsManager.enterprise': 'エンタープライズ',
  'dsManager.yourTemplates': 'あなたのテンプレート',
  'dsManager.yourSystemsAria': 'あなたのデザインシステム',
  'dsManager.eyebrowDesignSystems': 'デザインシステム',
  'dsManager.yourSystemsHeading': 'あなたのシステム',
  'dsManager.filterAria': 'デザインシステムを絞り込む',
  'dsManager.filterAll': 'すべて',
  'dsManager.filterPublished': '公開済み',
  'dsManager.filterDraft': '下書き',
  'dsManager.createTitle': '新しいデザインシステムを作成',
  'dsManager.createBody': 'ブランド・プロダクト・コード・アセット・デザインの参考資料を Open Design に学習させます。',
  'dsManager.createAction': '作成',
  'dsManager.emptyMine': 'デザインシステムはまだありません。実際のプロダクトのコンテキストから作成し、下書きを確認してから今後のプロジェクト向けに公開します。',
  'dsManager.badgeDefault': 'デフォルト',
  'dsManager.rowMetaUpdated': 'あなた · 更新 {date}',
  'dsManager.edit': '編集',
  'dsManager.makeDefault': 'デフォルトに設定',
  'dsManager.statusPublished': '公開済み',
  'dsManager.statusDraft': '下書き',
  'dsManager.openSystemAria': '{title} を開く',
  'dsManager.deleteSystemAria': '{title} を削除',
  'dsManager.presetsAria': '公式デザインシステムのプリセット',
  'dsManager.eyebrowLibrary': 'ライブラリ',
  'dsManager.eyebrowTemplates': 'テンプレート',
  'dsManager.yourTemplatesAria': 'あなたのテンプレート',
  'dsManager.emptyTemplates': 'テンプレートはまだありません。テンプレート公開が有効になると、生成済みのプロジェクトから「共有」で作成できます。',
  'dsManager.templateDescFallback': 'プロジェクトから作成',
  'dsManager.comingSoonBadge': '近日公開',
  'dsManager.enterpriseDsTitle': 'エンタープライズデザインシステム',
  'dsManager.enterpriseDsBody': 'チームで共有するデザインシステムと、ガバナンス付きのブランドライブラリは近日公開です。',
  'dsManager.enterpriseTplTitle': 'エンタープライズテンプレート',
  'dsManager.enterpriseTplBody': 'チーム承認のテンプレートと組織全体への公開は近日公開です。',
  'settings.instructionsTitle': '指示 / ルール',
  'settings.instructionsSubtitle': 'アシスタントが常に従う固定の振る舞い',
  'settings.instructionsNavSub': '固定のアシスタント挙動',
  'settings.customInstructionsDesc': 'Open Design がすべてのチャットで従う固定の指示です。これらは保存されたメモリではありません。事実・好み・プロジェクトのコンテキストには「メモリ」を使用してください。',
  'mcpClient.forwardedToLabel': '転送先：',
  'mcpClient.notForwardedToLabel': '転送されない先：',
  'mcpClient.forwardedAcpNote': 'stdio only と表示された ACP アダプターは、このリストから stdio タイプの MCP サーバーのみを受け取ります。HTTP と SSE のエントリは起動時に破棄されます。',
  'mcpClient.notForwardedNote': 'これらのエージェントについては、各エージェント自身の設定ファイル（例：~/.codex/config.toml、~/.gemini/settings.json）で MCP サーバーを設定してください。以下のサーバーはそこでは使用されません。',
};
